import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from 'state/graphql/hooks/use-sanity-query';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  DateTime: any,
  JSON: any,
  Date: any,
}

export interface IAccordionEntry {
  readonly __typename?: 'AccordionEntry',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly collapsedContent: Maybe<ILocaleString>,
  readonly expandedContent: Maybe<ILocaleString>,
}

export interface IAccordionWidget {
  readonly __typename?: 'AccordionWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly accordionContent: Maybe<ReadonlyArray<Maybe<IAccordionEntry>>>,
  readonly accordionTitle: Maybe<ILocaleString>,
}

export type IAccordionWidgetOrAnchorLinksWidgetOrAnchorWidgetOrCallToActionWidgetOrDoubleImageWidgetOrHeaderWidgetOrImageWidgetOrLocaleBlockTextWidgetOrMultiWidgetOrNutritionExplorerWidgetOrNutritionInfoWidgetOrPreviewWidgetOrQuoteWidgetOrVideoWidgetOrYoutubeWidget = IAccordionWidget | IAnchorLinksWidget | IAnchorWidget | ICallToActionWidget | IDoubleImageWidget | IHeaderWidget | IImageWidget | ILocaleBlockTextWidget | IMultiWidget | INutritionExplorerWidget | INutritionInfoWidget | IPreviewWidget | IQuoteWidget | IVideoWidget | IYoutubeWidget;

export interface IAddress {
  readonly __typename?: 'Address',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly address1: Maybe<Scalars['String']>,
  readonly address2: Maybe<Scalars['String']>,
  readonly city: Maybe<Scalars['String']>,
  readonly country: Maybe<Scalars['String']>,
  readonly postalCode: Maybe<Scalars['String']>,
  readonly stateProvince: Maybe<Scalars['String']>,
  readonly stateProvinceShort: Maybe<Scalars['String']>,
}

export interface IAlert  extends IDocument {
  readonly __typename?: 'Alert',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly body: Maybe<ILocaleString>,
  readonly heading: Maybe<ILocaleString>,
  readonly learnMoreText: Maybe<ILocaleString>,
  readonly learnMoreUrl: Maybe<ILocaleString>,
}

export interface IAlertFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export type IAlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrLockedOffersOrMainHeroOrMarketingTileGroupOrOffersSectionOrOurServicesOrRecentItemsOrRollUpTheRimSectionOrScanForRewardsOrTrending = IAlert | IAppDownload | IBrazeContentCards | IFanFavorites | ILockedOffers | IMainHero | IMarketingTileGroup | IOffersSection | IOurServices | IRecentItems | IRollUpTheRimSection | IScanForRewards | ITrending;

export interface IAllowRedemptionWithoutLogin {
  readonly __typename?: 'AllowRedemptionWithoutLogin',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly allowRedemptionWithoutLogin: Maybe<Scalars['String']>,
}

export type IAllowRedemptionWithoutLoginOrAndOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrOrOrOrderHistoryOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions = IAllowRedemptionWithoutLogin | IAnd | IBetweenDates | IBetweenTimes | ICartContainsPlu | ICartProperty | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | ILimit | IOr | IOrderHistory | IPaymentCardType | IPurchase | IRequiresAssignment | IRestaurantGroupRestrictions;

export type IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions = IAllowRedemptionWithoutLogin | IBetweenDates | IBetweenTimes | ICartContainsPlu | ICartProperty | ICoolDown | IDayOfWeekBand | IFirstOrderOnly | ILimit | IPaymentCardType | IPurchase | IRequiresAssignment | IRestaurantGroupRestrictions;

export interface IAnchorLinksWidget {
  readonly __typename?: 'AnchorLinksWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface IAnchorWidget {
  readonly __typename?: 'AnchorWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly anchorName: Maybe<ILocaleString>,
}

export interface IAnd {
  readonly __typename?: 'And',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly ruleSet: Maybe<ReadonlyArray<Maybe<IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions>>>,
}

export type IAndOrBetweenTimesOrCartContainsPluOrCartPropertyOrDayOfWeekBandOrOrOrPaymentCardTypeOrPurchase = IAnd | IBetweenTimes | ICartContainsPlu | ICartProperty | IDayOfWeekBand | IOr | IPaymentCardType | IPurchase;

export interface IAppData  extends IDocument {
  readonly __typename?: 'AppData',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly aboutMenuEntries: Maybe<INavigationSection>,
  readonly appDownloadSection: Maybe<IAppDownloadSection>,
  readonly appHeaderText: Maybe<Scalars['String']>,
  readonly appImage: Maybe<IImage>,
  readonly appImageLocale: Maybe<ILocaleImage>,
  readonly appVersion: Maybe<IAppVersion>,
  readonly appleWalletImage: Maybe<ILocaleImage>,
  readonly calorieDisclaimer: Maybe<ILocaleBlockContent>,
  readonly cateringMenu: Maybe<IMenu>,
  readonly cateringSection: Maybe<ISection>,
  readonly communicationPreferencesDisclaimer: Maybe<ILocaleString>,
  readonly communicationPreferencesDisclaimerBlock: Maybe<ILocaleBlockContent>,
  readonly contentCardsHeader: Maybe<ILocaleString>,
  readonly contentCardsSubheader: Maybe<ILocaleString>,
  readonly copyrightAndTrademarkDisclaimer: Maybe<ILocaleString>,
  readonly countryDisclaimer: Maybe<ILocaleString>,
  readonly dayParts: Maybe<ReadonlyArray<Maybe<IDayPart>>>,
  readonly defaultHeroImage: Maybe<IImage>,
  readonly defaultHeroImageLocale: Maybe<ILocaleImage>,
  readonly defaultMenu: Maybe<IMenu>,
  readonly emailAndPushOptInSettings: Maybe<ReadonlyArray<Maybe<IOptInSettingBooleanOrOptInSettingEmailAndPushOrOptInSettingEnum>>>,
  readonly fanFavoriteItems: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferOrPickerOrSection>>>,
  readonly favoriteSection: Maybe<IFavoriteSection>,
  readonly geolocationModalImage: Maybe<IImage>,
  readonly geolocationModalImageUseLocale: Maybe<ILocaleImage>,
  readonly giftCardImage: Maybe<ILocaleImage>,
  readonly giftCardTextImage: Maybe<ILocaleImage>,
  readonly googlePayImage: Maybe<ILocaleImage>,
  readonly headerText: Maybe<Scalars['String']>,
  readonly heroAction: Maybe<ILinkAction>,
  readonly heroActionAuthenticated: Maybe<ILinkAction>,
  readonly heroActionLeft: Maybe<ILinkAction>,
  readonly heroActionLeftIcon: Maybe<ILocaleImage>,
  readonly heroActionRight: Maybe<ILinkAction>,
  readonly heroActionRightIcon: Maybe<ILocaleImage>,
  readonly heroMaskCards: Maybe<ReadonlyArray<Maybe<ISimpleCard>>>,
  readonly heroSubText: Maybe<ILocaleString>,
  readonly heroSubTextAuthenticated: Maybe<ILocaleString>,
  readonly heroSuperText: Maybe<ILocaleString>,
  readonly heroSuperTextAuthenticated: Maybe<ILocaleString>,
  readonly heroText: Maybe<Scalars['String']>,
  readonly heroTextAuthenticated: Maybe<Scalars['String']>,
  readonly heroTextAuthenticatedLocale: Maybe<ILocaleString>,
  readonly heroTextColor: Maybe<Scalars['String']>,
  readonly heroTextLocale: Maybe<ILocaleString>,
  readonly homeGraphic: Maybe<IHomeGraphic>,
  readonly imagesDisclaimer: Maybe<ILocaleString>,
  readonly kioskAppData: Maybe<IKioskAppData>,
  readonly kioskAttractLoopImage: Maybe<IImage>,
  readonly kioskAttractLoopImageLocale: Maybe<ILocaleImage>,
  readonly loadingGraphics: Maybe<ILoadingGraphics>,
  readonly loyaltyCardImage: Maybe<ILocaleImage>,
  readonly loyaltyHeaderBackgroundImage: Maybe<IImage>,
  readonly loyaltyHeroAction: Maybe<ILinkAction>,
  readonly loyaltyHeroSubText: Maybe<ILocaleString>,
  readonly loyaltyHeroSuperText: Maybe<ILocaleString>,
  readonly loyaltyInfoImage: Maybe<ILocaleImage>,
  readonly mainHeroImage: Maybe<IImage>,
  readonly mainHeroImageAuthenticated: Maybe<IImage>,
  readonly mainHeroImageAuthenticatedLocale: Maybe<ILocaleImage>,
  readonly mainHeroImageLocale: Maybe<ILocaleImage>,
  readonly mainHeroMobileImage: Maybe<IImage>,
  readonly mainHeroMobileImageLocale: Maybe<ILocaleImage>,
  readonly menuHeroImage: Maybe<IImage>,
  readonly menuHeroImageLocale: Maybe<ILocaleImage>,
  readonly menuHeroText: Maybe<Scalars['String']>,
  readonly menuHeroTextLocale: Maybe<ILocaleString>,
  readonly offersDisclaimer: Maybe<ILocaleString>,
  readonly ourAppHeroImage: Maybe<IImage>,
  readonly ourAppHeroImageLocale: Maybe<ILocaleImage>,
  readonly ourServicesHeroImage: Maybe<IImage>,
  readonly ourServicesHeroImageLocale: Maybe<ILocaleImage>,
  readonly phoneNumberDisclaimer: Maybe<ILocaleString>,
  readonly priceDisclaimer: Maybe<ILocaleString>,
  readonly promotions: Maybe<ReadonlyArray<Maybe<IComboOrExternalLinkOrItemOrOfferOrPickerOrSection>>>,
  readonly recentOrderHeroText: Maybe<Scalars['String']>,
  readonly recentOrderHeroTextLocale: Maybe<ILocaleString>,
  readonly reservedRightsDisclaimer: Maybe<ILocaleString>,
  readonly rewardsMainImage: Maybe<IImage>,
  readonly rewardsMainImageLocale: Maybe<ILocaleImage>,
  readonly servicesHeaderText: Maybe<Scalars['String']>,
  readonly servicesHeaderTextLocale: Maybe<ILocaleString>,
  readonly servicesHeroText: Maybe<Scalars['String']>,
  readonly servicesHeroTextLocale: Maybe<ILocaleString>,
  readonly siteAlert: Maybe<IAlert>,
  readonly sodiumDisclaimer: Maybe<ILocaleBlockContent>,
  readonly sortedOffers: Maybe<ReadonlyArray<Maybe<IOffer>>>,
  readonly storeLocatorContent: Maybe<IStoreLocatorContent>,
  readonly superUpsellDisclaimer: Maybe<ILocaleBlockContent>,
  readonly upsellItemAtCheckout: Maybe<IItem>,
  readonly upsellItemsAtCheckout: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly upsellItemsAtCheckoutCatering: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly upsellItemsAtCheckoutDelivery: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly upsellItemsAtCheckoutRestaurant: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly useSideBySideHeroButtons: Maybe<Scalars['Boolean']>,
}

export interface IAppDataFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly appHeaderText?: Maybe<Scalars['String']>,
  readonly appHeaderText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly appHeaderText_matches?: Maybe<Scalars['String']>,
  readonly appHeaderText_not?: Maybe<Scalars['String']>,
  readonly appHeaderText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly appVersion?: Maybe<Scalars['ID']>,
  readonly cateringMenu?: Maybe<Scalars['ID']>,
  readonly cateringSection?: Maybe<Scalars['ID']>,
  readonly defaultMenu?: Maybe<Scalars['ID']>,
  readonly headerText?: Maybe<Scalars['String']>,
  readonly headerText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly headerText_matches?: Maybe<Scalars['String']>,
  readonly headerText_not?: Maybe<Scalars['String']>,
  readonly headerText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroText?: Maybe<Scalars['String']>,
  readonly heroTextAuthenticated?: Maybe<Scalars['String']>,
  readonly heroTextAuthenticated_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroTextAuthenticated_matches?: Maybe<Scalars['String']>,
  readonly heroTextAuthenticated_not?: Maybe<Scalars['String']>,
  readonly heroTextAuthenticated_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroTextColor?: Maybe<Scalars['String']>,
  readonly heroTextColor_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroTextColor_matches?: Maybe<Scalars['String']>,
  readonly heroTextColor_not?: Maybe<Scalars['String']>,
  readonly heroTextColor_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heroText_matches?: Maybe<Scalars['String']>,
  readonly heroText_not?: Maybe<Scalars['String']>,
  readonly heroText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly kioskAppData?: Maybe<Scalars['ID']>,
  readonly menuHeroText?: Maybe<Scalars['String']>,
  readonly menuHeroText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly menuHeroText_matches?: Maybe<Scalars['String']>,
  readonly menuHeroText_not?: Maybe<Scalars['String']>,
  readonly menuHeroText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly recentOrderHeroText?: Maybe<Scalars['String']>,
  readonly recentOrderHeroText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly recentOrderHeroText_matches?: Maybe<Scalars['String']>,
  readonly recentOrderHeroText_not?: Maybe<Scalars['String']>,
  readonly recentOrderHeroText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly servicesHeaderText?: Maybe<Scalars['String']>,
  readonly servicesHeaderText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly servicesHeaderText_matches?: Maybe<Scalars['String']>,
  readonly servicesHeaderText_not?: Maybe<Scalars['String']>,
  readonly servicesHeaderText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly servicesHeroText?: Maybe<Scalars['String']>,
  readonly servicesHeroText_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly servicesHeroText_matches?: Maybe<Scalars['String']>,
  readonly servicesHeroText_not?: Maybe<Scalars['String']>,
  readonly servicesHeroText_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly siteAlert?: Maybe<Scalars['ID']>,
  readonly upsellItemAtCheckout?: Maybe<Scalars['ID']>,
  readonly useSideBySideHeroButtons?: Maybe<Scalars['Boolean']>,
  readonly useSideBySideHeroButtons_not?: Maybe<Scalars['Boolean']>,
}

export interface IAppDownload  extends IDocument {
  readonly __typename?: 'AppDownload',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly details: Maybe<IAppDownloadSection>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IAppDownloadFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IAppDownloadSection {
  readonly __typename?: 'AppDownloadSection',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly androidDownloadImage: Maybe<ILocaleImage>,
  readonly androidDownloadLink: Maybe<Scalars['String']>,
  readonly copy: Maybe<ILocaleString>,
  readonly header: Maybe<ILocaleString>,
  readonly headerSuperText: Maybe<ILocaleString>,
  readonly iOSDownloadImage: Maybe<ILocaleImage>,
  readonly iOSDownloadLink: Maybe<Scalars['String']>,
  readonly primaryImage: Maybe<ILocaleImage>,
  readonly submitButtonText: Maybe<ILocaleString>,
  readonly textDecorationLeft: Maybe<IImage>,
  readonly textDecorationRight: Maybe<IImage>,
}

export interface IAppVersion  extends IDocument {
  readonly __typename?: 'AppVersion',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly kioskVersionName: Maybe<Scalars['String']>,
  readonly nativeVersionName: Maybe<Scalars['String']>,
  readonly nativeVersionNumber: Maybe<Scalars['Float']>,
}

export interface IAppVersionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly kioskVersionName?: Maybe<Scalars['String']>,
  readonly kioskVersionName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly kioskVersionName_matches?: Maybe<Scalars['String']>,
  readonly kioskVersionName_not?: Maybe<Scalars['String']>,
  readonly kioskVersionName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly nativeVersionName?: Maybe<Scalars['String']>,
  readonly nativeVersionName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly nativeVersionName_matches?: Maybe<Scalars['String']>,
  readonly nativeVersionName_not?: Maybe<Scalars['String']>,
  readonly nativeVersionName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly nativeVersionNumber?: Maybe<Scalars['Float']>,
  readonly nativeVersionNumber_gt?: Maybe<Scalars['Float']>,
  readonly nativeVersionNumber_gte?: Maybe<Scalars['Float']>,
  readonly nativeVersionNumber_lt?: Maybe<Scalars['Float']>,
  readonly nativeVersionNumber_lte?: Maybe<Scalars['Float']>,
  readonly nativeVersionNumber_not?: Maybe<Scalars['Float']>,
}

export interface IBarcodes  extends IDocument {
  readonly __typename?: 'Barcodes',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly endDate: Maybe<Scalars['Date']>,
  readonly name: Maybe<Scalars['String']>,
  readonly offers: Maybe<ReadonlyArray<Maybe<IOffer>>>,
  readonly prefix: Maybe<Scalars['String']>,
  readonly quantity: Maybe<Scalars['Float']>,
  readonly startDate: Maybe<Scalars['Date']>,
}

export interface IBarcodesFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly endDate?: Maybe<Scalars['Date']>,
  readonly endDate_gt?: Maybe<Scalars['Date']>,
  readonly endDate_gte?: Maybe<Scalars['Date']>,
  readonly endDate_lt?: Maybe<Scalars['Date']>,
  readonly endDate_lte?: Maybe<Scalars['Date']>,
  readonly endDate_not?: Maybe<Scalars['Date']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly prefix?: Maybe<Scalars['String']>,
  readonly prefix_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly prefix_matches?: Maybe<Scalars['String']>,
  readonly prefix_not?: Maybe<Scalars['String']>,
  readonly prefix_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly quantity?: Maybe<Scalars['Float']>,
  readonly quantity_gt?: Maybe<Scalars['Float']>,
  readonly quantity_gte?: Maybe<Scalars['Float']>,
  readonly quantity_lt?: Maybe<Scalars['Float']>,
  readonly quantity_lte?: Maybe<Scalars['Float']>,
  readonly quantity_not?: Maybe<Scalars['Float']>,
  readonly startDate?: Maybe<Scalars['Date']>,
  readonly startDate_gt?: Maybe<Scalars['Date']>,
  readonly startDate_gte?: Maybe<Scalars['Date']>,
  readonly startDate_lt?: Maybe<Scalars['Date']>,
  readonly startDate_lte?: Maybe<Scalars['Date']>,
  readonly startDate_not?: Maybe<Scalars['Date']>,
}

export interface IBetweenDates {
  readonly __typename?: 'BetweenDates',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly endDate: Maybe<Scalars['Date']>,
  readonly startDate: Maybe<Scalars['Date']>,
}

export type IBetweenDatesOrCartLimitOrDaypartRuleOrFirstOrderOnlyOrLoyaltyPoints = IBetweenDates | ICartLimit | IDaypartRule | IFirstOrderOnly | ILoyaltyPoints;

export interface IBetweenTimes {
  readonly __typename?: 'BetweenTimes',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly endTime: Maybe<Scalars['String']>,
  readonly startTime: Maybe<Scalars['String']>,
}

export interface IBirthdayMultiplier {
  readonly __typename?: 'BirthdayMultiplier',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly duration: Maybe<Scalars['String']>,
}

export interface IBlacklistCharacterReplaceRule {
  readonly __typename?: 'BlacklistCharacterReplaceRule',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly filter: Maybe<Scalars['String']>,
  readonly replace: Maybe<Scalars['String']>,
}

export interface IBlock {
  readonly __typename?: 'Block',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly children: Maybe<ReadonlyArray<Maybe<ISpan>>>,
  readonly list: Maybe<Scalars['String']>,
  readonly style: Maybe<Scalars['String']>,
}

export interface IBlockContentImage {
  readonly __typename?: 'BlockContentImage',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly asset: Maybe<ISanityImageAsset>,
  readonly caption: Maybe<Scalars['String']>,
  readonly crop: Maybe<ISanityImageCrop>,
  readonly hotspot: Maybe<ISanityImageHotspot>,
}

export type IBlockOrBlockContentImage = IBlock | IBlockContentImage;

export interface IBrazeContentCards  extends IDocument {
  readonly __typename?: 'BrazeContentCards',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly sectionSubheader: Maybe<ILocaleString>,
  readonly sectionheader: Maybe<ILocaleString>,
}

export interface IBrazeContentCardsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ICallToAction {
  readonly __typename?: 'CallToAction',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly buttonLink: Maybe<Scalars['String']>,
  readonly buttonText: Maybe<ILocaleString>,
  readonly heading: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly subheading: Maybe<ILocaleString>,
}

export interface ICallToActionWidget {
  readonly __typename?: 'CallToActionWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly callToActionContent: Maybe<ReadonlyArray<Maybe<ICallToAction>>>,
}

export interface ICardInformationTranslations {
  readonly __typename?: 'CardInformationTranslations',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly addCardAppleWallet: Maybe<ILocaleString>,
  readonly balanceReload: Maybe<ILocaleString>,
  readonly balanceReloadFailed: Maybe<ILocaleString>,
  readonly balanceTransfer: Maybe<ILocaleString>,
  readonly changeNewCard: Maybe<ILocaleString>,
  readonly connectATimsCard: Maybe<ILocaleString>,
  readonly connectCard: Maybe<ILocaleString>,
  readonly connectYourTimsCard: Maybe<ILocaleString>,
  readonly deactivateCard: Maybe<ILocaleString>,
  readonly deactivateYourTimsCard: Maybe<ILocaleString>,
  readonly digitalAccountBalance: Maybe<ILocaleString>,
  readonly enterDigitsOnCard: Maybe<ILocaleString>,
  readonly haveACardSaved: Maybe<ILocaleString>,
  readonly loadBalance: Maybe<ILocaleString>,
  readonly myBalance: Maybe<ILocaleString>,
  readonly myTimsBalance: Maybe<ILocaleString>,
  readonly noCardsAvailable: Maybe<ILocaleString>,
  readonly noGiftCards: Maybe<ILocaleString>,
  readonly payingInStore: Maybe<ILocaleString>,
  readonly scanRewardsCard: Maybe<ILocaleString>,
  readonly scanTimCard: Maybe<ILocaleString>,
  readonly sucessTransfer: Maybe<ILocaleString>,
  readonly tiedToBalance: Maybe<ILocaleString>,
  readonly timCardLost: Maybe<ILocaleString>,
  readonly timmyMeCards: Maybe<ILocaleString>,
  readonly timsCardConnected: Maybe<ILocaleString>,
  readonly transferTimCardBalance: Maybe<ILocaleString>,
  readonly transferTimmyMe: Maybe<ILocaleString>,
  readonly transferTimmyMeBalance: Maybe<ILocaleString>,
  readonly unregisteredTimsCard: Maybe<ILocaleString>,
  readonly updateAppBalance: Maybe<ILocaleString>,
  readonly updatingPrimaryCard: Maybe<ILocaleString>,
  readonly withYourTimCard: Maybe<ILocaleString>,
  readonly yourTimsCard: Maybe<ILocaleString>,
}

export interface ICartContainsPlu {
  readonly __typename?: 'CartContainsPlu',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly hdxPLUs: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly qstPLUs: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly quantity: Maybe<Scalars['Float']>,
  readonly sicomPLUs: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface ICartLimit {
  readonly __typename?: 'CartLimit',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly maximumRedemptions: Maybe<Scalars['Float']>,
}

export interface ICartProperty {
  readonly __typename?: 'CartProperty',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly key: Maybe<Scalars['String']>,
  readonly negated: Maybe<Scalars['Boolean']>,
  readonly operator: Maybe<Scalars['String']>,
  readonly value: Maybe<Scalars['String']>,
}

export interface ICategory  extends IDocument {
  readonly __typename?: 'Category',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly description: Maybe<ILocaleBlockContent>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<ITier>>>,
}

export interface ICategoryFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ICateringPageConfiguration  extends IDocument {
  readonly __typename?: 'CateringPageConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly components: Maybe<ReadonlyArray<Maybe<IMainHero>>>,
}

export interface ICateringPageConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IChannelExclusions {
  readonly __typename?: 'ChannelExclusions',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly delivery: Maybe<Scalars['Boolean']>,
  readonly googleFoodOrdering: Maybe<Scalars['Boolean']>,
  readonly kiosk: Maybe<Scalars['Boolean']>,
  readonly mobile: Maybe<Scalars['Boolean']>,
  readonly web: Maybe<Scalars['Boolean']>,
}

export interface ICode {
  readonly __typename?: 'Code',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly code: Maybe<Scalars['String']>,
  readonly filename: Maybe<Scalars['String']>,
  readonly highlightedLines: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>,
  readonly language: Maybe<Scalars['String']>,
}

export interface IColumn {
  readonly __typename?: 'Column',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly options: Maybe<ReadonlyArray<Maybe<ICopyrightAndLanguageSelectorOrHighlightedVerticalLinkListWidgetOrHorizontalLinkListWidgetOrImageWidgetOrSocialIconsWithHeaderWidgetOrTextWidgetOrVerticalLinkListWidgetOrVerticalLinkListWithHeaderWidgetOrWordmarkAndSocialIcons>>>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface ICombo  extends IDocument {
  readonly __typename?: 'Combo',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly activationDate: Maybe<Scalars['Date']>,
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly deactivationDate: Maybe<Scalars['Date']>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly dmbName: Maybe<ILocaleString>,
  readonly forceModifiersToBottom: Maybe<Scalars['Boolean']>,
  readonly hideMainItemDescription: Maybe<Scalars['Boolean']>,
  readonly image: Maybe<IImage>,
  readonly images: Maybe<IImages>,
  readonly labelAsPerPerson: Maybe<Scalars['Boolean']>,
  readonly mainItem: Maybe<IItem>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IComboSlot>>>,
  readonly prices: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>,
  readonly showInStaticMenu: Maybe<Scalars['Boolean']>,
  readonly uiPattern: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IComboFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly activationDate?: Maybe<Scalars['Date']>,
  readonly activationDate_gt?: Maybe<Scalars['Date']>,
  readonly activationDate_gte?: Maybe<Scalars['Date']>,
  readonly activationDate_lt?: Maybe<Scalars['Date']>,
  readonly activationDate_lte?: Maybe<Scalars['Date']>,
  readonly activationDate_not?: Maybe<Scalars['Date']>,
  readonly deactivationDate?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_not?: Maybe<Scalars['Date']>,
  readonly forceModifiersToBottom?: Maybe<Scalars['Boolean']>,
  readonly forceModifiersToBottom_not?: Maybe<Scalars['Boolean']>,
  readonly hideMainItemDescription?: Maybe<Scalars['Boolean']>,
  readonly hideMainItemDescription_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly labelAsPerPerson?: Maybe<Scalars['Boolean']>,
  readonly labelAsPerPerson_not?: Maybe<Scalars['Boolean']>,
  readonly mainItem?: Maybe<Scalars['ID']>,
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu_not?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export type IComboOrExternalLinkOrItemOrOfferOrPickerOrSection = ICombo | IExternalLink | IItem | IOffer | IPicker | ISection;

export type IComboOrItem = ICombo | IItem;

export type IComboOrItemOrOfferActivationOrOfferDiscountOrOfferItemDiscountOrOfferLoyaltyActionOrPicker = ICombo | IItem | IOfferActivation | IOfferDiscount | IOfferItemDiscount | IOfferLoyaltyAction | IPicker;

export type IComboOrItemOrOfferActivationOrOfferDiscountOrPicker = ICombo | IItem | IOfferActivation | IOfferDiscount | IPicker;

export type IComboOrItemOrOfferDiscountOrPicker = ICombo | IItem | IOfferDiscount | IPicker;

export type IComboOrItemOrOfferOrPickerOrSection = ICombo | IItem | IOffer | IPicker | ISection;

export type IComboOrItemOrPicker = ICombo | IItem | IPicker;

export type IComboOrItemOrPickerOrProductCategory = ICombo | IItem | IPicker | IProductCategory;

export type IComboOrItemOrPickerOrSection = ICombo | IItem | IPicker | ISection;

export interface IComboSlot  extends IDocument {
  readonly __typename?: 'ComboSlot',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly description: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<IImage>,
  readonly images: Maybe<IImages>,
  readonly maxAmount: Maybe<Scalars['Float']>,
  readonly minAmount: Maybe<Scalars['Float']>,
  readonly name: Maybe<ILocaleString>,
  readonly optionVisibilitySettings: Maybe<IOptionVisibilitySettings>,
  readonly options: Maybe<ReadonlyArray<Maybe<IComboSlotOption>>>,
  readonly respectMaximum: Maybe<Scalars['Boolean']>,
  readonly uiPattern: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IComboSlotFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly maxAmount?: Maybe<Scalars['Float']>,
  readonly maxAmount_gt?: Maybe<Scalars['Float']>,
  readonly maxAmount_gte?: Maybe<Scalars['Float']>,
  readonly maxAmount_lt?: Maybe<Scalars['Float']>,
  readonly maxAmount_lte?: Maybe<Scalars['Float']>,
  readonly maxAmount_not?: Maybe<Scalars['Float']>,
  readonly minAmount?: Maybe<Scalars['Float']>,
  readonly minAmount_gt?: Maybe<Scalars['Float']>,
  readonly minAmount_gte?: Maybe<Scalars['Float']>,
  readonly minAmount_lt?: Maybe<Scalars['Float']>,
  readonly minAmount_lte?: Maybe<Scalars['Float']>,
  readonly minAmount_not?: Maybe<Scalars['Float']>,
  readonly respectMaximum?: Maybe<Scalars['Boolean']>,
  readonly respectMaximum_not?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IComboSlotOption {
  readonly __typename?: 'ComboSlotOption',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly defaultAmount: Maybe<Scalars['Float']>,
  readonly maxAmount: Maybe<Scalars['Float']>,
  readonly minAmount: Maybe<Scalars['Float']>,
  readonly option: Maybe<IItemOrPickerOrSection>,
  readonly prices: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>,
}

export interface IConditionAllergen {
  readonly __typename?: 'ConditionAllergen',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly allergenIdentifier: Maybe<Scalars['String']>,
  readonly comparisonOperator: Maybe<Scalars['String']>,
  readonly comparisonValue: Maybe<Scalars['Float']>,
}

export type IConditionAllergenOrConditionItemOneOfOrConditionNutritionOrConditionParentCategory = IConditionAllergen | IConditionItemOneOf | IConditionNutrition | IConditionParentCategory;

export interface IConditionItemOneOf {
  readonly __typename?: 'ConditionItemOneOf',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly items: Maybe<ReadonlyArray<Maybe<IItem>>>,
}

export interface IConditionNutrition {
  readonly __typename?: 'ConditionNutrition',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly comparisonOperator: Maybe<Scalars['String']>,
  readonly comparisonValue: Maybe<Scalars['Float']>,
  readonly nutritionIdentifier: Maybe<Scalars['String']>,
}

export interface IConditionParentCategory {
  readonly __typename?: 'ConditionParentCategory',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly parentCategory: Maybe<IPickerOrSection>,
}

export interface ICoolDown {
  readonly __typename?: 'CoolDown',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly minimumElapsedTimeSeconds: Maybe<Scalars['Float']>,
}

export interface ICopyrightAndLanguageSelector {
  readonly __typename?: 'CopyrightAndLanguageSelector',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly copyrightText: Maybe<ILocaleString>,
}

export type ICopyrightAndLanguageSelectorOrHighlightedVerticalLinkListWidgetOrHorizontalLinkListWidgetOrImageWidgetOrSocialIconsWithHeaderWidgetOrTextWidgetOrVerticalLinkListWidgetOrVerticalLinkListWithHeaderWidgetOrWordmarkAndSocialIcons = ICopyrightAndLanguageSelector | IHighlightedVerticalLinkListWidget | IHorizontalLinkListWidget | IImageWidget | ISocialIconsWithHeaderWidget | ITextWidget | IVerticalLinkListWidget | IVerticalLinkListWithHeaderWidget | IWordmarkAndSocialIcons;

export interface ICss {
  readonly __typename?: 'Css',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly code: Maybe<Scalars['String']>,
  readonly filename: Maybe<Scalars['String']>,
  readonly highlightedLines: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>,
  readonly language: Maybe<Scalars['String']>,
}



export interface IDayOfWeekBand {
  readonly __typename?: 'DayOfWeekBand',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly friday: Maybe<Scalars['Boolean']>,
  readonly monday: Maybe<Scalars['Boolean']>,
  readonly saturday: Maybe<Scalars['Boolean']>,
  readonly sunday: Maybe<Scalars['Boolean']>,
  readonly thursday: Maybe<Scalars['Boolean']>,
  readonly tuesday: Maybe<Scalars['Boolean']>,
  readonly wednesday: Maybe<Scalars['Boolean']>,
}

export interface IDayPart {
  readonly __typename?: 'DayPart',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly endTime: Maybe<Scalars['String']>,
  readonly key: Maybe<Scalars['String']>,
  readonly startTime: Maybe<Scalars['String']>,
}

export interface IDaypartRule {
  readonly __typename?: 'DaypartRule',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly daypart: Maybe<Scalars['String']>,
}

export interface IDisplayGroup  extends IDocument {
  readonly __typename?: 'DisplayGroup',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly displayRank: Maybe<Scalars['Float']>,
  readonly name: Maybe<ILocaleString>,
}

export interface IDisplayGroupFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly displayRank?: Maybe<Scalars['Float']>,
  readonly displayRank_gt?: Maybe<Scalars['Float']>,
  readonly displayRank_gte?: Maybe<Scalars['Float']>,
  readonly displayRank_lt?: Maybe<Scalars['Float']>,
  readonly displayRank_lte?: Maybe<Scalars['Float']>,
  readonly displayRank_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IDocument {
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
}

export interface IDoubleImageWidget {
  readonly __typename?: 'DoubleImageWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly image1: Maybe<IImageWidget>,
  readonly image2: Maybe<IImageWidget>,
}

export interface IEarningCalculation  extends IDocument {
  readonly __typename?: 'EarningCalculation',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly cooldownPeriod: Maybe<Scalars['Float']>,
  readonly coreMetric: Maybe<Scalars['String']>,
  readonly minSpend: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays: Maybe<Scalars['Float']>,
  readonly pointsPerDollar: Maybe<Scalars['Float']>,
  readonly pointsPerVisit: Maybe<Scalars['Float']>,
}

export interface IEarningCalculationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly cooldownPeriod?: Maybe<Scalars['Float']>,
  readonly cooldownPeriod_gt?: Maybe<Scalars['Float']>,
  readonly cooldownPeriod_gte?: Maybe<Scalars['Float']>,
  readonly cooldownPeriod_lt?: Maybe<Scalars['Float']>,
  readonly cooldownPeriod_lte?: Maybe<Scalars['Float']>,
  readonly cooldownPeriod_not?: Maybe<Scalars['Float']>,
  readonly coreMetric?: Maybe<Scalars['String']>,
  readonly coreMetric_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly coreMetric_matches?: Maybe<Scalars['String']>,
  readonly coreMetric_not?: Maybe<Scalars['String']>,
  readonly coreMetric_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly minSpend?: Maybe<Scalars['Float']>,
  readonly minSpend_gt?: Maybe<Scalars['Float']>,
  readonly minSpend_gte?: Maybe<Scalars['Float']>,
  readonly minSpend_lt?: Maybe<Scalars['Float']>,
  readonly minSpend_lte?: Maybe<Scalars['Float']>,
  readonly minSpend_not?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays_gt?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays_gte?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays_lt?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays_lte?: Maybe<Scalars['Float']>,
  readonly pointsExpiryDays_not?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar_gt?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar_gte?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar_lt?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar_lte?: Maybe<Scalars['Float']>,
  readonly pointsPerDollar_not?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit_gt?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit_gte?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit_lt?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit_lte?: Maybe<Scalars['Float']>,
  readonly pointsPerVisit_not?: Maybe<Scalars['Float']>,
}

export interface IEmptyState  extends IDocument {
  readonly __typename?: 'EmptyState',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly buttonAction: Maybe<ILinkAction>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly headerText: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImages>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly title: Maybe<ILocaleString>,
}

export interface IEmptyStateFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IErrorsTranslations {
  readonly __typename?: 'ErrorsTranslations',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly canNotGetAmount: Maybe<ILocaleString>,
  readonly canNotGetBalance: Maybe<ILocaleString>,
  readonly canNotModify: Maybe<ILocaleString>,
  readonly canNotScan: Maybe<ILocaleString>,
  readonly contactTimsSupport: Maybe<ILocaleString>,
  readonly deactivationFailed: Maybe<ILocaleString>,
  readonly dontSeeOrder: Maybe<ILocaleString>,
  readonly errorTransferingCard: Maybe<ILocaleString>,
  readonly errorTransferingTimCard: Maybe<ILocaleString>,
  readonly errorWithTimCard: Maybe<ILocaleString>,
  readonly failedDeletingCard: Maybe<ILocaleString>,
  readonly failedFacebookLogin: Maybe<ILocaleString>,
  readonly failedFiringOrder: Maybe<ILocaleString>,
  readonly failedPaymentMethod: Maybe<ILocaleString>,
  readonly failedResendingCode: Maybe<ILocaleString>,
  readonly failedUpdatingCard: Maybe<ILocaleString>,
  readonly incorrectCard: Maybe<ILocaleString>,
  readonly purchaseDidNotCount: Maybe<ILocaleString>,
}

export interface IExternalLink {
  readonly __typename?: 'ExternalLink',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly link: Maybe<ILocaleUrl>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly name: Maybe<ILocaleString>,
  readonly url: Maybe<Scalars['String']>,
}

export interface IFanFavorites  extends IDocument {
  readonly __typename?: 'FanFavorites',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly fanFavoriteItems: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferOrPickerOrSection>>>,
  readonly favoriteSection: Maybe<IFavoriteSection>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IFanFavoritesFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IFavoriteSection {
  readonly __typename?: 'FavoriteSection',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly headerText: Maybe<ILocaleString>,
  readonly orderNowText: Maybe<ILocaleString>,
  readonly subheaderText: Maybe<ILocaleString>,
}

export interface IFeatureAccount  extends IDocument {
  readonly __typename?: 'FeatureAccount',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly emailAndPushOptInSettings: Maybe<ReadonlyArray<Maybe<IOptInSettingBooleanOrOptInSettingEmailAndPushOrOptInSettingEnum>>>,
}

export interface IFeatureAccountDeletePage  extends IDocument {
  readonly __typename?: 'FeatureAccountDeletePage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly cancelButtonText: Maybe<ILocaleString>,
  readonly confirmButtonText: Maybe<ILocaleString>,
  readonly content: Maybe<ILocaleBlockContent>,
  readonly errorText: Maybe<ILocaleString>,
  readonly headerText: Maybe<ILocaleString>,
}

export interface IFeatureAccountDeletePageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureAccountFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureAccountForm  extends IDocument {
  readonly __typename?: 'FeatureAccountForm',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly postalOrZipDisclaimer: Maybe<ILocaleString>,
}

export interface IFeatureAccountFormFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureAccountRequestInfoPage  extends IDocument {
  readonly __typename?: 'FeatureAccountRequestInfoPage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly confirmButtonText: Maybe<ILocaleString>,
  readonly content: Maybe<ILocaleBlockContent>,
  readonly errorText: Maybe<ILocaleString>,
  readonly headerText: Maybe<ILocaleString>,
}

export interface IFeatureAccountRequestInfoPageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureCateringPage  extends IDocument {
  readonly __typename?: 'FeatureCateringPage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly appAuthenticated: Maybe<ICateringPageConfiguration>,
  readonly appUnauthenticated: Maybe<ICateringPageConfiguration>,
  readonly webAuthenticated: Maybe<ICateringPageConfiguration>,
  readonly webUnauthenticated: Maybe<ICateringPageConfiguration>,
}

export interface IFeatureCateringPageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureDisclaimers  extends IDocument {
  readonly __typename?: 'FeatureDisclaimers',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly calorie: Maybe<ILocaleBlockContent>,
  readonly communicationPreferencesBlock: Maybe<ILocaleBlockContent>,
  readonly copyrightAndTrademark: Maybe<ILocaleString>,
  readonly country: Maybe<ILocaleString>,
  readonly images: Maybe<ILocaleString>,
  readonly itemAvailability: Maybe<ILocaleString>,
  readonly offers: Maybe<ILocaleString>,
  readonly phoneNumber: Maybe<ILocaleString>,
  readonly price: Maybe<ILocaleString>,
  readonly reservedRights: Maybe<ILocaleString>,
  readonly superUpsell: Maybe<ILocaleBlockContent>,
}

export interface IFeatureDisclaimersFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureFooter  extends IDocument {
  readonly __typename?: 'FeatureFooter',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly rows: Maybe<ReadonlyArray<Maybe<IRow>>>,
}

export interface IFeatureFooterFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureGeolocationModal  extends IDocument {
  readonly __typename?: 'FeatureGeolocationModal',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<ILocaleImage>,
  readonly body: Maybe<ILocaleString>,
  readonly deliveryImage: Maybe<ILocaleImage>,
  readonly header: Maybe<ILocaleString>,
  readonly logo: Maybe<ILocaleImage>,
}

export interface IFeatureGeolocationModalFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureGift  extends IDocument {
  readonly __typename?: 'FeatureGift',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<ILocaleImages>,
  readonly header: Maybe<ILocaleString>,
  readonly legalDisclaimer: Maybe<ILocaleBlockContent>,
  readonly receptionModalImage: Maybe<ILocaleImages>,
  readonly subHeader: Maybe<ILocaleBlockContent>,
}

export interface IFeatureGiftFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureHomePage  extends IDocument {
  readonly __typename?: 'FeatureHomePage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly appAuthenticated: Maybe<IHomePageConfiguration>,
  readonly appUnauthenticated: Maybe<IHomePageConfiguration>,
  readonly webAuthenticated: Maybe<IHomePageConfiguration>,
  readonly webUnauthenticated: Maybe<IHomePageConfiguration>,
}

export interface IFeatureHomePageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureKiosk  extends IDocument {
  readonly __typename?: 'FeatureKiosk',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly appData: Maybe<IKioskAppData>,
  readonly attractLoopImage: Maybe<ILocaleImage>,
  readonly rewardsMainImage: Maybe<ILocaleImage>,
}

export interface IFeatureKioskFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly appData?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureLayout  extends IDocument {
  readonly __typename?: 'FeatureLayout',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly appleWalletImage: Maybe<ILocaleImage>,
  readonly defaultHeroImage: Maybe<ILocaleImage>,
  readonly geolocationModalImage: Maybe<ILocaleImage>,
  readonly giftCardImage: Maybe<ILocaleImage>,
  readonly giftCardTextImage: Maybe<ILocaleImage>,
  readonly googlePayImage: Maybe<ILocaleImage>,
  readonly loadingGraphics: Maybe<ILoadingGraphics>,
  readonly recentOrderHeroText: Maybe<ILocaleString>,
}

export interface IFeatureLayoutFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureLocationPromo  extends IDocument {
  readonly __typename?: 'FeatureLocationPromo',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly bottomText: Maybe<ILocaleString>,
  readonly failLocationHeader: Maybe<ILocaleString>,
  readonly failLocationSubtext: Maybe<ILocaleString>,
  readonly legalText: Maybe<ILocaleString>,
  readonly linkToStaticPage: Maybe<ILinkAction>,
  readonly menuHeroText: Maybe<ILocaleString>,
  readonly promoBackgroundImage: Maybe<IImage>,
}

export interface IFeatureLocationPromoFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureMenu  extends IDocument {
  readonly __typename?: 'FeatureMenu',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly cateringMenu: Maybe<IMenu>,
  readonly dayParts: Maybe<ReadonlyArray<Maybe<IDayPart>>>,
  readonly defaultMenu: Maybe<IMenu>,
  readonly menuHeroImage: Maybe<ILocaleImage>,
  readonly menuHeroText: Maybe<ILocaleString>,
  readonly upsellItemsAtCheckoutCatering: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly upsellItemsAtCheckoutDelivery: Maybe<ReadonlyArray<Maybe<IItem>>>,
  readonly upsellItemsAtCheckoutRestaurant: Maybe<ReadonlyArray<Maybe<IItem>>>,
}

export interface IFeatureMenuFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly cateringMenu?: Maybe<Scalars['ID']>,
  readonly defaultMenu?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureMobileAppConfiguration  extends IDocument {
  readonly __typename?: 'FeatureMobileAppConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly appVersion: Maybe<IAppVersion>,
}

export interface IFeatureMobileAppConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly appVersion?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureNavigation  extends IDocument {
  readonly __typename?: 'FeatureNavigation',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly aboutMenuEntries: Maybe<INavigationSection>,
  readonly navigationDesktop: Maybe<INavigationDesktop>,
  readonly navigationMobile: Maybe<INavigationMobile>,
}

export interface IFeatureNavigationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureNutrition  extends IDocument {
  readonly __typename?: 'FeatureNutrition',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly nutritionTables: Maybe<ReadonlyArray<Maybe<INutritionTable>>>,
}

export interface IFeatureNutritionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureOffers  extends IDocument {
  readonly __typename?: 'FeatureOffers',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly defaultBackgroundImage: Maybe<IImage>,
  readonly offersBrowsingPanel: Maybe<IOffersBrowsingPanel>,
  readonly offersDetailsPanel: Maybe<IOffersDetailsPanel>,
  readonly sortedOffers: Maybe<ReadonlyArray<Maybe<IOffer>>>,
}

export interface IFeatureOffersFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFeatureQuiz  extends IDocument {
  readonly __typename?: 'FeatureQuiz',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly description: Maybe<ILocaleString>,
  readonly endDate: Maybe<Scalars['Date']>,
  readonly introPageBackground: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
  readonly question: Maybe<ReadonlyArray<Maybe<IQuestionDetails>>>,
  readonly questionPageBackground: Maybe<IImage>,
  readonly questions: Maybe<ReadonlyArray<Maybe<IQuestionDetails>>>,
  readonly resultPageBackground: Maybe<IImage>,
  readonly results: Maybe<ReadonlyArray<Maybe<IResultDetails>>>,
  readonly startDate: Maybe<Scalars['Date']>,
}

export interface IFeatureQuizFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly endDate?: Maybe<Scalars['Date']>,
  readonly endDate_gt?: Maybe<Scalars['Date']>,
  readonly endDate_gte?: Maybe<Scalars['Date']>,
  readonly endDate_lt?: Maybe<Scalars['Date']>,
  readonly endDate_lte?: Maybe<Scalars['Date']>,
  readonly endDate_not?: Maybe<Scalars['Date']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly startDate?: Maybe<Scalars['Date']>,
  readonly startDate_gt?: Maybe<Scalars['Date']>,
  readonly startDate_gte?: Maybe<Scalars['Date']>,
  readonly startDate_lt?: Maybe<Scalars['Date']>,
  readonly startDate_lte?: Maybe<Scalars['Date']>,
  readonly startDate_not?: Maybe<Scalars['Date']>,
}

export interface IFeatureStaticMenu  extends IDocument {
  readonly __typename?: 'FeatureStaticMenu',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly itemUnavailableModal: Maybe<IItemUnavailableModal>,
}

export interface IFeatureStaticMenuFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IFile {
  readonly __typename?: 'File',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly asset: Maybe<ISanityFileAsset>,
}

export interface IFilter {
  readonly __typename?: 'Filter',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly conditions: Maybe<ReadonlyArray<Maybe<IConditionAllergenOrConditionItemOneOfOrConditionNutritionOrConditionParentCategory>>>,
  readonly description: Maybe<ILocaleString>,
}

export interface IFilterGroup {
  readonly __typename?: 'FilterGroup',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly filters: Maybe<ReadonlyArray<Maybe<IFilter>>>,
}

export interface IFirstOrderOnly {
  readonly __typename?: 'FirstOrderOnly',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly firstUserOrder: Maybe<Scalars['Boolean']>,
}

export interface IFooter  extends IDocument {
  readonly __typename?: 'Footer',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly accessibilitystatement: Maybe<ILink>,
  readonly careers: Maybe<ILink>,
  readonly company: Maybe<ILink>,
  readonly contactus: Maybe<ILink>,
  readonly foundation: Maybe<ILink>,
  readonly franchiseopportunities: Maybe<ILink>,
  readonly investorrelations: Maybe<ILink>,
  readonly legal: Maybe<ILink>,
  readonly ourstory: Maybe<ILink>,
  readonly privacypolicy: Maybe<ILink>,
  readonly sitemap: Maybe<ILink>,
  readonly support: Maybe<ILink>,
  readonly termsofuse: Maybe<ILink>,
}

export interface IFooterFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IGeopoint {
  readonly __typename?: 'Geopoint',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly alt: Maybe<Scalars['Float']>,
  readonly lat: Maybe<Scalars['Float']>,
  readonly lng: Maybe<Scalars['Float']>,
}

export interface IHeaderWidget {
  readonly __typename?: 'HeaderWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly headerImage: Maybe<ILocaleImage>,
  readonly headingContent: Maybe<ILocaleString>,
  readonly taglineContent: Maybe<ILocaleString>,
}

export interface IHighlightedLinkWidget {
  readonly __typename?: 'HighlightedLinkWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly link: Maybe<ILocaleUrl>,
  readonly text: Maybe<ILocaleString>,
}

export interface IHighlightedVerticalLinkListWidget {
  readonly __typename?: 'HighlightedVerticalLinkListWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly header: Maybe<ILocaleString>,
  readonly highlightedLinks: Maybe<ReadonlyArray<Maybe<IHighlightedLinkWidget>>>,
  readonly subheader: Maybe<ILocaleString>,
}

export interface IHomeGraphic {
  readonly __typename?: 'HomeGraphic',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly asset: Maybe<ISanityFileAsset>,
  readonly description: Maybe<Scalars['String']>,
}

export interface IHomePageConfiguration  extends IDocument {
  readonly __typename?: 'HomePageConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly components: Maybe<ReadonlyArray<Maybe<IAlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrLockedOffersOrMainHeroOrMarketingTileGroupOrOffersSectionOrOurServicesOrRecentItemsOrRollUpTheRimSectionOrScanForRewardsOrTrending>>>,
}

export interface IHomePageConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IHomeScreenTranslations {
  readonly __typename?: 'HomeScreenTranslations',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly countrySetTo: Maybe<ILocaleString>,
  readonly doubleTapSelect: Maybe<ILocaleString>,
  readonly restaurantAndViewMenu: Maybe<ILocaleString>,
  readonly whatIsNew: Maybe<ILocaleString>,
}

export interface IHorizontalLinkListWidget {
  readonly __typename?: 'HorizontalLinkListWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly linkWidgets: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>,
}

export interface IHoursOfOperation {
  readonly __typename?: 'HoursOfOperation',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly friClose: Maybe<Scalars['String']>,
  readonly friOpen: Maybe<Scalars['String']>,
  readonly monClose: Maybe<Scalars['String']>,
  readonly monOpen: Maybe<Scalars['String']>,
  readonly satClose: Maybe<Scalars['String']>,
  readonly satOpen: Maybe<Scalars['String']>,
  readonly sunClose: Maybe<Scalars['String']>,
  readonly sunOpen: Maybe<Scalars['String']>,
  readonly thrClose: Maybe<Scalars['String']>,
  readonly thrOpen: Maybe<Scalars['String']>,
  readonly tueClose: Maybe<Scalars['String']>,
  readonly tueOpen: Maybe<Scalars['String']>,
  readonly wedClose: Maybe<Scalars['String']>,
  readonly wedOpen: Maybe<Scalars['String']>,
}

export interface IHtml {
  readonly __typename?: 'Html',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly code: Maybe<Scalars['String']>,
  readonly filename: Maybe<Scalars['String']>,
  readonly highlightedLines: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>,
  readonly language: Maybe<Scalars['String']>,
}

export interface IImage {
  readonly __typename?: 'Image',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly asset: Maybe<ISanityImageAsset>,
  readonly crop: Maybe<ISanityImageCrop>,
  readonly hotspot: Maybe<ISanityImageHotspot>,
}

export interface IImages {
  readonly __typename?: 'Images',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly app: Maybe<IImage>,
  readonly imageDescription: Maybe<Scalars['String']>,
  readonly kiosk: Maybe<IImage>,
}

export interface IImageWidget {
  readonly __typename?: 'ImageWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly attributionLink: Maybe<Scalars['String']>,
  readonly caption: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly imageDescription: Maybe<ILocaleString>,
}

export interface IItem  extends IDocument {
  readonly __typename?: 'Item',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly activationDate: Maybe<Scalars['Date']>,
  readonly allergens: Maybe<IOpAllergen>,
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly deactivationDate: Maybe<Scalars['Date']>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly dmbName: Maybe<ILocaleString>,
  readonly image: Maybe<IImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly images: Maybe<IImages>,
  readonly labelAsPerPerson: Maybe<Scalars['Boolean']>,
  readonly name: Maybe<ILocaleString>,
  readonly nutrition: Maybe<INutrition>,
  readonly nutritionWithModifiers: Maybe<INutrition>,
  readonly operationalItem: Maybe<IOpItem>,
  readonly options: Maybe<ReadonlyArray<Maybe<IItemOption>>>,
  readonly prices: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>,
  readonly rewardEligible: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu: Maybe<Scalars['Boolean']>,
  readonly tier: Maybe<ITier>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IItemFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly activationDate?: Maybe<Scalars['Date']>,
  readonly activationDate_gt?: Maybe<Scalars['Date']>,
  readonly activationDate_gte?: Maybe<Scalars['Date']>,
  readonly activationDate_lt?: Maybe<Scalars['Date']>,
  readonly activationDate_lte?: Maybe<Scalars['Date']>,
  readonly activationDate_not?: Maybe<Scalars['Date']>,
  readonly deactivationDate?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_not?: Maybe<Scalars['Date']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly labelAsPerPerson?: Maybe<Scalars['Boolean']>,
  readonly labelAsPerPerson_not?: Maybe<Scalars['Boolean']>,
  readonly rewardEligible?: Maybe<Scalars['Boolean']>,
  readonly rewardEligible_not?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu_not?: Maybe<Scalars['Boolean']>,
  readonly tier?: Maybe<Scalars['ID']>,
}

export interface IItemOption {
  readonly __typename?: 'ItemOption',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly activationDate: Maybe<Scalars['DateTime']>,
  readonly allowMultipleSelections: Maybe<Scalars['Boolean']>,
  readonly componentStyle: Maybe<Scalars['String']>,
  readonly deactivationDate: Maybe<Scalars['DateTime']>,
  readonly displayGroup: Maybe<IDisplayGroup>,
  readonly displayModifierMultiplierName: Maybe<Scalars['Boolean']>,
  readonly injectDefaultSelection: Maybe<Scalars['Boolean']>,
  readonly maxAmount: Maybe<Scalars['Float']>,
  readonly minAmount: Maybe<Scalars['Float']>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IItemOptionModifier>>>,
  readonly upsellModifier: Maybe<Scalars['Boolean']>,
}

export interface IItemOptionModifier {
  readonly __typename?: 'ItemOptionModifier',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly activationDate: Maybe<Scalars['DateTime']>,
  readonly allergen: Maybe<IOpAllergen>,
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly deactivationDate: Maybe<Scalars['DateTime']>,
  readonly default: Maybe<Scalars['Boolean']>,
  readonly modifierMultiplier: Maybe<IModifierMultiplier>,
  readonly name: Maybe<ILocaleString>,
  readonly nutrition: Maybe<INutrition>,
  readonly prices: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export type IItemOrNutritionalSection = IItem | INutritionalSection;

export type IItemOrPickerOrSection = IItem | IPicker | ISection;

export interface IItemUnavailableModal {
  readonly __typename?: 'ItemUnavailableModal',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly continue: Maybe<ILocaleString>,
  readonly header: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly itemNotAvailableForDelivery: Maybe<ILocaleString>,
  readonly selectNew: Maybe<ILocaleString>,
}


export interface IKiosk {
  readonly __typename?: 'Kiosk',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly serialNumber: Maybe<Scalars['String']>,
}

export interface IKioskAppData  extends IDocument {
  readonly __typename?: 'KioskAppData',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly blacklistCharacterReplaceRules: Maybe<ReadonlyArray<Maybe<IBlacklistCharacterReplaceRule>>>,
  readonly userNameBlacklist: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
}

export interface IKioskAppDataFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ILanguageSelectorWidget {
  readonly __typename?: 'LanguageSelectorWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface ILimit {
  readonly __typename?: 'Limit',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly interval: Maybe<Scalars['String']>,
  readonly limitInterval: Maybe<Scalars['String']>,
  readonly maximumRedemptions: Maybe<Scalars['Float']>,
  readonly multiplier: Maybe<Scalars['Float']>,
  readonly resetAt: Maybe<Scalars['String']>,
}

export interface ILink {
  readonly __typename?: 'Link',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly link: Maybe<Scalars['String']>,
  readonly title: Maybe<Scalars['String']>,
}

export interface ILinkAction {
  readonly __typename?: 'LinkAction',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly actionText: Maybe<ILocaleString>,
  readonly actionUrl: Maybe<ILocaleUrl>,
  readonly route: Maybe<Scalars['String']>,
}

export interface ILinksTranslations {
  readonly __typename?: 'LinksTranslations',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly legalLink: Maybe<ILocaleString>,
  readonly privacyLink: Maybe<ILocaleString>,
  readonly rewardsLink: Maybe<ILocaleString>,
}

export interface ILinkWidget {
  readonly __typename?: 'LinkWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly link: Maybe<ILocaleUrl>,
  readonly text: Maybe<ILocaleString>,
}

export interface IListItem {
  readonly __typename?: 'ListItem',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly title: Maybe<Scalars['String']>,
  readonly value: Maybe<Scalars['String']>,
}

export interface ILoader {
  readonly __typename?: 'Loader',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly desktopGraphic: Maybe<IImage>,
  readonly mobileGraphic: Maybe<IImage>,
  readonly text: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ILoadingGraphics {
  readonly __typename?: 'LoadingGraphics',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly cartInitialLoader: Maybe<ILoader>,
  readonly cartPricingLoader: Maybe<ILoader>,
}

export interface ILocaleBlockContent {
  readonly __typename?: 'LocaleBlockContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly deRaw: Maybe<Scalars['JSON']>,
  readonly enRaw: Maybe<Scalars['JSON']>,
  readonly frRaw: Maybe<Scalars['JSON']>,
  readonly itRaw: Maybe<Scalars['JSON']>,
}

export interface ILocaleBlockTextWidget {
  readonly __typename?: 'LocaleBlockTextWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly blockTextInversion: Maybe<Scalars['Boolean']>,
  readonly localeBlockTextContent: Maybe<ILocaleBlockContent>,
}

export interface ILocaleFile {
  readonly __typename?: 'LocaleFile',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<IFile>,
  readonly en: Maybe<IFile>,
  readonly fr: Maybe<IFile>,
  readonly it: Maybe<IFile>,
}

export interface ILocaleImage {
  readonly __typename?: 'LocaleImage',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<IImage>,
  readonly en: Maybe<IImage>,
  readonly fr: Maybe<IImage>,
  readonly it: Maybe<IImage>,
}

export interface ILocaleImages {
  readonly __typename?: 'LocaleImages',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<IImages>,
  readonly en: Maybe<IImages>,
  readonly fr: Maybe<IImages>,
  readonly it: Maybe<IImages>,
}

export interface ILocaleSlug {
  readonly __typename?: 'LocaleSlug',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<ISlug>,
  readonly en: Maybe<ISlug>,
  readonly fr: Maybe<ISlug>,
  readonly it: Maybe<ISlug>,
}

export interface ILocaleString {
  readonly __typename?: 'LocaleString',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<Scalars['String']>,
  readonly en: Maybe<Scalars['String']>,
  readonly fr: Maybe<Scalars['String']>,
  readonly it: Maybe<Scalars['String']>,
}

export interface ILocaleTypographyBlock {
  readonly __typename?: 'LocaleTypographyBlock',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly deRaw: Maybe<Scalars['JSON']>,
  readonly enRaw: Maybe<Scalars['JSON']>,
  readonly frRaw: Maybe<Scalars['JSON']>,
  readonly itRaw: Maybe<Scalars['JSON']>,
}

export interface ILocaleUrl {
  readonly __typename?: 'LocaleUrl',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly de: Maybe<Scalars['String']>,
  readonly en: Maybe<Scalars['String']>,
  readonly fr: Maybe<Scalars['String']>,
  readonly it: Maybe<Scalars['String']>,
}

export interface ILockedOffers  extends IDocument {
  readonly __typename?: 'LockedOffers',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface ILockedOffersFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ILockedOffersPanel {
  readonly __typename?: 'LockedOffersPanel',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly completedChallengeDescription: Maybe<ILocaleBlockContent>,
  readonly completedChallengeHeader: Maybe<ILocaleBlockContent>,
}

export interface ILoyaltyConfiguration  extends IDocument {
  readonly __typename?: 'LoyaltyConfiguration',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly bankMyRewardTier: Maybe<ITier>,
  readonly categories: Maybe<ReadonlyArray<Maybe<ICategory>>>,
  readonly defaultTier: Maybe<ITier>,
  readonly name: Maybe<ILocaleString>,
  readonly onboardingQuickSelectTiers: Maybe<ReadonlyArray<Maybe<ITier>>>,
}

export interface ILoyaltyConfigurationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly bankMyRewardTier?: Maybe<Scalars['ID']>,
  readonly defaultTier?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ILoyaltyContent  extends IDocument {
  readonly __typename?: 'LoyaltyContent',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly addCardHeaderText: Maybe<ILocaleString>,
  readonly addCardImage: Maybe<ILocaleImages>,
  readonly addCardSkipText: Maybe<ILocaleString>,
  readonly addCardTextBlock: Maybe<ILocaleBlockContent>,
  readonly birthdayLegalText: Maybe<ILocaleString>,
  readonly detailsIconFour: Maybe<ILocaleImage>,
  readonly detailsIconOne: Maybe<ILocaleImage>,
  readonly detailsIconThree: Maybe<ILocaleImage>,
  readonly detailsIconTwo: Maybe<ILocaleImage>,
  readonly detailsInstructionsFour: Maybe<ILocaleString>,
  readonly detailsInstructionsOne: Maybe<ILocaleString>,
  readonly detailsInstructionsThree: Maybe<ILocaleString>,
  readonly detailsInstructionsTwo: Maybe<ILocaleString>,
  readonly detailsPageHeroImage: Maybe<ILocaleImage>,
  readonly detailsPageHeroImageMobile: Maybe<ILocaleImage>,
  readonly detailsPageHeroImageWeb: Maybe<ILocaleImage>,
  readonly detailsSetupPageSubtext: Maybe<ILocaleString>,
  readonly detailsSetupPageText: Maybe<ILocaleString>,
  readonly detailsTabName: Maybe<ILocaleString>,
  readonly historyPageSubtext: Maybe<ILocaleString>,
  readonly historyPageText: Maybe<ILocaleString>,
  readonly historyTabName: Maybe<ILocaleString>,
  readonly lostCardSectionBlockText: Maybe<ILocaleBlockContent>,
  readonly lostCardSectionTitle: Maybe<ILocaleString>,
  readonly loyaltyCardSectionText: Maybe<ILocaleString>,
  readonly loyaltyCardSectionTitle: Maybe<ILocaleString>,
  readonly loyaltyProgramInstructionsBlockText: Maybe<ILocaleBlockContent>,
  readonly mainHeroLoyaltyImage: Maybe<ILocaleImage>,
  readonly mainHeroLoyaltySubtext: Maybe<ILocaleString>,
  readonly mainHeroLoyaltyText: Maybe<ILocaleString>,
  readonly name: Maybe<Scalars['String']>,
  readonly newPointsDisclaimerTextBlock: Maybe<ILocaleBlockContent>,
  readonly newPointsImage: Maybe<ILocaleImages>,
  readonly newPointsTextBlockBottom: Maybe<ILocaleBlockContent>,
  readonly newPointsTextBlockTop: Maybe<ILocaleBlockContent>,
  readonly onboardingBackgroundImage: Maybe<ILocaleImages>,
  readonly onboardingButtonLink: Maybe<Scalars['String']>,
  readonly onboardingButtonText: Maybe<ILocaleString>,
  readonly onboardingContentCardBackgroundImage: Maybe<ILocaleImages>,
  readonly onboardingImage: Maybe<ILocaleImages>,
  readonly onboardingTextBlock: Maybe<ILocaleBlockContent>,
  readonly onboardingTimsRewardHeaderImage: Maybe<ILocaleImages>,
  readonly pointsUpdateText: Maybe<ILocaleString>,
  readonly registerCardImage: Maybe<ILocaleImage>,
  readonly registerCardSectionBlockText: Maybe<ILocaleBlockContent>,
  readonly registerCardSectionTitle: Maybe<ILocaleString>,
  readonly rewardSetupPageBlockText: Maybe<ILocaleBlockContent>,
  readonly rewardSetupPageSubtext: Maybe<ILocaleString>,
  readonly rewardSetupPageText: Maybe<ILocaleString>,
  readonly rewardSetupTabName: Maybe<ILocaleString>,
  readonly rewardsUnavailableBlockText: Maybe<ILocaleBlockContent>,
  readonly seeMoreOptionsText: Maybe<ILocaleString>,
  readonly tierCardTextBlock: Maybe<ILocaleBlockContent>,
  readonly tierHeaderText: Maybe<ILocaleString>,
  readonly timsRewardsImage: Maybe<ILocaleImage>,
}

export interface ILoyaltyContentFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly onboardingButtonLink?: Maybe<Scalars['String']>,
  readonly onboardingButtonLink_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly onboardingButtonLink_matches?: Maybe<Scalars['String']>,
  readonly onboardingButtonLink_not?: Maybe<Scalars['String']>,
  readonly onboardingButtonLink_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ILoyaltyPoints {
  readonly __typename?: 'LoyaltyPoints',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly points: Maybe<Scalars['Float']>,
}

export interface ILoyaltyTranslations {
  readonly __typename?: 'LoyaltyTranslations',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly earnAndRedeem: Maybe<ILocaleString>,
  readonly freeAfterPurchases: Maybe<ILocaleString>,
  readonly get1Free: Maybe<ILocaleString>,
  readonly getRewardedPurchase: Maybe<ILocaleString>,
  readonly getRewardsAfter7: Maybe<ILocaleString>,
  readonly haveRewards: Maybe<ILocaleString>,
  readonly limitRewardsReached: Maybe<ILocaleString>,
  readonly loyaltyLegend: Maybe<ILocaleString>,
  readonly make7Purchases: Maybe<ILocaleString>,
  readonly myRewards: Maybe<ILocaleString>,
  readonly myTimsBalance: Maybe<ILocaleString>,
  readonly purchasesAwayFromRewards: Maybe<ILocaleString>,
  readonly rewardSavings: Maybe<ILocaleString>,
  readonly scanAtStore: Maybe<ILocaleString>,
  readonly scanForRewards: Maybe<ILocaleString>,
  readonly timsRewards: Maybe<ILocaleString>,
  readonly timsRewardsDetails: Maybe<ILocaleString>,
  readonly timsRewardsTerms: Maybe<ILocaleString>,
}

export interface ILoyaltyUi  extends IDocument {
  readonly __typename?: 'LoyaltyUI',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly noRewardPoints: Maybe<IEmptyState>,
  readonly notEnrolledState: Maybe<IEmptyState>,
  readonly optInModal: Maybe<IOptInModalContent>,
  readonly optInModalError: Maybe<IOptInModalContent>,
  readonly optInModalLoading: Maybe<IOptInModalLoading>,
}

export interface ILoyaltyUiFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly noRewardPoints?: Maybe<Scalars['ID']>,
  readonly notEnrolledState?: Maybe<Scalars['ID']>,
}

export interface IMainHero  extends IDocument {
  readonly __typename?: 'MainHero',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly action: Maybe<ILinkAction>,
  readonly actionLeft: Maybe<ILinkAction>,
  readonly actionLeftIcon: Maybe<ILocaleImage>,
  readonly actionRight: Maybe<ILinkAction>,
  readonly actionRightIcon: Maybe<ILocaleImage>,
  readonly image: Maybe<ILocaleImage>,
  readonly loyaltyAction: Maybe<ILinkAction>,
  readonly mainText: Maybe<ILocaleString>,
  readonly maskCards: Maybe<ReadonlyArray<Maybe<ISimpleCard>>>,
  readonly mobileImage: Maybe<ILocaleImage>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly subText: Maybe<ILocaleString>,
  readonly superText: Maybe<ILocaleString>,
  readonly textColor: Maybe<Scalars['String']>,
}

export interface IMainHeroFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly textColor?: Maybe<Scalars['String']>,
  readonly textColor_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly textColor_matches?: Maybe<Scalars['String']>,
  readonly textColor_not?: Maybe<Scalars['String']>,
  readonly textColor_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IMarketingTile  extends IDocument {
  readonly __typename?: 'MarketingTile',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<ILocaleImages>,
  readonly buttonAction: Maybe<ILinkAction>,
  readonly buttonAlignment: Maybe<Scalars['String']>,
  readonly textAlignment: Maybe<Scalars['String']>,
  readonly textBlock: Maybe<ILocaleTypographyBlock>,
  readonly textColor: Maybe<Scalars['String']>,
}

export interface IMarketingTileFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly buttonAlignment?: Maybe<Scalars['String']>,
  readonly buttonAlignment_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly buttonAlignment_matches?: Maybe<Scalars['String']>,
  readonly buttonAlignment_not?: Maybe<Scalars['String']>,
  readonly buttonAlignment_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly textAlignment?: Maybe<Scalars['String']>,
  readonly textAlignment_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly textAlignment_matches?: Maybe<Scalars['String']>,
  readonly textAlignment_not?: Maybe<Scalars['String']>,
  readonly textAlignment_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly textColor?: Maybe<Scalars['String']>,
  readonly textColor_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly textColor_matches?: Maybe<Scalars['String']>,
  readonly textColor_not?: Maybe<Scalars['String']>,
  readonly textColor_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IMarketingTileGroup  extends IDocument {
  readonly __typename?: 'MarketingTileGroup',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly tiles: Maybe<ReadonlyArray<Maybe<IMarketingTileOrMarketingTilePair>>>,
}

export interface IMarketingTileGroupFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export type IMarketingTileOrMarketingTilePair = IMarketingTile | IMarketingTilePair;

export interface IMarketingTilePair {
  readonly __typename?: 'MarketingTilePair',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly left: Maybe<IMarketingTile>,
  readonly right: Maybe<IMarketingTile>,
}

export interface IMenu  extends IDocument {
  readonly __typename?: 'Menu',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly headerSuperText: Maybe<ILocaleString>,
  readonly headerText: Maybe<ILocaleString>,
  readonly image: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IComboOrItemOrPickerOrSection>>>,
  readonly pickerBackgroundImage: Maybe<IImage>,
}

export interface IMenuFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IModifier  extends IDocument {
  readonly __typename?: 'Modifier',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly image: Maybe<IImage>,
  readonly images: Maybe<IImages>,
  readonly name: Maybe<ILocaleString>,
  readonly specificationName: Maybe<Scalars['String']>,
  readonly specificationNumber: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IModifierFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly specificationName?: Maybe<Scalars['String']>,
  readonly specificationName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly specificationName_matches?: Maybe<Scalars['String']>,
  readonly specificationName_not?: Maybe<Scalars['String']>,
  readonly specificationName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly specificationNumber?: Maybe<Scalars['String']>,
  readonly specificationNumber_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly specificationNumber_matches?: Maybe<Scalars['String']>,
  readonly specificationNumber_not?: Maybe<Scalars['String']>,
  readonly specificationNumber_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IModifierMultiplier  extends IDocument {
  readonly __typename?: 'ModifierMultiplier',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly modifier: Maybe<IModifier>,
  readonly multiplier: Maybe<Scalars['Float']>,
  readonly prefix: Maybe<ILocaleString>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IModifierMultiplierFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly modifier?: Maybe<Scalars['ID']>,
  readonly multiplier?: Maybe<Scalars['Float']>,
  readonly multiplier_gt?: Maybe<Scalars['Float']>,
  readonly multiplier_gte?: Maybe<Scalars['Float']>,
  readonly multiplier_lt?: Maybe<Scalars['Float']>,
  readonly multiplier_lte?: Maybe<Scalars['Float']>,
  readonly multiplier_not?: Maybe<Scalars['Float']>,
}

export interface IMultipleScreensTranslations {
  readonly __typename?: 'MultipleScreensTranslations',
  readonly RestaurantNickname: Maybe<ILocaleString>,
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly addTimCard: Maybe<ILocaleString>,
  readonly addTimmyMe: Maybe<ILocaleString>,
  readonly canada: Maybe<ILocaleString>,
  readonly codeSentTo: Maybe<ILocaleString>,
  readonly comboOfferSavings: Maybe<ILocaleString>,
  readonly enjoyOurApp: Maybe<ILocaleString>,
  readonly findATims: Maybe<ILocaleString>,
  readonly leaveUsAReview: Maybe<ILocaleString>,
  readonly loadAndPlaceOrder: Maybe<ILocaleString>,
  readonly locationOnForApp: Maybe<ILocaleString>,
  readonly loyalty: Maybe<ILocaleString>,
  readonly myRewards: Maybe<ILocaleString>,
  readonly newAvailableVersion: Maybe<ILocaleString>,
  readonly notUseWhileDriving: Maybe<ILocaleString>,
  readonly resendVerificationCode: Maybe<ILocaleString>,
  readonly reward: Maybe<ILocaleString>,
  readonly rewardYourRoutine: Maybe<ILocaleString>,
  readonly sendVerificationCode: Maybe<ILocaleString>,
  readonly sendingCode: Maybe<ILocaleString>,
  readonly slowNetwork: Maybe<ILocaleString>,
  readonly sorry: Maybe<ILocaleString>,
  readonly useAReward: Maybe<ILocaleString>,
  readonly zoomToFindCloseTims: Maybe<ILocaleString>,
}

export interface IMultiWidget {
  readonly __typename?: 'MultiWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly widget: Maybe<Scalars['String']>,
}

export interface INavigationDesktop {
  readonly __typename?: 'NavigationDesktop',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly aboutMenuEntries: Maybe<INavigationSection>,
  readonly navigationLinks: Maybe<ReadonlyArray<Maybe<INavigationDesktopLink>>>,
}

export interface INavigationDesktopLink {
  readonly __typename?: 'NavigationDesktopLink',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly navLink: Maybe<ILinkWidget>,
}

export interface INavigationMobile {
  readonly __typename?: 'NavigationMobile',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly aboutMenuEntries: Maybe<INavigationSection>,
  readonly navigationTabs: Maybe<ReadonlyArray<Maybe<INavigationMobileTab>>>,
}

export interface INavigationMobileTab {
  readonly __typename?: 'NavigationMobileTab',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly tabIcon: Maybe<ILocaleImage>,
  readonly tabIconActive: Maybe<ILocaleImage>,
  readonly tabLink: Maybe<ILinkWidget>,
}

export interface INavigationSection  extends IDocument {
  readonly __typename?: 'NavigationSection',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<ILocaleString>,
  readonly pages: Maybe<ReadonlyArray<Maybe<INavigationSectionOrStaticPage>>>,
}

export interface INavigationSectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export type INavigationSectionOrStaticPage = INavigationSection | IStaticPage;

export interface INutrition {
  readonly __typename?: 'Nutrition',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly calories: Maybe<Scalars['Float']>,
  readonly caloriesPer100: Maybe<Scalars['Float']>,
  readonly carbohydrates: Maybe<Scalars['Float']>,
  readonly carbohydratesPer100: Maybe<Scalars['Float']>,
  readonly cholesterol: Maybe<Scalars['Float']>,
  readonly energyKJ: Maybe<Scalars['Float']>,
  readonly energyKJPer100: Maybe<Scalars['Float']>,
  readonly fat: Maybe<Scalars['Float']>,
  readonly fatPer100: Maybe<Scalars['Float']>,
  readonly fiber: Maybe<Scalars['Float']>,
  readonly proteins: Maybe<Scalars['Float']>,
  readonly proteinsPer100: Maybe<Scalars['Float']>,
  readonly salt: Maybe<Scalars['Float']>,
  readonly saltPer100: Maybe<Scalars['Float']>,
  readonly saturatedFat: Maybe<Scalars['Float']>,
  readonly saturatedFatPer100: Maybe<Scalars['Float']>,
  readonly sodium: Maybe<Scalars['Float']>,
  readonly sugar: Maybe<Scalars['Float']>,
  readonly sugarPer100: Maybe<Scalars['Float']>,
  readonly transFat: Maybe<Scalars['Float']>,
  readonly weight: Maybe<Scalars['Float']>,
}

export interface INutritionalSection  extends IDocument {
  readonly __typename?: 'NutritionalSection',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<ILocaleString>,
  readonly products: Maybe<ReadonlyArray<Maybe<IItemOrNutritionalSection>>>,
}

export interface INutritionalSectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface INutritionExplorerWidget {
  readonly __typename?: 'NutritionExplorerWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly categoryWhitelist: Maybe<ReadonlyArray<Maybe<IPickerOrSection>>>,
  readonly madLibFilterGroup: Maybe<IFilterGroup>,
  readonly menu: Maybe<IMenu>,
  readonly modalFilterGroups: Maybe<ReadonlyArray<Maybe<IFilterGroup>>>,
  readonly moreOptionsButtonText: Maybe<ILocaleString>,
  readonly tastySwaps: Maybe<ITastySwaps>,
  readonly viewMenuButtonText: Maybe<ILocaleString>,
}

export interface INutritionInfoWidget {
  readonly __typename?: 'NutritionInfoWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly nutritionalSection: Maybe<INutritionalSection>,
}

export interface INutritionItem {
  readonly __typename?: 'NutritionItem',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly additionalItems: Maybe<ReadonlyArray<Maybe<INutritionItem>>>,
  readonly name: Maybe<ILocaleString>,
  readonly nutritionKey: Maybe<Scalars['String']>,
  readonly unit: Maybe<ILocaleString>,
}

export interface INutritionItemGroup {
  readonly __typename?: 'NutritionItemGroup',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly lineItems: Maybe<ReadonlyArray<Maybe<INutritionItem>>>,
  readonly mainItem: Maybe<INutritionItem>,
}

export type INutritionItemOrNutritionItemGroup = INutritionItem | INutritionItemGroup;

export interface INutritionTable {
  readonly __typename?: 'NutritionTable',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly items: Maybe<ReadonlyArray<Maybe<INutritionItemOrNutritionItemGroup>>>,
  readonly title: Maybe<ILocaleString>,
}

export interface IOffer  extends IDocument {
  readonly __typename?: 'Offer',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly activationDate: Maybe<Scalars['Date']>,
  readonly backgroundImage: Maybe<IImage>,
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly daypart: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly deactivationDate: Maybe<Scalars['Date']>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly dmbName: Maybe<ILocaleString>,
  readonly forSupport: Maybe<Scalars['Boolean']>,
  readonly headerSuperText: Maybe<ILocaleString>,
  readonly howToRedeem: Maybe<ILocaleBlockContent>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly images: Maybe<IImages>,
  readonly incentives: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferActivationOrOfferDiscountOrOfferItemDiscountOrOfferLoyaltyActionOrPicker>>>,
  readonly localizedImage: Maybe<ILocaleImages>,
  readonly lockedOffersPanel: Maybe<ILockedOffersPanel>,
  readonly marketPrice: Maybe<IComboOrItem>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly mustBeAssigned: Maybe<Scalars['Boolean']>,
  readonly name: Maybe<ILocaleBlockContent>,
  readonly offerCTA: Maybe<ILinkAction>,
  readonly offerPrice: Maybe<Scalars['Float']>,
  readonly option: Maybe<IComboOrItemOrOfferActivationOrOfferDiscountOrPicker>,
  readonly percentageDiscount: Maybe<Scalars['Boolean']>,
  readonly prices: Maybe<ReadonlyArray<Maybe<IPricingRegionPrice>>>,
  readonly promoCodePanel: Maybe<IPromoCodePanel>,
  readonly requirements: Maybe<IRequirements>,
  readonly ruleSet: Maybe<ReadonlyArray<Maybe<IAllowRedemptionWithoutLoginOrAndOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrOrOrOrderHistoryOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions>>>,
  readonly shortCode: Maybe<Scalars['String']>,
  readonly uiPattern: Maybe<Scalars['String']>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
  readonly vendorPlus: Maybe<IVendorPlus>,
}

export interface IOfferActivation  extends IDocument {
  readonly __typename?: 'OfferActivation',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly fakeField: Maybe<Scalars['Boolean']>,
}

export interface IOfferActivationFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly fakeField?: Maybe<Scalars['Boolean']>,
  readonly fakeField_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IOfferDiscount  extends IDocument {
  readonly __typename?: 'OfferDiscount',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly discountType: Maybe<Scalars['String']>,
  readonly discountValue: Maybe<Scalars['Float']>,
}

export interface IOfferDiscountFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly discountType?: Maybe<Scalars['String']>,
  readonly discountType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly discountType_matches?: Maybe<Scalars['String']>,
  readonly discountType_not?: Maybe<Scalars['String']>,
  readonly discountType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly discountValue?: Maybe<Scalars['Float']>,
  readonly discountValue_gt?: Maybe<Scalars['Float']>,
  readonly discountValue_gte?: Maybe<Scalars['Float']>,
  readonly discountValue_lt?: Maybe<Scalars['Float']>,
  readonly discountValue_lte?: Maybe<Scalars['Float']>,
  readonly discountValue_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IOfferFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly activationDate?: Maybe<Scalars['Date']>,
  readonly activationDate_gt?: Maybe<Scalars['Date']>,
  readonly activationDate_gte?: Maybe<Scalars['Date']>,
  readonly activationDate_lt?: Maybe<Scalars['Date']>,
  readonly activationDate_lte?: Maybe<Scalars['Date']>,
  readonly activationDate_not?: Maybe<Scalars['Date']>,
  readonly deactivationDate?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_gte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lt?: Maybe<Scalars['Date']>,
  readonly deactivationDate_lte?: Maybe<Scalars['Date']>,
  readonly deactivationDate_not?: Maybe<Scalars['Date']>,
  readonly forSupport?: Maybe<Scalars['Boolean']>,
  readonly forSupport_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly marketPrice?: Maybe<Scalars['ID']>,
  readonly mustBeAssigned?: Maybe<Scalars['Boolean']>,
  readonly mustBeAssigned_not?: Maybe<Scalars['Boolean']>,
  readonly offerPrice?: Maybe<Scalars['Float']>,
  readonly offerPrice_gt?: Maybe<Scalars['Float']>,
  readonly offerPrice_gte?: Maybe<Scalars['Float']>,
  readonly offerPrice_lt?: Maybe<Scalars['Float']>,
  readonly offerPrice_lte?: Maybe<Scalars['Float']>,
  readonly offerPrice_not?: Maybe<Scalars['Float']>,
  readonly option?: Maybe<Scalars['ID']>,
  readonly percentageDiscount?: Maybe<Scalars['Boolean']>,
  readonly percentageDiscount_not?: Maybe<Scalars['Boolean']>,
  readonly shortCode?: Maybe<Scalars['String']>,
  readonly shortCode_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly shortCode_matches?: Maybe<Scalars['String']>,
  readonly shortCode_not?: Maybe<Scalars['String']>,
  readonly shortCode_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IOfferItemDiscount  extends IDocument {
  readonly __typename?: 'OfferItemDiscount',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly discountType: Maybe<Scalars['String']>,
  readonly discountValue: Maybe<Scalars['Float']>,
  readonly option: Maybe<IComboOrItemOrPicker>,
}

export interface IOfferItemDiscountFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly discountType?: Maybe<Scalars['String']>,
  readonly discountType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly discountType_matches?: Maybe<Scalars['String']>,
  readonly discountType_not?: Maybe<Scalars['String']>,
  readonly discountType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly discountValue?: Maybe<Scalars['Float']>,
  readonly discountValue_gt?: Maybe<Scalars['Float']>,
  readonly discountValue_gte?: Maybe<Scalars['Float']>,
  readonly discountValue_lt?: Maybe<Scalars['Float']>,
  readonly discountValue_lte?: Maybe<Scalars['Float']>,
  readonly discountValue_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly option?: Maybe<Scalars['ID']>,
}

export interface IOfferLoyaltyAction  extends IDocument {
  readonly __typename?: 'OfferLoyaltyAction',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly loyaltyType: Maybe<Scalars['String']>,
  readonly loyaltyValue: Maybe<Scalars['Float']>,
}

export interface IOfferLoyaltyActionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyType?: Maybe<Scalars['String']>,
  readonly loyaltyType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyType_matches?: Maybe<Scalars['String']>,
  readonly loyaltyType_not?: Maybe<Scalars['String']>,
  readonly loyaltyType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyValue?: Maybe<Scalars['Float']>,
  readonly loyaltyValue_gt?: Maybe<Scalars['Float']>,
  readonly loyaltyValue_gte?: Maybe<Scalars['Float']>,
  readonly loyaltyValue_lt?: Maybe<Scalars['Float']>,
  readonly loyaltyValue_lte?: Maybe<Scalars['Float']>,
  readonly loyaltyValue_not?: Maybe<Scalars['Float']>,
}

export interface IOfferRequirementCode {
  readonly __typename?: 'OfferRequirementCode',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly shortCode: Maybe<Scalars['String']>,
}

export interface IOfferRequirementPlatform {
  readonly __typename?: 'OfferRequirementPlatform',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly platform: Maybe<Scalars['String']>,
}

export interface IOfferRequirementPurchase {
  readonly __typename?: 'OfferRequirementPurchase',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly option: Maybe<IComboOrItem>,
}

export interface IOfferRequirementUser {
  readonly __typename?: 'OfferRequirementUser',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly status: Maybe<Scalars['String']>,
}

export interface IOffersBrowsingPanel {
  readonly __typename?: 'OffersBrowsingPanel',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly emptyStateBody: Maybe<ILocaleString>,
  readonly emptyStateImage: Maybe<ILocaleImage>,
  readonly emptyStateTitle: Maybe<ILocaleString>,
  readonly endOfOffersImage: Maybe<ILocaleImage>,
  readonly endOfOffersMessage: Maybe<ILocaleString>,
  readonly offersSelectRestaurantCta: Maybe<IOffersSelectRestaurantCta>,
}

export interface IOffersDetailsPanel {
  readonly __typename?: 'OffersDetailsPanel',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly emptyStateAction: Maybe<ILinkAction>,
  readonly emptyStateBody: Maybe<ILocaleString>,
  readonly emptyStateImage: Maybe<ILocaleImage>,
  readonly emptyStateTitle: Maybe<ILocaleString>,
  readonly missingOfferAction: Maybe<ILinkAction>,
  readonly missingOfferBody: Maybe<ILocaleString>,
  readonly missingOfferImage: Maybe<ILocaleImage>,
  readonly missingOfferTitle: Maybe<ILocaleString>,
}

export interface IOffersFeedbackTranslations {
  readonly __typename?: 'OffersFeedbackTranslations',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly genericOffersFeedback: Maybe<ILocaleString>,
  readonly insufficientSubtotal: Maybe<ILocaleString>,
}

export interface IOffersSection  extends IDocument {
  readonly __typename?: 'OffersSection',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IOffersSectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IOffersSelectRestaurantCta {
  readonly __typename?: 'OffersSelectRestaurantCta',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly ctaButtonText: Maybe<ILocaleString>,
  readonly link: Maybe<ILocaleUrl>,
  readonly minimumNumberOfOffers: Maybe<Scalars['Float']>,
  readonly title: Maybe<ILocaleString>,
}

export interface IOfferTemplateMvp  extends IDocument {
  readonly __typename?: 'OfferTemplateMvp',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly offerReference: Maybe<IOffer>,
  readonly position: Maybe<Scalars['Boolean']>,
}

export interface IOfferTemplateMvpFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly offerReference?: Maybe<Scalars['ID']>,
  readonly position?: Maybe<Scalars['Boolean']>,
  readonly position_not?: Maybe<Scalars['Boolean']>,
}

export interface IOpAllergen {
  readonly __typename?: 'OpAllergen',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly celery: Maybe<Scalars['Float']>,
  readonly eggs: Maybe<Scalars['Float']>,
  readonly fish: Maybe<Scalars['Float']>,
  readonly gluten: Maybe<Scalars['Float']>,
  readonly lupin: Maybe<Scalars['Float']>,
  readonly milk: Maybe<Scalars['Float']>,
  readonly mustard: Maybe<Scalars['Float']>,
  readonly peanuts: Maybe<Scalars['Float']>,
  readonly sesame: Maybe<Scalars['Float']>,
  readonly shellfish: Maybe<Scalars['Float']>,
  readonly soy: Maybe<Scalars['Float']>,
  readonly sulphurDioxide: Maybe<Scalars['Float']>,
  readonly treeNuts: Maybe<Scalars['Float']>,
  readonly wheat: Maybe<Scalars['Float']>,
}

export interface IOpItem {
  readonly __typename?: 'OpItem',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly daypart: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly launchDate: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly product: Maybe<Scalars['String']>,
  readonly productNumber: Maybe<Scalars['Float']>,
}

export interface IOpPricingRegion  extends IDocument {
  readonly __typename?: 'OpPricingRegion',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<Scalars['String']>,
  readonly restaurants: Maybe<ReadonlyArray<Maybe<IRestaurant>>>,
}

export interface IOpPricingRegionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IOptInModalContent {
  readonly __typename?: 'OptInModalContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly buttonText: Maybe<ILocaleString>,
  readonly description: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImages>,
  readonly title: Maybe<ILocaleString>,
}

export interface IOptInModalLoading {
  readonly __typename?: 'OptInModalLoading',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface IOptInSettingBoolean {
  readonly __typename?: 'OptInSettingBoolean',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly key: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
}

export type IOptInSettingBooleanOrOptInSettingEmailAndPushOrOptInSettingEnum = IOptInSettingBoolean | IOptInSettingEmailAndPush | IOptInSettingEnum;

export interface IOptInSettingEmailAndPush {
  readonly __typename?: 'OptInSettingEmailAndPush',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly emailKey: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
  readonly pushKey: Maybe<Scalars['String']>,
}

export interface IOptInSettingEnum {
  readonly __typename?: 'OptInSettingEnum',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly enumStrings: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly key: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
}

export interface IOptionVisibilitySettings {
  readonly __typename?: 'OptionVisibilitySettings',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly toggleButtonTextClosed: Maybe<ILocaleString>,
  readonly toggleButtonTextOpen: Maybe<ILocaleString>,
  readonly visibleOptions: Maybe<Scalars['Float']>,
}

export interface IOr {
  readonly __typename?: 'Or',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly ruleSet: Maybe<ReadonlyArray<Maybe<IAllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions>>>,
}

export interface IOrderHistory {
  readonly __typename?: 'OrderHistory',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly from: Maybe<Scalars['Date']>,
  readonly isSequential: Maybe<Scalars['Boolean']>,
  readonly lastNSeconds: Maybe<Scalars['Float']>,
  readonly rangeType: Maybe<Scalars['String']>,
  readonly ruleSet: Maybe<ReadonlyArray<Maybe<IAndOrBetweenTimesOrCartContainsPluOrCartPropertyOrDayOfWeekBandOrOrOrPaymentCardTypeOrPurchase>>>,
  readonly to: Maybe<Scalars['Date']>,
}

export interface IOrderPreparationTranslations {
  readonly __typename?: 'OrderPreparationTranslations',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly iAmDrivingFull: Maybe<ILocaleString>,
  readonly iAmWalking: Maybe<ILocaleString>,
  readonly iAmWalkingFull: Maybe<ILocaleString>,
  readonly keepYouNotified: Maybe<ILocaleString>,
  readonly orderLimitReached: Maybe<ILocaleString>,
}

export interface IOurServices  extends IDocument {
  readonly __typename?: 'OurServices',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly ourServicesHeroImageLocale: Maybe<ILocaleImage>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly servicesHeaderTextLocale: Maybe<ILocaleString>,
  readonly servicesHeroTextLocale: Maybe<ILocaleString>,
}

export interface IOurServicesFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IParentChildPlu {
  readonly __typename?: 'ParentChildPlu',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly childPlu: Maybe<Scalars['String']>,
  readonly plu: Maybe<Scalars['String']>,
}

export interface IPaymentCardType {
  readonly __typename?: 'PaymentCardType',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly cardType: Maybe<Scalars['String']>,
}

export interface IPaymentScreenTranslations {
  readonly __typename?: 'PaymentScreenTranslations',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly availableScanToPay: Maybe<ILocaleString>,
  readonly scanQRCode: Maybe<ILocaleString>,
  readonly scanToPay: Maybe<ILocaleString>,
}

export interface IPicker  extends IDocument {
  readonly __typename?: 'Picker',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly dmbName: Maybe<ILocaleString>,
  readonly image: Maybe<IImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly images: Maybe<IImages>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IPickerOption>>>,
  readonly pickerAspectItemOptionMappings: Maybe<ReadonlyArray<Maybe<IPickerAspectItemOptions>>>,
  readonly pickerAspects: Maybe<ReadonlyArray<Maybe<IPickerAspect>>>,
  readonly pickerDefaults: Maybe<ReadonlyArray<Maybe<IPickerItemMapping>>>,
  readonly quickConfigs: Maybe<ReadonlyArray<Maybe<IQuickConfig>>>,
  readonly showInStaticMenu: Maybe<Scalars['Boolean']>,
  readonly uiPattern: Maybe<Scalars['String']>,
}

export interface IPickerAspect  extends IDocument {
  readonly __typename?: 'PickerAspect',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<ILocaleString>,
  readonly pickerAspectOptions: Maybe<ReadonlyArray<Maybe<IPickerAspectValue>>>,
  readonly uiPattern: Maybe<Scalars['String']>,
}

export interface IPickerAspectFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IPickerAspectItemOptions {
  readonly __typename?: 'PickerAspectItemOptions',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly options: Maybe<ReadonlyArray<Maybe<IListItem>>>,
  readonly pickerAspect: Maybe<IPickerAspect>,
}

export interface IPickerAspectValue {
  readonly __typename?: 'PickerAspectValue',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly hideNameInItemPreview: Maybe<Scalars['Boolean']>,
  readonly identifier: Maybe<Scalars['String']>,
  readonly image: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
}

export interface IPickerFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu_not?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IPickerItemMapping {
  readonly __typename?: 'PickerItemMapping',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly pickerAspect: Maybe<IPickerAspect>,
  readonly pickerAspectValueIdentifier: Maybe<Scalars['String']>,
}

export interface IPickerOption {
  readonly __typename?: 'PickerOption',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly default: Maybe<Scalars['Boolean']>,
  readonly option: Maybe<IComboOrItem>,
  readonly pickerItemMappings: Maybe<ReadonlyArray<Maybe<IPickerItemMapping>>>,
}

export type IPickerOrSection = IPicker | ISection;

export interface IPlu {
  readonly __typename?: 'Plu',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly plu: Maybe<Scalars['String']>,
  readonly qualifier: Maybe<Scalars['String']>,
  readonly quantity: Maybe<Scalars['Float']>,
}

export interface IPluData {
  readonly __typename?: 'PluData',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly available: Maybe<Scalars['Boolean']>,
  readonly pluNumber: Maybe<Scalars['Float']>,
  readonly price: Maybe<Scalars['Float']>,
}

export interface IPos {
  readonly __typename?: 'Pos',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly vendor: Maybe<Scalars['String']>,
  readonly version: Maybe<Scalars['String']>,
}

export interface IPreviewEntry {
  readonly __typename?: 'PreviewEntry',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly bodyText: Maybe<ILocaleString>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly linkText: Maybe<ILocaleString>,
  readonly linkURL: Maybe<Scalars['String']>,
  readonly previewImage: Maybe<ILocaleImage>,
  readonly titleText: Maybe<ILocaleString>,
}

export interface IPreviewWidget {
  readonly __typename?: 'PreviewWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly previewContent: Maybe<ReadonlyArray<Maybe<IPreviewEntry>>>,
}

export interface IPricingRegionPrice {
  readonly __typename?: 'PricingRegionPrice',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly opPricingRegion: Maybe<IOpPricingRegion>,
  readonly price: Maybe<Scalars['Float']>,
}

export interface IPrizes {
  readonly __typename?: 'Prizes',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly buttonText: Maybe<ILocaleBlockContent>,
  readonly excludeInAlberta: Maybe<Scalars['Boolean']>,
  readonly header: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<ILocaleImages>,
  readonly numberAwarded: Maybe<ILocaleBlockContent>,
  readonly text: Maybe<ILocaleBlockContent>,
}

export interface IProductCategory  extends IDocument {
  readonly __typename?: 'ProductCategory',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly hierarchyLevel: Maybe<Scalars['String']>,
  readonly image: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
}

export interface IProductCategoryFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly hierarchyLevel?: Maybe<Scalars['String']>,
  readonly hierarchyLevel_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly hierarchyLevel_matches?: Maybe<Scalars['String']>,
  readonly hierarchyLevel_not?: Maybe<Scalars['String']>,
  readonly hierarchyLevel_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IPromoCodePanel {
  readonly __typename?: 'PromoCodePanel',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly campaignId: Maybe<Scalars['String']>,
  readonly promoCodeDescription: Maybe<ILocaleBlockContent>,
  readonly promoCodeLabel: Maybe<ILocaleBlockContent>,
  readonly promoCodeLink: Maybe<Scalars['String']>,
}

export interface IPurchase {
  readonly __typename?: 'Purchase',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly option: Maybe<IComboOrItemOrPickerOrProductCategory>,
  readonly quantity: Maybe<Scalars['Float']>,
  readonly sanityId: Maybe<Scalars['String']>,
}

export interface IQuestionDetails  extends IDocument {
  readonly __typename?: 'QuestionDetails',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly countdownTimer: Maybe<Scalars['Float']>,
  readonly responses: Maybe<ReadonlyArray<Maybe<IResponseDetails>>>,
  readonly text: Maybe<ILocaleString>,
}

export interface IQuestionDetailsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly countdownTimer?: Maybe<Scalars['Float']>,
  readonly countdownTimer_gt?: Maybe<Scalars['Float']>,
  readonly countdownTimer_gte?: Maybe<Scalars['Float']>,
  readonly countdownTimer_lt?: Maybe<Scalars['Float']>,
  readonly countdownTimer_lte?: Maybe<Scalars['Float']>,
  readonly countdownTimer_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IQuickConfig {
  readonly __typename?: 'QuickConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
  readonly rules: Maybe<ReadonlyArray<Maybe<IQuickConfigRule>>>,
}

export interface IQuickConfigRule {
  readonly __typename?: 'QuickConfigRule',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly itemOptions: Maybe<ReadonlyArray<Maybe<IListItem>>>,
  readonly modifier: Maybe<IListItem>,
}

export interface IQuoteWidget {
  readonly __typename?: 'QuoteWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly attributionImage: Maybe<IImage>,
  readonly attributionName: Maybe<Scalars['String']>,
  readonly attributionTitle: Maybe<ILocaleString>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly quoteText: Maybe<ILocaleString>,
}

export interface IRecentItems  extends IDocument {
  readonly __typename?: 'RecentItems',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IRecentItemsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRequirements {
  readonly __typename?: 'Requirements',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly platform: Maybe<Scalars['String']>,
  readonly purchase: Maybe<IComboOrItemOrPickerOrSection>,
  readonly shortCode: Maybe<Scalars['String']>,
  readonly status: Maybe<Scalars['String']>,
}

export interface IRequiresAssignment {
  readonly __typename?: 'RequiresAssignment',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly requiresAssignment: Maybe<Scalars['String']>,
}

export interface IResponseDetails  extends IDocument {
  readonly __typename?: 'ResponseDetails',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly content: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly resultsValuesDetails: Maybe<ReadonlyArray<Maybe<IResultValueDetails>>>,
  readonly text: Maybe<ILocaleString>,
}

export interface IResponseDetailsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IRestaurant  extends IDocument {
  readonly __typename?: 'Restaurant',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly adi: Maybe<Scalars['String']>,
  readonly chaseMerchantId: Maybe<Scalars['String']>,
  readonly curbsideHours: Maybe<IHoursOfOperation>,
  readonly deliveryHours: Maybe<IHoursOfOperation>,
  readonly diningRoomHours: Maybe<IHoursOfOperation>,
  readonly drinkStationType: Maybe<Scalars['String']>,
  readonly driveThruHours: Maybe<IHoursOfOperation>,
  readonly driveThruLaneType: Maybe<Scalars['String']>,
  readonly email: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly environment: Maybe<Scalars['String']>,
  readonly franchiseGroupId: Maybe<Scalars['Float']>,
  readonly franchiseGroupName: Maybe<Scalars['String']>,
  readonly frontCounterClosed: Maybe<Scalars['Boolean']>,
  readonly googleOrderingStatus: Maybe<Scalars['String']>,
  readonly hasBreakfast: Maybe<Scalars['Boolean']>,
  readonly hasBurgersForBreakfast: Maybe<Scalars['Boolean']>,
  readonly hasCatering: Maybe<Scalars['Boolean']>,
  readonly hasCurbside: Maybe<Scalars['Boolean']>,
  readonly hasDMBSuggestiveSelling: Maybe<Scalars['Boolean']>,
  readonly hasDelivery: Maybe<Scalars['Boolean']>,
  readonly hasDineIn: Maybe<Scalars['Boolean']>,
  readonly hasDriveThru: Maybe<Scalars['Boolean']>,
  readonly hasMobileOrdering: Maybe<Scalars['Boolean']>,
  readonly hasModifiedTakeout: Maybe<Scalars['Boolean']>,
  readonly hasParking: Maybe<Scalars['Boolean']>,
  readonly hasPlayground: Maybe<Scalars['Boolean']>,
  readonly hasTakeOut: Maybe<Scalars['Boolean']>,
  readonly hasWifi: Maybe<Scalars['Boolean']>,
  readonly hideInEnvironments: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly isDarkKitchen: Maybe<Scalars['Boolean']>,
  readonly landmark: Maybe<ILocaleString>,
  readonly lastModifiedTime: Maybe<Scalars['DateTime']>,
  readonly latitude: Maybe<Scalars['Float']>,
  readonly longitude: Maybe<Scalars['Float']>,
  readonly mobileOrderingStatus: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly nbrDriveThruWindows: Maybe<Scalars['Float']>,
  readonly number: Maybe<Scalars['String']>,
  readonly ownership: Maybe<Scalars['String']>,
  readonly parkingType: Maybe<Scalars['String']>,
  readonly phoneNumber: Maybe<Scalars['String']>,
  readonly physicalAddress: Maybe<IAddress>,
  readonly playgroundType: Maybe<Scalars['String']>,
  readonly pos: Maybe<IPos>,
  readonly posRestaurantId: Maybe<Scalars['String']>,
  readonly restaurantImage: Maybe<IImage>,
  readonly restaurantKioskData: Maybe<IRestaurantKioskData>,
  readonly restaurantPosData: Maybe<IRestaurantPosData>,
  readonly servicesHasDriveThru: Maybe<Scalars['Boolean']>,
  readonly status: Maybe<Scalars['String']>,
  readonly timezone: Maybe<Scalars['String']>,
}

export interface IRestaurantFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly adi?: Maybe<Scalars['String']>,
  readonly adi_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly adi_matches?: Maybe<Scalars['String']>,
  readonly adi_not?: Maybe<Scalars['String']>,
  readonly adi_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly chaseMerchantId?: Maybe<Scalars['String']>,
  readonly chaseMerchantId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly chaseMerchantId_matches?: Maybe<Scalars['String']>,
  readonly chaseMerchantId_not?: Maybe<Scalars['String']>,
  readonly chaseMerchantId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly drinkStationType?: Maybe<Scalars['String']>,
  readonly drinkStationType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly drinkStationType_matches?: Maybe<Scalars['String']>,
  readonly drinkStationType_not?: Maybe<Scalars['String']>,
  readonly drinkStationType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly driveThruLaneType?: Maybe<Scalars['String']>,
  readonly driveThruLaneType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly driveThruLaneType_matches?: Maybe<Scalars['String']>,
  readonly driveThruLaneType_not?: Maybe<Scalars['String']>,
  readonly driveThruLaneType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly environment?: Maybe<Scalars['String']>,
  readonly environment_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly environment_matches?: Maybe<Scalars['String']>,
  readonly environment_not?: Maybe<Scalars['String']>,
  readonly environment_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly franchiseGroupId?: Maybe<Scalars['Float']>,
  readonly franchiseGroupId_gt?: Maybe<Scalars['Float']>,
  readonly franchiseGroupId_gte?: Maybe<Scalars['Float']>,
  readonly franchiseGroupId_lt?: Maybe<Scalars['Float']>,
  readonly franchiseGroupId_lte?: Maybe<Scalars['Float']>,
  readonly franchiseGroupId_not?: Maybe<Scalars['Float']>,
  readonly franchiseGroupName?: Maybe<Scalars['String']>,
  readonly franchiseGroupName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly franchiseGroupName_matches?: Maybe<Scalars['String']>,
  readonly franchiseGroupName_not?: Maybe<Scalars['String']>,
  readonly franchiseGroupName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly frontCounterClosed?: Maybe<Scalars['Boolean']>,
  readonly frontCounterClosed_not?: Maybe<Scalars['Boolean']>,
  readonly googleOrderingStatus?: Maybe<Scalars['String']>,
  readonly googleOrderingStatus_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly googleOrderingStatus_matches?: Maybe<Scalars['String']>,
  readonly googleOrderingStatus_not?: Maybe<Scalars['String']>,
  readonly googleOrderingStatus_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly hasBreakfast?: Maybe<Scalars['Boolean']>,
  readonly hasBreakfast_not?: Maybe<Scalars['Boolean']>,
  readonly hasBurgersForBreakfast?: Maybe<Scalars['Boolean']>,
  readonly hasBurgersForBreakfast_not?: Maybe<Scalars['Boolean']>,
  readonly hasCatering?: Maybe<Scalars['Boolean']>,
  readonly hasCatering_not?: Maybe<Scalars['Boolean']>,
  readonly hasCurbside?: Maybe<Scalars['Boolean']>,
  readonly hasCurbside_not?: Maybe<Scalars['Boolean']>,
  readonly hasDMBSuggestiveSelling?: Maybe<Scalars['Boolean']>,
  readonly hasDMBSuggestiveSelling_not?: Maybe<Scalars['Boolean']>,
  readonly hasDelivery?: Maybe<Scalars['Boolean']>,
  readonly hasDelivery_not?: Maybe<Scalars['Boolean']>,
  readonly hasDineIn?: Maybe<Scalars['Boolean']>,
  readonly hasDineIn_not?: Maybe<Scalars['Boolean']>,
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>,
  readonly hasDriveThru_not?: Maybe<Scalars['Boolean']>,
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>,
  readonly hasMobileOrdering_not?: Maybe<Scalars['Boolean']>,
  readonly hasModifiedTakeout?: Maybe<Scalars['Boolean']>,
  readonly hasModifiedTakeout_not?: Maybe<Scalars['Boolean']>,
  readonly hasParking?: Maybe<Scalars['Boolean']>,
  readonly hasParking_not?: Maybe<Scalars['Boolean']>,
  readonly hasPlayground?: Maybe<Scalars['Boolean']>,
  readonly hasPlayground_not?: Maybe<Scalars['Boolean']>,
  readonly hasTakeOut?: Maybe<Scalars['Boolean']>,
  readonly hasTakeOut_not?: Maybe<Scalars['Boolean']>,
  readonly hasWifi?: Maybe<Scalars['Boolean']>,
  readonly hasWifi_not?: Maybe<Scalars['Boolean']>,
  readonly isDarkKitchen?: Maybe<Scalars['Boolean']>,
  readonly isDarkKitchen_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly lastModifiedTime?: Maybe<Scalars['DateTime']>,
  readonly lastModifiedTime_gt?: Maybe<Scalars['DateTime']>,
  readonly lastModifiedTime_gte?: Maybe<Scalars['DateTime']>,
  readonly lastModifiedTime_lt?: Maybe<Scalars['DateTime']>,
  readonly lastModifiedTime_lte?: Maybe<Scalars['DateTime']>,
  readonly lastModifiedTime_not?: Maybe<Scalars['DateTime']>,
  readonly latitude?: Maybe<Scalars['Float']>,
  readonly latitude_gt?: Maybe<Scalars['Float']>,
  readonly latitude_gte?: Maybe<Scalars['Float']>,
  readonly latitude_lt?: Maybe<Scalars['Float']>,
  readonly latitude_lte?: Maybe<Scalars['Float']>,
  readonly latitude_not?: Maybe<Scalars['Float']>,
  readonly longitude?: Maybe<Scalars['Float']>,
  readonly longitude_gt?: Maybe<Scalars['Float']>,
  readonly longitude_gte?: Maybe<Scalars['Float']>,
  readonly longitude_lt?: Maybe<Scalars['Float']>,
  readonly longitude_lte?: Maybe<Scalars['Float']>,
  readonly longitude_not?: Maybe<Scalars['Float']>,
  readonly mobileOrderingStatus?: Maybe<Scalars['String']>,
  readonly mobileOrderingStatus_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mobileOrderingStatus_matches?: Maybe<Scalars['String']>,
  readonly mobileOrderingStatus_not?: Maybe<Scalars['String']>,
  readonly mobileOrderingStatus_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly nbrDriveThruWindows?: Maybe<Scalars['Float']>,
  readonly nbrDriveThruWindows_gt?: Maybe<Scalars['Float']>,
  readonly nbrDriveThruWindows_gte?: Maybe<Scalars['Float']>,
  readonly nbrDriveThruWindows_lt?: Maybe<Scalars['Float']>,
  readonly nbrDriveThruWindows_lte?: Maybe<Scalars['Float']>,
  readonly nbrDriveThruWindows_not?: Maybe<Scalars['Float']>,
  readonly number?: Maybe<Scalars['String']>,
  readonly number_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly number_matches?: Maybe<Scalars['String']>,
  readonly number_not?: Maybe<Scalars['String']>,
  readonly number_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly ownership?: Maybe<Scalars['String']>,
  readonly ownership_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly ownership_matches?: Maybe<Scalars['String']>,
  readonly ownership_not?: Maybe<Scalars['String']>,
  readonly ownership_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly parkingType?: Maybe<Scalars['String']>,
  readonly parkingType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly parkingType_matches?: Maybe<Scalars['String']>,
  readonly parkingType_not?: Maybe<Scalars['String']>,
  readonly parkingType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly phoneNumber?: Maybe<Scalars['String']>,
  readonly phoneNumber_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly phoneNumber_matches?: Maybe<Scalars['String']>,
  readonly phoneNumber_not?: Maybe<Scalars['String']>,
  readonly phoneNumber_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly playgroundType?: Maybe<Scalars['String']>,
  readonly playgroundType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly playgroundType_matches?: Maybe<Scalars['String']>,
  readonly playgroundType_not?: Maybe<Scalars['String']>,
  readonly playgroundType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly posRestaurantId?: Maybe<Scalars['String']>,
  readonly posRestaurantId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly posRestaurantId_matches?: Maybe<Scalars['String']>,
  readonly posRestaurantId_not?: Maybe<Scalars['String']>,
  readonly posRestaurantId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly restaurantKioskData?: Maybe<Scalars['ID']>,
  readonly restaurantPosData?: Maybe<Scalars['ID']>,
  readonly servicesHasDriveThru?: Maybe<Scalars['Boolean']>,
  readonly servicesHasDriveThru_not?: Maybe<Scalars['Boolean']>,
  readonly status?: Maybe<Scalars['String']>,
  readonly status_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly status_matches?: Maybe<Scalars['String']>,
  readonly status_not?: Maybe<Scalars['String']>,
  readonly status_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly timezone?: Maybe<Scalars['String']>,
  readonly timezone_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly timezone_matches?: Maybe<Scalars['String']>,
  readonly timezone_not?: Maybe<Scalars['String']>,
  readonly timezone_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRestaurantGroup  extends IDocument {
  readonly __typename?: 'RestaurantGroup',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<Scalars['String']>,
  readonly restaurants: Maybe<ReadonlyArray<Maybe<IRestaurant>>>,
}

export interface IRestaurantGroupFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRestaurantGroupRestrictions {
  readonly __typename?: 'RestaurantGroupRestrictions',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly restaurantGroupRestrictionList: Maybe<ReadonlyArray<Maybe<IRestaurantGroup>>>,
}

export interface IRestaurantKioskData  extends IDocument {
  readonly __typename?: 'RestaurantKioskData',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly kiosks: Maybe<ReadonlyArray<Maybe<IKiosk>>>,
  readonly restaurantNumber: Maybe<Scalars['Float']>,
}

export interface IRestaurantKioskDataFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly restaurantNumber?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_gt?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_gte?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_lt?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_lte?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_not?: Maybe<Scalars['Float']>,
}

export interface IRestaurantPosData  extends IDocument {
  readonly __typename?: 'RestaurantPosData',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly deliveryPLUs: Maybe<Scalars['String']>,
  readonly disableChickenSandwich: Maybe<Scalars['Boolean']>,
  readonly heartbeatOverride: Maybe<Scalars['String']>,
  readonly heartbeatStatus: Maybe<Scalars['Boolean']>,
  readonly lastHeartbeatTimestamp: Maybe<Scalars['DateTime']>,
  readonly plus: Maybe<Scalars['String']>,
  readonly restaurant: Maybe<IRestaurant>,
  readonly restaurantNumber: Maybe<Scalars['Float']>,
}

export interface IRestaurantPosDataFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly deliveryPLUs?: Maybe<Scalars['String']>,
  readonly deliveryPLUs_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly deliveryPLUs_matches?: Maybe<Scalars['String']>,
  readonly deliveryPLUs_not?: Maybe<Scalars['String']>,
  readonly deliveryPLUs_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly disableChickenSandwich?: Maybe<Scalars['Boolean']>,
  readonly disableChickenSandwich_not?: Maybe<Scalars['Boolean']>,
  readonly heartbeatOverride?: Maybe<Scalars['String']>,
  readonly heartbeatOverride_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heartbeatOverride_matches?: Maybe<Scalars['String']>,
  readonly heartbeatOverride_not?: Maybe<Scalars['String']>,
  readonly heartbeatOverride_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly heartbeatStatus?: Maybe<Scalars['Boolean']>,
  readonly heartbeatStatus_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly lastHeartbeatTimestamp?: Maybe<Scalars['DateTime']>,
  readonly lastHeartbeatTimestamp_gt?: Maybe<Scalars['DateTime']>,
  readonly lastHeartbeatTimestamp_gte?: Maybe<Scalars['DateTime']>,
  readonly lastHeartbeatTimestamp_lt?: Maybe<Scalars['DateTime']>,
  readonly lastHeartbeatTimestamp_lte?: Maybe<Scalars['DateTime']>,
  readonly lastHeartbeatTimestamp_not?: Maybe<Scalars['DateTime']>,
  readonly plus?: Maybe<Scalars['String']>,
  readonly plus_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly plus_matches?: Maybe<Scalars['String']>,
  readonly plus_not?: Maybe<Scalars['String']>,
  readonly plus_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly restaurant?: Maybe<Scalars['ID']>,
  readonly restaurantNumber?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_gt?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_gte?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_lt?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_lte?: Maybe<Scalars['Float']>,
  readonly restaurantNumber_not?: Maybe<Scalars['Float']>,
}

export interface IResultDetails  extends IDocument {
  readonly __typename?: 'ResultDetails',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly description: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly offer: Maybe<IOffer>,
  readonly prefix: Maybe<ILocaleString>,
  readonly text: Maybe<ILocaleString>,
}

export interface IResultDetailsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly offer?: Maybe<Scalars['ID']>,
}

export interface IResultValueDetails {
  readonly __typename?: 'ResultValueDetails',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly result: Maybe<IResultDetails>,
  readonly value: Maybe<Scalars['Float']>,
}

export interface IReward  extends IDocument {
  readonly __typename?: 'Reward',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly backgroundImage: Maybe<IImage>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly howToRedeem: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<ILocaleImage>,
  readonly incentives: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferDiscountOrPicker>>>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly moreInfo: Maybe<ILocaleBlockContent>,
  readonly name: Maybe<ILocaleString>,
  readonly ruleSet: Maybe<ReadonlyArray<Maybe<IBetweenDatesOrCartLimitOrDaypartRuleOrFirstOrderOnlyOrLoyaltyPoints>>>,
  readonly vendorConfigs: Maybe<IVendorConfigs>,
}

export interface IRewardFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRewards {
  readonly __typename?: 'Rewards',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly allSetBlurbBlock: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<ILocaleImages>,
  readonly key: Maybe<Scalars['String']>,
  readonly requireSkillsQuestion: Maybe<Scalars['Boolean']>,
  readonly rewardName: Maybe<ILocaleString>,
  readonly rewardYouWonMessageBlock: Maybe<ILocaleBlockContent>,
}

export interface IRollUpTheRim  extends IDocument {
  readonly __typename?: 'RollUpTheRim',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly allSetClaimFailedHeaderText: Maybe<ILocaleString>,
  readonly allSetEmailSentText: Maybe<ILocaleString>,
  readonly allSetHeaderBlock: Maybe<ILocaleBlockContent>,
  readonly allSetHeaderText: Maybe<ILocaleString>,
  readonly allSetLegalBlock: Maybe<ILocaleBlockContent>,
  readonly allSetTextBlock: Maybe<ILocaleBlockContent>,
  readonly countdownText: Maybe<ILocaleBlockContent>,
  readonly cupImage: Maybe<ILocaleImages>,
  readonly desktopGamePlayImage: Maybe<ILocaleImages>,
  readonly desktopPrizesImage: Maybe<ILocaleImages>,
  readonly desktopReusablesImage: Maybe<ILocaleImages>,
  readonly desktopShareImage: Maybe<ILocaleImages>,
  readonly emptyTimelineButtonBlock: Maybe<ILocaleBlockContent>,
  readonly emptyTimelineImage: Maybe<ILocaleImages>,
  readonly emptyTimelineTextBlock: Maybe<ILocaleBlockContent>,
  readonly endText: Maybe<ILocaleBlockContent>,
  readonly enterButtonText: Maybe<ILocaleBlockContent>,
  readonly entriesText: Maybe<ILocaleBlockContent>,
  readonly errorTimelineButtonText: Maybe<ILocaleString>,
  readonly errorTimelineImage: Maybe<ILocaleImages>,
  readonly errorTimelineText: Maybe<ILocaleString>,
  readonly firstDrawing: Maybe<Scalars['DateTime']>,
  readonly footerLinks: Maybe<ReadonlyArray<Maybe<IRutrFooter>>>,
  readonly fourthDrawing: Maybe<Scalars['DateTime']>,
  readonly gameBackgroundImage: Maybe<ILocaleImages>,
  readonly gameButtonText: Maybe<ILocaleBlockContent>,
  readonly gameErrorBlock: Maybe<ILocaleBlockContent>,
  readonly gameErrorHeaderText: Maybe<ILocaleString>,
  readonly gameHeader: Maybe<ILocaleBlockContent>,
  readonly gameHeaderText: Maybe<ILocaleString>,
  readonly gameNeedHelp: Maybe<ILocaleString>,
  readonly gamePlayButtonText: Maybe<ILocaleBlockContent>,
  readonly gamePlayHeader: Maybe<ILocaleBlockContent>,
  readonly gamePlayImage: Maybe<ILocaleImages>,
  readonly gamePlayTextBlock: Maybe<ILocaleBlockContent>,
  readonly gameRollButtonText: Maybe<ILocaleString>,
  readonly gameTextBlock: Maybe<ILocaleBlockContent>,
  readonly gameplayRollAudio: Maybe<IFile>,
  readonly gameplayWinAudio: Maybe<IFile>,
  readonly homepageBackgroundImage: Maybe<ILocaleImages>,
  readonly homepageCupImage: Maybe<ILocaleImages>,
  readonly homepageHeader: Maybe<ILocaleBlockContent>,
  readonly howManyTextBlock: Maybe<ILocaleBlockContent>,
  readonly localeSwitchModalDisclaimerText: Maybe<ILocaleString>,
  readonly localeSwitchModalHeaderText: Maybe<ILocaleString>,
  readonly localeSwitchModalPrimaryText: Maybe<ILocaleString>,
  readonly localeSwitchModalSecondaryText: Maybe<ILocaleString>,
  readonly modalTimelineHeader: Maybe<ILocaleBlockContent>,
  readonly modalWinnersHeader: Maybe<ILocaleBlockContent>,
  readonly modalWinnersTextBlock: Maybe<ILocaleBlockContent>,
  readonly moneyStackImage: Maybe<ILocaleImages>,
  readonly nextDrawText: Maybe<ILocaleBlockContent>,
  readonly planeImage: Maybe<ILocaleImages>,
  readonly prizes: Maybe<ReadonlyArray<Maybe<IPrizes>>>,
  readonly prizesButtonText: Maybe<ILocaleBlockContent>,
  readonly prizesHeader: Maybe<ILocaleBlockContent>,
  readonly prizesImage: Maybe<ILocaleImages>,
  readonly prizesSeparator: Maybe<ILocaleBlockContent>,
  readonly prizesTextBlock: Maybe<ILocaleBlockContent>,
  readonly reusablesButtonText: Maybe<ILocaleBlockContent>,
  readonly reusablesHeader: Maybe<ILocaleBlockContent>,
  readonly reusablesImage: Maybe<ILocaleImages>,
  readonly reusablesTextBlock: Maybe<ILocaleBlockContent>,
  readonly rewards: Maybe<ReadonlyArray<Maybe<IRewards>>>,
  readonly rewardsBackgroundImage: Maybe<ILocaleImages>,
  readonly rewardsButtonText: Maybe<ILocaleBlockContent>,
  readonly rewardsCupImage: Maybe<ILocaleImages>,
  readonly rewardsHeader: Maybe<ILocaleBlockContent>,
  readonly rewardsHeaderText: Maybe<ILocaleString>,
  readonly rewardsTextBlock: Maybe<ILocaleBlockContent>,
  readonly rollsRemainingText: Maybe<ILocaleBlockContent>,
  readonly rollupAnimationFrames: Maybe<ReadonlyArray<Maybe<ILocaleImages>>>,
  readonly rrrollButtonText: Maybe<ILocaleBlockContent>,
  readonly rulesLinkPath: Maybe<ILocaleString>,
  readonly rulesLinkText: Maybe<ILocaleString>,
  readonly rulesText: Maybe<ILocaleBlockContent>,
  readonly secondDrawing: Maybe<Scalars['DateTime']>,
  readonly shareButtonText: Maybe<ILocaleBlockContent>,
  readonly shareHeader: Maybe<ILocaleBlockContent>,
  readonly shareImage: Maybe<ILocaleImages>,
  readonly shareRollHeader: Maybe<ILocaleBlockContent>,
  readonly shareRollIncrementText: Maybe<ILocaleString>,
  readonly shareRollLinkTitle: Maybe<ILocaleString>,
  readonly shareRollReclaimButtonText: Maybe<ILocaleString>,
  readonly shareRollReclaimDescriptionText: Maybe<ILocaleString>,
  readonly shareRollReclaimQuestionText: Maybe<ILocaleString>,
  readonly shareRollShare: Maybe<ILocaleString>,
  readonly shareRollTextBlock: Maybe<ILocaleBlockContent>,
  readonly shareRollTo: Maybe<ILocaleString>,
  readonly shareRollURL: Maybe<ILocaleString>,
  readonly shareRollYouHave: Maybe<ILocaleString>,
  readonly shareRollsBackgroundImage: Maybe<ILocaleImages>,
  readonly shareRollsDisclaimer: Maybe<ILocaleBlockContent>,
  readonly shareRollsImage: Maybe<ILocaleImages>,
  readonly shareRolluttonText: Maybe<ILocaleBlockContent>,
  readonly shareTextBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingAddedBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingBackgroundImage: Maybe<ILocaleImages>,
  readonly sharedLandingBadLinkButtonBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingBadLinkHeaderBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingBadLinkImage: Maybe<ILocaleImages>,
  readonly sharedLandingBadLinkTextBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingButtonBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingHeaderBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingImage: Maybe<ILocaleImages>,
  readonly sharedLandingMoreThanOneRollAddedBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingMoreThanOneRollHeaderBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingMoreThanOneRollTextBlock: Maybe<ILocaleBlockContent>,
  readonly sharedLandingTextBlock: Maybe<ILocaleBlockContent>,
  readonly skillsQuestionAcknowledgeText: Maybe<ILocaleString>,
  readonly skillsQuestionDescriptionText: Maybe<ILocaleString>,
  readonly skillsQuestionHeaderText: Maybe<ILocaleString>,
  readonly skillsQuestionHintText: Maybe<ILocaleString>,
  readonly skillsQuestionMathBlock: Maybe<ILocaleBlockContent>,
  readonly skillsQuestionReleaseBlock: Maybe<ILocaleBlockContent>,
  readonly sponsorTitle: Maybe<ILocaleString>,
  readonly sponsorsImage: Maybe<ILocaleImages>,
  readonly thirdDrawing: Maybe<Scalars['DateTime']>,
  readonly timelineButtonText: Maybe<ILocaleBlockContent>,
  readonly timelineComponents: Maybe<ReadonlyArray<Maybe<ITimelineComponents>>>,
  readonly timelineConfetti: Maybe<ILocaleImages>,
  readonly timelineHeader: Maybe<ILocaleBlockContent>,
  readonly timelinePrizeClaimedText: Maybe<ILocaleString>,
  readonly timelineRollSharedText: Maybe<ILocaleString>,
  readonly timelineTextBlock: Maybe<ILocaleBlockContent>,
  readonly timelineTextLoadMore: Maybe<ILocaleString>,
  readonly winnersButtonText: Maybe<ILocaleBlockContent>,
  readonly winnersHeader: Maybe<ILocaleBlockContent>,
  readonly winnersTextBlock: Maybe<ILocaleBlockContent>,
}

export interface IRollUpTheRimFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing_gt?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing_gte?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing_lt?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing_lte?: Maybe<Scalars['DateTime']>,
  readonly firstDrawing_not?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing_gt?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing_gte?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing_lt?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing_lte?: Maybe<Scalars['DateTime']>,
  readonly fourthDrawing_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly secondDrawing?: Maybe<Scalars['DateTime']>,
  readonly secondDrawing_gt?: Maybe<Scalars['DateTime']>,
  readonly secondDrawing_gte?: Maybe<Scalars['DateTime']>,
  readonly secondDrawing_lt?: Maybe<Scalars['DateTime']>,
  readonly secondDrawing_lte?: Maybe<Scalars['DateTime']>,
  readonly secondDrawing_not?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing_gt?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing_gte?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing_lt?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing_lte?: Maybe<Scalars['DateTime']>,
  readonly thirdDrawing_not?: Maybe<Scalars['DateTime']>,
}

export interface IRollUpTheRimSection  extends IDocument {
  readonly __typename?: 'RollUpTheRimSection',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IRollUpTheRimSectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IRootQuery {
  readonly __typename?: 'RootQuery',
  readonly Alert: Maybe<IAlert>,
  readonly AppData: Maybe<IAppData>,
  readonly AppDownload: Maybe<IAppDownload>,
  readonly AppVersion: Maybe<IAppVersion>,
  readonly Barcodes: Maybe<IBarcodes>,
  readonly BrazeContentCards: Maybe<IBrazeContentCards>,
  readonly Category: Maybe<ICategory>,
  readonly CateringPageConfiguration: Maybe<ICateringPageConfiguration>,
  readonly Combo: Maybe<ICombo>,
  readonly ComboSlot: Maybe<IComboSlot>,
  readonly DisplayGroup: Maybe<IDisplayGroup>,
  readonly EarningCalculation: Maybe<IEarningCalculation>,
  readonly EmptyState: Maybe<IEmptyState>,
  readonly FanFavorites: Maybe<IFanFavorites>,
  readonly FeatureAccount: Maybe<IFeatureAccount>,
  readonly FeatureAccountDeletePage: Maybe<IFeatureAccountDeletePage>,
  readonly FeatureAccountForm: Maybe<IFeatureAccountForm>,
  readonly FeatureAccountRequestInfoPage: Maybe<IFeatureAccountRequestInfoPage>,
  readonly FeatureCateringPage: Maybe<IFeatureCateringPage>,
  readonly FeatureDisclaimers: Maybe<IFeatureDisclaimers>,
  readonly FeatureFooter: Maybe<IFeatureFooter>,
  readonly FeatureGeolocationModal: Maybe<IFeatureGeolocationModal>,
  readonly FeatureGift: Maybe<IFeatureGift>,
  readonly FeatureHomePage: Maybe<IFeatureHomePage>,
  readonly FeatureKiosk: Maybe<IFeatureKiosk>,
  readonly FeatureLayout: Maybe<IFeatureLayout>,
  readonly FeatureLocationPromo: Maybe<IFeatureLocationPromo>,
  readonly FeatureMenu: Maybe<IFeatureMenu>,
  readonly FeatureMobileAppConfiguration: Maybe<IFeatureMobileAppConfiguration>,
  readonly FeatureNavigation: Maybe<IFeatureNavigation>,
  readonly FeatureNutrition: Maybe<IFeatureNutrition>,
  readonly FeatureOffers: Maybe<IFeatureOffers>,
  readonly FeatureQuiz: Maybe<IFeatureQuiz>,
  readonly FeatureStaticMenu: Maybe<IFeatureStaticMenu>,
  readonly Footer: Maybe<IFooter>,
  readonly HomePageConfiguration: Maybe<IHomePageConfiguration>,
  readonly Item: Maybe<IItem>,
  readonly KioskAppData: Maybe<IKioskAppData>,
  readonly LockedOffers: Maybe<ILockedOffers>,
  readonly LoyaltyConfiguration: Maybe<ILoyaltyConfiguration>,
  readonly LoyaltyContent: Maybe<ILoyaltyContent>,
  readonly LoyaltyUI: Maybe<ILoyaltyUi>,
  readonly MainHero: Maybe<IMainHero>,
  readonly MarketingTile: Maybe<IMarketingTile>,
  readonly MarketingTileGroup: Maybe<IMarketingTileGroup>,
  readonly Menu: Maybe<IMenu>,
  readonly Modifier: Maybe<IModifier>,
  readonly ModifierMultiplier: Maybe<IModifierMultiplier>,
  readonly NavigationSection: Maybe<INavigationSection>,
  readonly NutritionalSection: Maybe<INutritionalSection>,
  readonly Offer: Maybe<IOffer>,
  readonly OfferActivation: Maybe<IOfferActivation>,
  readonly OfferDiscount: Maybe<IOfferDiscount>,
  readonly OfferItemDiscount: Maybe<IOfferItemDiscount>,
  readonly OfferLoyaltyAction: Maybe<IOfferLoyaltyAction>,
  readonly OfferTemplateMvp: Maybe<IOfferTemplateMvp>,
  readonly OffersSection: Maybe<IOffersSection>,
  readonly OpPricingRegion: Maybe<IOpPricingRegion>,
  readonly OurServices: Maybe<IOurServices>,
  readonly Picker: Maybe<IPicker>,
  readonly PickerAspect: Maybe<IPickerAspect>,
  readonly ProductCategory: Maybe<IProductCategory>,
  readonly QuestionDetails: Maybe<IQuestionDetails>,
  readonly RecentItems: Maybe<IRecentItems>,
  readonly ResponseDetails: Maybe<IResponseDetails>,
  readonly Restaurant: Maybe<IRestaurant>,
  readonly RestaurantGroup: Maybe<IRestaurantGroup>,
  readonly RestaurantKioskData: Maybe<IRestaurantKioskData>,
  readonly RestaurantPosData: Maybe<IRestaurantPosData>,
  readonly ResultDetails: Maybe<IResultDetails>,
  readonly Reward: Maybe<IReward>,
  readonly RollUpTheRim: Maybe<IRollUpTheRim>,
  readonly RollUpTheRimSection: Maybe<IRollUpTheRimSection>,
  readonly SanityFileAsset: Maybe<ISanityFileAsset>,
  readonly SanityImageAsset: Maybe<ISanityImageAsset>,
  readonly ScanForRewards: Maybe<IScanForRewards>,
  readonly Section: Maybe<ISection>,
  readonly StaticPage: Maybe<IStaticPage>,
  readonly StaticStringsDictionary: Maybe<IStaticStringsDictionary>,
  readonly SupportCategoryGroup: Maybe<ISupportCategoryGroup>,
  readonly SupportData: Maybe<ISupportData>,
  readonly SupportFaq: Maybe<ISupportFaq>,
  readonly SupportSubcategory: Maybe<ISupportSubcategory>,
  readonly SystemwidePromotion: Maybe<ISystemwidePromotion>,
  readonly Tier: Maybe<ITier>,
  readonly Trending: Maybe<ITrending>,
  readonly allAlerts: ReadonlyArray<IAlert>,
  readonly allAppData: ReadonlyArray<IAppData>,
  readonly allAppDownloads: ReadonlyArray<IAppDownload>,
  readonly allAppVersions: ReadonlyArray<IAppVersion>,
  readonly allBarcodes: ReadonlyArray<IBarcodes>,
  readonly allBrazeContentCards: ReadonlyArray<IBrazeContentCards>,
  readonly allCategories: ReadonlyArray<ICategory>,
  readonly allCateringPageConfigurations: ReadonlyArray<ICateringPageConfiguration>,
  readonly allComboSlots: ReadonlyArray<IComboSlot>,
  readonly allCombos: ReadonlyArray<ICombo>,
  readonly allDisplayGroups: ReadonlyArray<IDisplayGroup>,
  readonly allEarningCalculations: ReadonlyArray<IEarningCalculation>,
  readonly allEmptyStates: ReadonlyArray<IEmptyState>,
  readonly allFanFavorites: ReadonlyArray<IFanFavorites>,
  readonly allFeatureAccountDeletePages: ReadonlyArray<IFeatureAccountDeletePage>,
  readonly allFeatureAccountForms: ReadonlyArray<IFeatureAccountForm>,
  readonly allFeatureAccountRequestInfoPages: ReadonlyArray<IFeatureAccountRequestInfoPage>,
  readonly allFeatureAccounts: ReadonlyArray<IFeatureAccount>,
  readonly allFeatureCateringPages: ReadonlyArray<IFeatureCateringPage>,
  readonly allFeatureDisclaimers: ReadonlyArray<IFeatureDisclaimers>,
  readonly allFeatureFooters: ReadonlyArray<IFeatureFooter>,
  readonly allFeatureGeolocationModals: ReadonlyArray<IFeatureGeolocationModal>,
  readonly allFeatureGifts: ReadonlyArray<IFeatureGift>,
  readonly allFeatureHomePages: ReadonlyArray<IFeatureHomePage>,
  readonly allFeatureKiosks: ReadonlyArray<IFeatureKiosk>,
  readonly allFeatureLayouts: ReadonlyArray<IFeatureLayout>,
  readonly allFeatureLocationPromos: ReadonlyArray<IFeatureLocationPromo>,
  readonly allFeatureMenus: ReadonlyArray<IFeatureMenu>,
  readonly allFeatureMobileAppConfigurations: ReadonlyArray<IFeatureMobileAppConfiguration>,
  readonly allFeatureNavigations: ReadonlyArray<IFeatureNavigation>,
  readonly allFeatureNutritions: ReadonlyArray<IFeatureNutrition>,
  readonly allFeatureOffers: ReadonlyArray<IFeatureOffers>,
  readonly allFeatureQuizzes: ReadonlyArray<IFeatureQuiz>,
  readonly allFeatureStaticMenus: ReadonlyArray<IFeatureStaticMenu>,
  readonly allFooters: ReadonlyArray<IFooter>,
  readonly allHomePageConfigurations: ReadonlyArray<IHomePageConfiguration>,
  readonly allItems: ReadonlyArray<IItem>,
  readonly allKioskAppData: ReadonlyArray<IKioskAppData>,
  readonly allLockedOffers: ReadonlyArray<ILockedOffers>,
  readonly allLoyaltyConfigurations: ReadonlyArray<ILoyaltyConfiguration>,
  readonly allLoyaltyContents: ReadonlyArray<ILoyaltyContent>,
  readonly allLoyaltyUis: ReadonlyArray<ILoyaltyUi>,
  readonly allMainHeroes: ReadonlyArray<IMainHero>,
  readonly allMarketingTileGroups: ReadonlyArray<IMarketingTileGroup>,
  readonly allMarketingTiles: ReadonlyArray<IMarketingTile>,
  readonly allMenus: ReadonlyArray<IMenu>,
  readonly allModifierMultipliers: ReadonlyArray<IModifierMultiplier>,
  readonly allModifiers: ReadonlyArray<IModifier>,
  readonly allNavigationSections: ReadonlyArray<INavigationSection>,
  readonly allNutritionalSections: ReadonlyArray<INutritionalSection>,
  readonly allOfferActivations: ReadonlyArray<IOfferActivation>,
  readonly allOfferDiscounts: ReadonlyArray<IOfferDiscount>,
  readonly allOfferItemDiscounts: ReadonlyArray<IOfferItemDiscount>,
  readonly allOfferLoyaltyActions: ReadonlyArray<IOfferLoyaltyAction>,
  readonly allOfferTemplateMvps: ReadonlyArray<IOfferTemplateMvp>,
  readonly allOffers: ReadonlyArray<IOffer>,
  readonly allOffersSections: ReadonlyArray<IOffersSection>,
  readonly allOpPricingRegions: ReadonlyArray<IOpPricingRegion>,
  readonly allOurServices: ReadonlyArray<IOurServices>,
  readonly allPickerAspects: ReadonlyArray<IPickerAspect>,
  readonly allPickers: ReadonlyArray<IPicker>,
  readonly allProductCategories: ReadonlyArray<IProductCategory>,
  readonly allQuestionDetails: ReadonlyArray<IQuestionDetails>,
  readonly allRecentItems: ReadonlyArray<IRecentItems>,
  readonly allResponseDetails: ReadonlyArray<IResponseDetails>,
  readonly allRestaurantGroups: ReadonlyArray<IRestaurantGroup>,
  readonly allRestaurantKioskData: ReadonlyArray<IRestaurantKioskData>,
  readonly allRestaurantPosData: ReadonlyArray<IRestaurantPosData>,
  readonly allRestaurants: ReadonlyArray<IRestaurant>,
  readonly allResultDetails: ReadonlyArray<IResultDetails>,
  readonly allRewards: ReadonlyArray<IReward>,
  readonly allRollUpTheRimSections: ReadonlyArray<IRollUpTheRimSection>,
  readonly allRollUpTheRims: ReadonlyArray<IRollUpTheRim>,
  readonly allSanityFileAssets: ReadonlyArray<ISanityFileAsset>,
  readonly allSanityImageAssets: ReadonlyArray<ISanityImageAsset>,
  readonly allScanForRewards: ReadonlyArray<IScanForRewards>,
  readonly allSections: ReadonlyArray<ISection>,
  readonly allStaticPages: ReadonlyArray<IStaticPage>,
  readonly allStaticStringsDictionaries: ReadonlyArray<IStaticStringsDictionary>,
  readonly allSupportCategoryGroups: ReadonlyArray<ISupportCategoryGroup>,
  readonly allSupportData: ReadonlyArray<ISupportData>,
  readonly allSupportFaqs: ReadonlyArray<ISupportFaq>,
  readonly allSupportSubcategories: ReadonlyArray<ISupportSubcategory>,
  readonly allSystemwidePromotions: ReadonlyArray<ISystemwidePromotion>,
  readonly allTiers: ReadonlyArray<ITier>,
  readonly allTrendings: ReadonlyArray<ITrending>,
}


export interface IRootQueryAlertArgs {
  id: Scalars['ID']
}


export interface IRootQueryAppDataArgs {
  id: Scalars['ID']
}


export interface IRootQueryAppDownloadArgs {
  id: Scalars['ID']
}


export interface IRootQueryAppVersionArgs {
  id: Scalars['ID']
}


export interface IRootQueryBarcodesArgs {
  id: Scalars['ID']
}


export interface IRootQueryBrazeContentCardsArgs {
  id: Scalars['ID']
}


export interface IRootQueryCategoryArgs {
  id: Scalars['ID']
}


export interface IRootQueryCateringPageConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryComboArgs {
  id: Scalars['ID']
}


export interface IRootQueryComboSlotArgs {
  id: Scalars['ID']
}


export interface IRootQueryDisplayGroupArgs {
  id: Scalars['ID']
}


export interface IRootQueryEarningCalculationArgs {
  id: Scalars['ID']
}


export interface IRootQueryEmptyStateArgs {
  id: Scalars['ID']
}


export interface IRootQueryFanFavoritesArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureAccountArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureAccountDeletePageArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureAccountFormArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureAccountRequestInfoPageArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureCateringPageArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureDisclaimersArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureFooterArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureGeolocationModalArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureGiftArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureHomePageArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureKioskArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureLayoutArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureLocationPromoArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureMenuArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureMobileAppConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureNavigationArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureNutritionArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureOffersArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureQuizArgs {
  id: Scalars['ID']
}


export interface IRootQueryFeatureStaticMenuArgs {
  id: Scalars['ID']
}


export interface IRootQueryFooterArgs {
  id: Scalars['ID']
}


export interface IRootQueryHomePageConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryItemArgs {
  id: Scalars['ID']
}


export interface IRootQueryKioskAppDataArgs {
  id: Scalars['ID']
}


export interface IRootQueryLockedOffersArgs {
  id: Scalars['ID']
}


export interface IRootQueryLoyaltyConfigurationArgs {
  id: Scalars['ID']
}


export interface IRootQueryLoyaltyContentArgs {
  id: Scalars['ID']
}


export interface IRootQueryLoyaltyUiArgs {
  id: Scalars['ID']
}


export interface IRootQueryMainHeroArgs {
  id: Scalars['ID']
}


export interface IRootQueryMarketingTileArgs {
  id: Scalars['ID']
}


export interface IRootQueryMarketingTileGroupArgs {
  id: Scalars['ID']
}


export interface IRootQueryMenuArgs {
  id: Scalars['ID']
}


export interface IRootQueryModifierArgs {
  id: Scalars['ID']
}


export interface IRootQueryModifierMultiplierArgs {
  id: Scalars['ID']
}


export interface IRootQueryNavigationSectionArgs {
  id: Scalars['ID']
}


export interface IRootQueryNutritionalSectionArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferActivationArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferDiscountArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferItemDiscountArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferLoyaltyActionArgs {
  id: Scalars['ID']
}


export interface IRootQueryOfferTemplateMvpArgs {
  id: Scalars['ID']
}


export interface IRootQueryOffersSectionArgs {
  id: Scalars['ID']
}


export interface IRootQueryOpPricingRegionArgs {
  id: Scalars['ID']
}


export interface IRootQueryOurServicesArgs {
  id: Scalars['ID']
}


export interface IRootQueryPickerArgs {
  id: Scalars['ID']
}


export interface IRootQueryPickerAspectArgs {
  id: Scalars['ID']
}


export interface IRootQueryProductCategoryArgs {
  id: Scalars['ID']
}


export interface IRootQueryQuestionDetailsArgs {
  id: Scalars['ID']
}


export interface IRootQueryRecentItemsArgs {
  id: Scalars['ID']
}


export interface IRootQueryResponseDetailsArgs {
  id: Scalars['ID']
}


export interface IRootQueryRestaurantArgs {
  id: Scalars['ID']
}


export interface IRootQueryRestaurantGroupArgs {
  id: Scalars['ID']
}


export interface IRootQueryRestaurantKioskDataArgs {
  id: Scalars['ID']
}


export interface IRootQueryRestaurantPosDataArgs {
  id: Scalars['ID']
}


export interface IRootQueryResultDetailsArgs {
  id: Scalars['ID']
}


export interface IRootQueryRewardArgs {
  id: Scalars['ID']
}


export interface IRootQueryRollUpTheRimArgs {
  id: Scalars['ID']
}


export interface IRootQueryRollUpTheRimSectionArgs {
  id: Scalars['ID']
}


export interface IRootQuerySanityFileAssetArgs {
  id: Scalars['ID']
}


export interface IRootQuerySanityImageAssetArgs {
  id: Scalars['ID']
}


export interface IRootQueryScanForRewardsArgs {
  id: Scalars['ID']
}


export interface IRootQuerySectionArgs {
  id: Scalars['ID']
}


export interface IRootQueryStaticPageArgs {
  id: Scalars['ID']
}


export interface IRootQueryStaticStringsDictionaryArgs {
  id: Scalars['ID']
}


export interface IRootQuerySupportCategoryGroupArgs {
  id: Scalars['ID']
}


export interface IRootQuerySupportDataArgs {
  id: Scalars['ID']
}


export interface IRootQuerySupportFaqArgs {
  id: Scalars['ID']
}


export interface IRootQuerySupportSubcategoryArgs {
  id: Scalars['ID']
}


export interface IRootQuerySystemwidePromotionArgs {
  id: Scalars['ID']
}


export interface IRootQueryTierArgs {
  id: Scalars['ID']
}


export interface IRootQueryTrendingArgs {
  id: Scalars['ID']
}


export interface IRootQueryAllAlertsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IAlertFilter>
}


export interface IRootQueryAllAppDataArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IAppDataFilter>
}


export interface IRootQueryAllAppDownloadsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IAppDownloadFilter>
}


export interface IRootQueryAllAppVersionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IAppVersionFilter>
}


export interface IRootQueryAllBarcodesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IBarcodesFilter>
}


export interface IRootQueryAllBrazeContentCardsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IBrazeContentCardsFilter>
}


export interface IRootQueryAllCategoriesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ICategoryFilter>
}


export interface IRootQueryAllCateringPageConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ICateringPageConfigurationFilter>
}


export interface IRootQueryAllComboSlotsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IComboSlotFilter>
}


export interface IRootQueryAllCombosArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IComboFilter>
}


export interface IRootQueryAllDisplayGroupsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IDisplayGroupFilter>
}


export interface IRootQueryAllEarningCalculationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IEarningCalculationFilter>
}


export interface IRootQueryAllEmptyStatesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IEmptyStateFilter>
}


export interface IRootQueryAllFanFavoritesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFanFavoritesFilter>
}


export interface IRootQueryAllFeatureAccountDeletePagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureAccountDeletePageFilter>
}


export interface IRootQueryAllFeatureAccountFormsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureAccountFormFilter>
}


export interface IRootQueryAllFeatureAccountRequestInfoPagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureAccountRequestInfoPageFilter>
}


export interface IRootQueryAllFeatureAccountsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureAccountFilter>
}


export interface IRootQueryAllFeatureCateringPagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureCateringPageFilter>
}


export interface IRootQueryAllFeatureDisclaimersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureDisclaimersFilter>
}


export interface IRootQueryAllFeatureFootersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureFooterFilter>
}


export interface IRootQueryAllFeatureGeolocationModalsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureGeolocationModalFilter>
}


export interface IRootQueryAllFeatureGiftsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureGiftFilter>
}


export interface IRootQueryAllFeatureHomePagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureHomePageFilter>
}


export interface IRootQueryAllFeatureKiosksArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureKioskFilter>
}


export interface IRootQueryAllFeatureLayoutsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureLayoutFilter>
}


export interface IRootQueryAllFeatureLocationPromosArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureLocationPromoFilter>
}


export interface IRootQueryAllFeatureMenusArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureMenuFilter>
}


export interface IRootQueryAllFeatureMobileAppConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureMobileAppConfigurationFilter>
}


export interface IRootQueryAllFeatureNavigationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureNavigationFilter>
}


export interface IRootQueryAllFeatureNutritionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureNutritionFilter>
}


export interface IRootQueryAllFeatureOffersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureOffersFilter>
}


export interface IRootQueryAllFeatureQuizzesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureQuizFilter>
}


export interface IRootQueryAllFeatureStaticMenusArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFeatureStaticMenuFilter>
}


export interface IRootQueryAllFootersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IFooterFilter>
}


export interface IRootQueryAllHomePageConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IHomePageConfigurationFilter>
}


export interface IRootQueryAllItemsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IItemFilter>
}


export interface IRootQueryAllKioskAppDataArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IKioskAppDataFilter>
}


export interface IRootQueryAllLockedOffersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILockedOffersFilter>
}


export interface IRootQueryAllLoyaltyConfigurationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILoyaltyConfigurationFilter>
}


export interface IRootQueryAllLoyaltyContentsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILoyaltyContentFilter>
}


export interface IRootQueryAllLoyaltyUisArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ILoyaltyUiFilter>
}


export interface IRootQueryAllMainHeroesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMainHeroFilter>
}


export interface IRootQueryAllMarketingTileGroupsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMarketingTileGroupFilter>
}


export interface IRootQueryAllMarketingTilesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMarketingTileFilter>
}


export interface IRootQueryAllMenusArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IMenuFilter>
}


export interface IRootQueryAllModifierMultipliersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IModifierMultiplierFilter>
}


export interface IRootQueryAllModifiersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IModifierFilter>
}


export interface IRootQueryAllNavigationSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<INavigationSectionFilter>
}


export interface IRootQueryAllNutritionalSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<INutritionalSectionFilter>
}


export interface IRootQueryAllOfferActivationsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferActivationFilter>
}


export interface IRootQueryAllOfferDiscountsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferDiscountFilter>
}


export interface IRootQueryAllOfferItemDiscountsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferItemDiscountFilter>
}


export interface IRootQueryAllOfferLoyaltyActionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferLoyaltyActionFilter>
}


export interface IRootQueryAllOfferTemplateMvpsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferTemplateMvpFilter>
}


export interface IRootQueryAllOffersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOfferFilter>
}


export interface IRootQueryAllOffersSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOffersSectionFilter>
}


export interface IRootQueryAllOpPricingRegionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOpPricingRegionFilter>
}


export interface IRootQueryAllOurServicesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IOurServicesFilter>
}


export interface IRootQueryAllPickerAspectsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IPickerAspectFilter>
}


export interface IRootQueryAllPickersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IPickerFilter>
}


export interface IRootQueryAllProductCategoriesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IProductCategoryFilter>
}


export interface IRootQueryAllQuestionDetailsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IQuestionDetailsFilter>
}


export interface IRootQueryAllRecentItemsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRecentItemsFilter>
}


export interface IRootQueryAllResponseDetailsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IResponseDetailsFilter>
}


export interface IRootQueryAllRestaurantGroupsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRestaurantGroupFilter>
}


export interface IRootQueryAllRestaurantKioskDataArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRestaurantKioskDataFilter>
}


export interface IRootQueryAllRestaurantPosDataArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRestaurantPosDataFilter>
}


export interface IRootQueryAllRestaurantsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRestaurantFilter>
}


export interface IRootQueryAllResultDetailsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IResultDetailsFilter>
}


export interface IRootQueryAllRewardsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRewardFilter>
}


export interface IRootQueryAllRollUpTheRimSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRollUpTheRimSectionFilter>
}


export interface IRootQueryAllRollUpTheRimsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IRollUpTheRimFilter>
}


export interface IRootQueryAllSanityFileAssetsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISanityFileAssetFilter>
}


export interface IRootQueryAllSanityImageAssetsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISanityImageAssetFilter>
}


export interface IRootQueryAllScanForRewardsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IScanForRewardsFilter>
}


export interface IRootQueryAllSectionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISectionFilter>
}


export interface IRootQueryAllStaticPagesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IStaticPageFilter>
}


export interface IRootQueryAllStaticStringsDictionariesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<IStaticStringsDictionaryFilter>
}


export interface IRootQueryAllSupportCategoryGroupsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISupportCategoryGroupFilter>
}


export interface IRootQueryAllSupportDataArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISupportDataFilter>
}


export interface IRootQueryAllSupportFaqsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISupportFaqFilter>
}


export interface IRootQueryAllSupportSubcategoriesArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISupportSubcategoryFilter>
}


export interface IRootQueryAllSystemwidePromotionsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ISystemwidePromotionFilter>
}


export interface IRootQueryAllTiersArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ITierFilter>
}


export interface IRootQueryAllTrendingsArgs {
  limit: Maybe<Scalars['Int']>,
  offset: Maybe<Scalars['Int']>,
  where: Maybe<ITrendingFilter>
}

export interface IRow {
  readonly __typename?: 'Row',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly columns: Maybe<ReadonlyArray<Maybe<IColumn>>>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IRutrFooter {
  readonly __typename?: 'RutrFooter',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly footerLinkLocalizedPath: Maybe<ILocaleString>,
  readonly footerLinkText: Maybe<ILocaleString>,
  readonly footerText: Maybe<ILocaleString>,
  readonly footerTitle: Maybe<ILocaleString>,
}

export interface ISanityAssetSourceData {
  readonly __typename?: 'SanityAssetSourceData',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly id: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly url: Maybe<Scalars['String']>,
}

export interface ISanityFileAsset  extends IDocument {
  readonly __typename?: 'SanityFileAsset',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly assetId: Maybe<Scalars['String']>,
  readonly description: Maybe<Scalars['String']>,
  readonly extension: Maybe<Scalars['String']>,
  readonly label: Maybe<Scalars['String']>,
  readonly mimeType: Maybe<Scalars['String']>,
  readonly originalFilename: Maybe<Scalars['String']>,
  readonly path: Maybe<Scalars['String']>,
  readonly sha1hash: Maybe<Scalars['String']>,
  readonly size: Maybe<Scalars['Float']>,
  readonly source: Maybe<ISanityAssetSourceData>,
  readonly title: Maybe<Scalars['String']>,
  readonly url: Maybe<Scalars['String']>,
}

export interface ISanityFileAssetFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly assetId?: Maybe<Scalars['String']>,
  readonly assetId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly assetId_matches?: Maybe<Scalars['String']>,
  readonly assetId_not?: Maybe<Scalars['String']>,
  readonly assetId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly description?: Maybe<Scalars['String']>,
  readonly description_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly description_matches?: Maybe<Scalars['String']>,
  readonly description_not?: Maybe<Scalars['String']>,
  readonly description_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly extension?: Maybe<Scalars['String']>,
  readonly extension_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly extension_matches?: Maybe<Scalars['String']>,
  readonly extension_not?: Maybe<Scalars['String']>,
  readonly extension_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly label?: Maybe<Scalars['String']>,
  readonly label_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly label_matches?: Maybe<Scalars['String']>,
  readonly label_not?: Maybe<Scalars['String']>,
  readonly label_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mimeType?: Maybe<Scalars['String']>,
  readonly mimeType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mimeType_matches?: Maybe<Scalars['String']>,
  readonly mimeType_not?: Maybe<Scalars['String']>,
  readonly mimeType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly originalFilename?: Maybe<Scalars['String']>,
  readonly originalFilename_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly originalFilename_matches?: Maybe<Scalars['String']>,
  readonly originalFilename_not?: Maybe<Scalars['String']>,
  readonly originalFilename_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly path?: Maybe<Scalars['String']>,
  readonly path_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly path_matches?: Maybe<Scalars['String']>,
  readonly path_not?: Maybe<Scalars['String']>,
  readonly path_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sha1hash?: Maybe<Scalars['String']>,
  readonly sha1hash_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sha1hash_matches?: Maybe<Scalars['String']>,
  readonly sha1hash_not?: Maybe<Scalars['String']>,
  readonly sha1hash_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly size?: Maybe<Scalars['Float']>,
  readonly size_gt?: Maybe<Scalars['Float']>,
  readonly size_gte?: Maybe<Scalars['Float']>,
  readonly size_lt?: Maybe<Scalars['Float']>,
  readonly size_lte?: Maybe<Scalars['Float']>,
  readonly size_not?: Maybe<Scalars['Float']>,
  readonly title?: Maybe<Scalars['String']>,
  readonly title_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly title_matches?: Maybe<Scalars['String']>,
  readonly title_not?: Maybe<Scalars['String']>,
  readonly title_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly url?: Maybe<Scalars['String']>,
  readonly url_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly url_matches?: Maybe<Scalars['String']>,
  readonly url_not?: Maybe<Scalars['String']>,
  readonly url_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISanityImageAsset  extends IDocument {
  readonly __typename?: 'SanityImageAsset',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly assetId: Maybe<Scalars['String']>,
  readonly description: Maybe<Scalars['String']>,
  readonly extension: Maybe<Scalars['String']>,
  readonly label: Maybe<Scalars['String']>,
  readonly metadata: Maybe<ISanityImageMetadata>,
  readonly mimeType: Maybe<Scalars['String']>,
  readonly originalFilename: Maybe<Scalars['String']>,
  readonly path: Maybe<Scalars['String']>,
  readonly sha1hash: Maybe<Scalars['String']>,
  readonly size: Maybe<Scalars['Float']>,
  readonly source: Maybe<ISanityAssetSourceData>,
  readonly title: Maybe<Scalars['String']>,
  readonly url: Maybe<Scalars['String']>,
}

export interface ISanityImageAssetFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly assetId?: Maybe<Scalars['String']>,
  readonly assetId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly assetId_matches?: Maybe<Scalars['String']>,
  readonly assetId_not?: Maybe<Scalars['String']>,
  readonly assetId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly description?: Maybe<Scalars['String']>,
  readonly description_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly description_matches?: Maybe<Scalars['String']>,
  readonly description_not?: Maybe<Scalars['String']>,
  readonly description_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly extension?: Maybe<Scalars['String']>,
  readonly extension_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly extension_matches?: Maybe<Scalars['String']>,
  readonly extension_not?: Maybe<Scalars['String']>,
  readonly extension_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly label?: Maybe<Scalars['String']>,
  readonly label_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly label_matches?: Maybe<Scalars['String']>,
  readonly label_not?: Maybe<Scalars['String']>,
  readonly label_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mimeType?: Maybe<Scalars['String']>,
  readonly mimeType_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly mimeType_matches?: Maybe<Scalars['String']>,
  readonly mimeType_not?: Maybe<Scalars['String']>,
  readonly mimeType_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly originalFilename?: Maybe<Scalars['String']>,
  readonly originalFilename_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly originalFilename_matches?: Maybe<Scalars['String']>,
  readonly originalFilename_not?: Maybe<Scalars['String']>,
  readonly originalFilename_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly path?: Maybe<Scalars['String']>,
  readonly path_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly path_matches?: Maybe<Scalars['String']>,
  readonly path_not?: Maybe<Scalars['String']>,
  readonly path_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sha1hash?: Maybe<Scalars['String']>,
  readonly sha1hash_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sha1hash_matches?: Maybe<Scalars['String']>,
  readonly sha1hash_not?: Maybe<Scalars['String']>,
  readonly sha1hash_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly size?: Maybe<Scalars['Float']>,
  readonly size_gt?: Maybe<Scalars['Float']>,
  readonly size_gte?: Maybe<Scalars['Float']>,
  readonly size_lt?: Maybe<Scalars['Float']>,
  readonly size_lte?: Maybe<Scalars['Float']>,
  readonly size_not?: Maybe<Scalars['Float']>,
  readonly title?: Maybe<Scalars['String']>,
  readonly title_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly title_matches?: Maybe<Scalars['String']>,
  readonly title_not?: Maybe<Scalars['String']>,
  readonly title_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly url?: Maybe<Scalars['String']>,
  readonly url_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly url_matches?: Maybe<Scalars['String']>,
  readonly url_not?: Maybe<Scalars['String']>,
  readonly url_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISanityImageCrop {
  readonly __typename?: 'SanityImageCrop',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly bottom: Maybe<Scalars['Float']>,
  readonly left: Maybe<Scalars['Float']>,
  readonly right: Maybe<Scalars['Float']>,
  readonly top: Maybe<Scalars['Float']>,
}

export interface ISanityImageDimensions {
  readonly __typename?: 'SanityImageDimensions',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly aspectRatio: Maybe<Scalars['Float']>,
  readonly height: Maybe<Scalars['Float']>,
  readonly width: Maybe<Scalars['Float']>,
}

export interface ISanityImageHotspot {
  readonly __typename?: 'SanityImageHotspot',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly height: Maybe<Scalars['Float']>,
  readonly width: Maybe<Scalars['Float']>,
  readonly x: Maybe<Scalars['Float']>,
  readonly y: Maybe<Scalars['Float']>,
}

export interface ISanityImageMetadata {
  readonly __typename?: 'SanityImageMetadata',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly dimensions: Maybe<ISanityImageDimensions>,
  readonly hasAlpha: Maybe<Scalars['Boolean']>,
  readonly isOpaque: Maybe<Scalars['Boolean']>,
  readonly location: Maybe<IGeopoint>,
  readonly lqip: Maybe<Scalars['String']>,
  readonly palette: Maybe<ISanityImagePalette>,
}

export interface ISanityImagePalette {
  readonly __typename?: 'SanityImagePalette',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly darkMuted: Maybe<ISanityImagePaletteSwatch>,
  readonly darkVibrant: Maybe<ISanityImagePaletteSwatch>,
  readonly dominant: Maybe<ISanityImagePaletteSwatch>,
  readonly lightMuted: Maybe<ISanityImagePaletteSwatch>,
  readonly lightVibrant: Maybe<ISanityImagePaletteSwatch>,
  readonly muted: Maybe<ISanityImagePaletteSwatch>,
  readonly vibrant: Maybe<ISanityImagePaletteSwatch>,
}

export interface ISanityImagePaletteSwatch {
  readonly __typename?: 'SanityImagePaletteSwatch',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly background: Maybe<Scalars['String']>,
  readonly foreground: Maybe<Scalars['String']>,
  readonly population: Maybe<Scalars['Float']>,
  readonly title: Maybe<Scalars['String']>,
}

export interface IScanForRewards  extends IDocument {
  readonly __typename?: 'ScanForRewards',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface IScanForRewardsFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISection  extends IDocument {
  readonly __typename?: 'Section',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly carouselImage: Maybe<IImage>,
  readonly channelExclusions: Maybe<IChannelExclusions>,
  readonly daypart: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly description: Maybe<ILocaleBlockContent>,
  readonly dmbName: Maybe<ILocaleString>,
  readonly headerSuperText: Maybe<ILocaleString>,
  readonly headerText: Maybe<ILocaleString>,
  readonly image: Maybe<IImage>,
  readonly imageDescription: Maybe<ILocaleString>,
  readonly images: Maybe<IImages>,
  readonly name: Maybe<ILocaleString>,
  readonly options: Maybe<ReadonlyArray<Maybe<IComboOrItemOrOfferOrPickerOrSection>>>,
  readonly redirectLink: Maybe<ILocaleUrl>,
  readonly showInStaticMenu: Maybe<Scalars['Boolean']>,
  readonly uiPattern: Maybe<Scalars['String']>,
}

export interface ISectionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu?: Maybe<Scalars['Boolean']>,
  readonly showInStaticMenu_not?: Maybe<Scalars['Boolean']>,
  readonly uiPattern?: Maybe<Scalars['String']>,
  readonly uiPattern_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly uiPattern_matches?: Maybe<Scalars['String']>,
  readonly uiPattern_not?: Maybe<Scalars['String']>,
  readonly uiPattern_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISimpleCard {
  readonly __typename?: 'SimpleCard',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly description: Maybe<ILocaleString>,
  readonly image: Maybe<IImage>,
  readonly title: Maybe<ILocaleString>,
}

export interface ISizeBasedPlu {
  readonly __typename?: 'SizeBasedPlu',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly comboPlu: Maybe<Scalars['String']>,
  readonly comboSize: Maybe<Scalars['String']>,
}

export interface ISlug {
  readonly __typename?: 'Slug',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly current: Maybe<Scalars['String']>,
}

export interface ISocialIconsWidget {
  readonly __typename?: 'SocialIconsWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly facebookUrl: Maybe<ILocaleUrl>,
  readonly instagramUrl: Maybe<ILocaleUrl>,
  readonly twitterUrl: Maybe<ILocaleUrl>,
  readonly youtubeUrl: Maybe<ILocaleUrl>,
}

export interface ISocialIconsWithHeaderWidget {
  readonly __typename?: 'SocialIconsWithHeaderWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly header: Maybe<ILocaleString>,
  readonly socialIconsWidget: Maybe<ISocialIconsWidget>,
}

export interface ISpan {
  readonly __typename?: 'Span',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly marks: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>,
  readonly text: Maybe<Scalars['String']>,
}

export interface IStaticPage  extends IDocument {
  readonly __typename?: 'StaticPage',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly displayIndex: Maybe<Scalars['Float']>,
  readonly image: Maybe<IImage>,
  readonly includedInSitemap: Maybe<Scalars['Boolean']>,
  readonly localePath: Maybe<ILocaleSlug>,
  readonly localeTitle: Maybe<ILocaleString>,
  readonly pageCSS: Maybe<ICss>,
  readonly pageHtml: Maybe<IHtml>,
  readonly pageVariablesRaw: Maybe<Scalars['JSON']>,
  readonly parent: Maybe<IStaticPage>,
  readonly path: Maybe<ISlug>,
  readonly redirectUrl: Maybe<ILocaleString>,
  readonly title: Maybe<Scalars['String']>,
  readonly widgets: Maybe<ReadonlyArray<Maybe<IAccordionWidgetOrAnchorLinksWidgetOrAnchorWidgetOrCallToActionWidgetOrDoubleImageWidgetOrHeaderWidgetOrImageWidgetOrLocaleBlockTextWidgetOrMultiWidgetOrNutritionExplorerWidgetOrNutritionInfoWidgetOrPreviewWidgetOrQuoteWidgetOrVideoWidgetOrYoutubeWidget>>>,
}

export interface IStaticPageFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly displayIndex?: Maybe<Scalars['Float']>,
  readonly displayIndex_gt?: Maybe<Scalars['Float']>,
  readonly displayIndex_gte?: Maybe<Scalars['Float']>,
  readonly displayIndex_lt?: Maybe<Scalars['Float']>,
  readonly displayIndex_lte?: Maybe<Scalars['Float']>,
  readonly displayIndex_not?: Maybe<Scalars['Float']>,
  readonly includedInSitemap?: Maybe<Scalars['Boolean']>,
  readonly includedInSitemap_not?: Maybe<Scalars['Boolean']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly parent?: Maybe<Scalars['ID']>,
  readonly title?: Maybe<Scalars['String']>,
  readonly title_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly title_matches?: Maybe<Scalars['String']>,
  readonly title_not?: Maybe<Scalars['String']>,
  readonly title_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IStaticStringsDictionary  extends IDocument {
  readonly __typename?: 'StaticStringsDictionary',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly cardInformationTranslations: Maybe<ICardInformationTranslations>,
  readonly errorsTranslations: Maybe<IErrorsTranslations>,
  readonly homeScreenTranslations: Maybe<IHomeScreenTranslations>,
  readonly linksTranslations: Maybe<ILinksTranslations>,
  readonly loyaltyTranslations: Maybe<ILoyaltyTranslations>,
  readonly multipleScreensTranslations: Maybe<IMultipleScreensTranslations>,
  readonly offersFeedbackTranslations: Maybe<IOffersFeedbackTranslations>,
  readonly orderPreparationTranslations: Maybe<IOrderPreparationTranslations>,
  readonly paymentScreenTranslations: Maybe<IPaymentScreenTranslations>,
  readonly userAccountTranslations: Maybe<IUserAccountTranslations>,
}

export interface IStaticStringsDictionaryFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface IStoreLocatorContent {
  readonly __typename?: 'StoreLocatorContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly findStoresCard: Maybe<ITextCard>,
  readonly noStoresCard: Maybe<ITextCard>,
  readonly searchThisAreaButtonLabel: Maybe<ILocaleString>,
  readonly tabsContent: Maybe<ITabsContent>,
  readonly tabsStoreLocatorContent: Maybe<ITabsStoreLocatorContent>,
}

export interface ISupportCategory {
  readonly __typename?: 'SupportCategory',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly directTicketProcessingPercentage: Maybe<Scalars['Float']>,
  readonly knowledgeForceIssueId: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
}

export interface ISupportCategoryGroup  extends IDocument {
  readonly __typename?: 'SupportCategoryGroup',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly name: Maybe<ILocaleString>,
  readonly supportSubcategories: Maybe<ReadonlyArray<Maybe<ISupportSubcategory>>>,
  readonly suppotCategoryFaqs: Maybe<ReadonlyArray<Maybe<ISupportFaq>>>,
}

export interface ISupportCategoryGroupFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
}

export interface ISupportCategorySubTypes {
  readonly __typename?: 'SupportCategorySubTypes',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly directTicketProcessingPercentage: Maybe<Scalars['Float']>,
  readonly knowledgeForceIssueId: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
}

export interface ISupportCategoryTypes {
  readonly __typename?: 'SupportCategoryTypes',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
  readonly supportCategorySubTypes: Maybe<ReadonlyArray<Maybe<ISupportCategorySubTypes>>>,
}

export interface ISupportData  extends IDocument {
  readonly __typename?: 'SupportData',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly categories: Maybe<ReadonlyArray<Maybe<ISupportCategory>>>,
  readonly deliveryMissingItemsSubcategory: Maybe<ISupportSubcategory>,
  readonly deliveryNeverArriveSubcategory: Maybe<ISupportSubcategory>,
  readonly orderingIssuesCategoryGroup: Maybe<ISupportCategoryGroup>,
  readonly supportCategories: Maybe<ReadonlyArray<Maybe<ISupportCategoryTypes>>>,
  readonly supportCategoryGroups: Maybe<ReadonlyArray<Maybe<ISupportCategoryGroup>>>,
  readonly supportDataFaqs: Maybe<ReadonlyArray<Maybe<ISupportFaq>>>,
  readonly supportFaqs: Maybe<ReadonlyArray<Maybe<ISupportFaqs>>>,
}

export interface ISupportDataFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly deliveryMissingItemsSubcategory?: Maybe<Scalars['ID']>,
  readonly deliveryNeverArriveSubcategory?: Maybe<Scalars['ID']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly orderingIssuesCategoryGroup?: Maybe<Scalars['ID']>,
}

export interface ISupportFaq  extends IDocument {
  readonly __typename?: 'SupportFaq',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly supportFaqContent: Maybe<ILocaleBlockContent>,
  readonly supportFaqMParticleEvent: Maybe<Scalars['String']>,
  readonly supportFaqTitle: Maybe<ILocaleString>,
}

export interface ISupportFaqFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly supportFaqMParticleEvent?: Maybe<Scalars['String']>,
  readonly supportFaqMParticleEvent_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly supportFaqMParticleEvent_matches?: Maybe<Scalars['String']>,
  readonly supportFaqMParticleEvent_not?: Maybe<Scalars['String']>,
  readonly supportFaqMParticleEvent_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface ISupportFaqs {
  readonly __typename?: 'SupportFaqs',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly accordionWidget: Maybe<IAccordionWidget>,
  readonly key: Maybe<Scalars['String']>,
}

export interface ISupportSubcategory  extends IDocument {
  readonly __typename?: 'SupportSubcategory',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly directTicketProcessingPercentage: Maybe<Scalars['Float']>,
  readonly knowledgeForceIssueId: Maybe<Scalars['String']>,
  readonly name: Maybe<ILocaleString>,
  readonly supportSubcategoryFaq: Maybe<ISupportFaq>,
  readonly supportSubcategoryFaqs: Maybe<ReadonlyArray<Maybe<ISupportFaq>>>,
  readonly supportSubcategoryForwardToOrders: Maybe<Scalars['Boolean']>,
  readonly supportSubcategorySubmitToSutherland: Maybe<Scalars['Boolean']>,
}

export interface ISupportSubcategoryFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly directTicketProcessingPercentage?: Maybe<Scalars['Float']>,
  readonly directTicketProcessingPercentage_gt?: Maybe<Scalars['Float']>,
  readonly directTicketProcessingPercentage_gte?: Maybe<Scalars['Float']>,
  readonly directTicketProcessingPercentage_lt?: Maybe<Scalars['Float']>,
  readonly directTicketProcessingPercentage_lte?: Maybe<Scalars['Float']>,
  readonly directTicketProcessingPercentage_not?: Maybe<Scalars['Float']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly knowledgeForceIssueId?: Maybe<Scalars['String']>,
  readonly knowledgeForceIssueId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly knowledgeForceIssueId_matches?: Maybe<Scalars['String']>,
  readonly knowledgeForceIssueId_not?: Maybe<Scalars['String']>,
  readonly knowledgeForceIssueId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly supportSubcategoryFaq?: Maybe<Scalars['ID']>,
  readonly supportSubcategoryForwardToOrders?: Maybe<Scalars['Boolean']>,
  readonly supportSubcategoryForwardToOrders_not?: Maybe<Scalars['Boolean']>,
  readonly supportSubcategorySubmitToSutherland?: Maybe<Scalars['Boolean']>,
  readonly supportSubcategorySubmitToSutherland_not?: Maybe<Scalars['Boolean']>,
}

export interface ISystemwidePromotion  extends IDocument {
  readonly __typename?: 'SystemwidePromotion',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly endDate: Maybe<Scalars['DateTime']>,
  readonly loyaltyEngineId: Maybe<Scalars['String']>,
  readonly name: Maybe<Scalars['String']>,
  readonly pointsMultiplier: Maybe<Scalars['Float']>,
  readonly startDate: Maybe<Scalars['DateTime']>,
  readonly systemwidePromotion: Maybe<ReadonlyArray<Maybe<IBirthdayMultiplier>>>,
}

export interface ISystemwidePromotionFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly endDate?: Maybe<Scalars['DateTime']>,
  readonly endDate_gt?: Maybe<Scalars['DateTime']>,
  readonly endDate_gte?: Maybe<Scalars['DateTime']>,
  readonly endDate_lt?: Maybe<Scalars['DateTime']>,
  readonly endDate_lte?: Maybe<Scalars['DateTime']>,
  readonly endDate_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly loyaltyEngineId?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly loyaltyEngineId_matches?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not?: Maybe<Scalars['String']>,
  readonly loyaltyEngineId_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name?: Maybe<Scalars['String']>,
  readonly name_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly name_matches?: Maybe<Scalars['String']>,
  readonly name_not?: Maybe<Scalars['String']>,
  readonly name_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly pointsMultiplier?: Maybe<Scalars['Float']>,
  readonly pointsMultiplier_gt?: Maybe<Scalars['Float']>,
  readonly pointsMultiplier_gte?: Maybe<Scalars['Float']>,
  readonly pointsMultiplier_lt?: Maybe<Scalars['Float']>,
  readonly pointsMultiplier_lte?: Maybe<Scalars['Float']>,
  readonly pointsMultiplier_not?: Maybe<Scalars['Float']>,
  readonly startDate?: Maybe<Scalars['DateTime']>,
  readonly startDate_gt?: Maybe<Scalars['DateTime']>,
  readonly startDate_gte?: Maybe<Scalars['DateTime']>,
  readonly startDate_lt?: Maybe<Scalars['DateTime']>,
  readonly startDate_lte?: Maybe<Scalars['DateTime']>,
  readonly startDate_not?: Maybe<Scalars['DateTime']>,
}

export interface ITabDetailContent {
  readonly __typename?: 'TabDetailContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly image: Maybe<ILocaleImage>,
  readonly title: Maybe<ILocaleString>,
}

export interface ITabsContent {
  readonly __typename?: 'TabsContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly favoritesTab: Maybe<ITitleAndBody>,
  readonly nearbyTab: Maybe<ITitleAndBody>,
  readonly recentTab: Maybe<ITitleAndBody>,
}

export interface ITabsStoreLocatorContent {
  readonly __typename?: 'TabsStoreLocatorContent',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly favoritesTab: Maybe<ITabDetailContent>,
  readonly nearbyTab: Maybe<ITabDetailContent>,
  readonly recentTab: Maybe<ITabDetailContent>,
}

export interface ITastySwap {
  readonly __typename?: 'TastySwap',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly selectedProduct: Maybe<IComboOrItem>,
  readonly suggestedProduct: Maybe<IComboOrItem>,
  readonly swapTitle: Maybe<ILocaleString>,
}

export interface ITastySwaps {
  readonly __typename?: 'TastySwaps',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly mainSubtitle: Maybe<ILocaleString>,
  readonly mainTitle: Maybe<ILocaleString>,
  readonly modalSubtitle: Maybe<ILocaleString>,
  readonly modalTitle: Maybe<ILocaleString>,
  readonly swaps: Maybe<ReadonlyArray<Maybe<ITastySwap>>>,
}

export interface ITextCard {
  readonly __typename?: 'TextCard',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly heading: Maybe<ILocaleString>,
  readonly superHeading: Maybe<ILocaleString>,
}

export interface ITextWidget {
  readonly __typename?: 'TextWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly text: Maybe<ILocaleString>,
}

export interface ITier  extends IDocument {
  readonly __typename?: 'Tier',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly description: Maybe<ILocaleBlockContent>,
  readonly image: Maybe<IImage>,
  readonly name: Maybe<ILocaleString>,
  readonly points: Maybe<Scalars['Float']>,
}

export interface ITierFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly points?: Maybe<Scalars['Float']>,
  readonly points_gt?: Maybe<Scalars['Float']>,
  readonly points_gte?: Maybe<Scalars['Float']>,
  readonly points_lt?: Maybe<Scalars['Float']>,
  readonly points_lte?: Maybe<Scalars['Float']>,
  readonly points_not?: Maybe<Scalars['Float']>,
}

export interface ITimelineComponents {
  readonly __typename?: 'TimelineComponents',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly buttonText: Maybe<ILocaleString>,
  readonly description: Maybe<ILocaleString>,
  readonly headerColor: Maybe<Scalars['String']>,
  readonly image: Maybe<ILocaleImages>,
  readonly key: Maybe<Scalars['String']>,
  readonly state: Maybe<Scalars['String']>,
  readonly timelineEventType: Maybe<Scalars['String']>,
  readonly timelineHeader: Maybe<ILocaleString>,
}

export interface ITitleAndBody {
  readonly __typename?: 'TitleAndBody',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly body: Maybe<ILocaleString>,
  readonly title: Maybe<ILocaleString>,
}

export interface ITrending  extends IDocument {
  readonly __typename?: 'Trending',
  readonly _createdAt: Scalars['DateTime'],
  readonly _id: Scalars['ID'],
  readonly _key: Maybe<Scalars['String']>,
  readonly _rev: Scalars['String'],
  readonly _type: Scalars['String'],
  readonly _updatedAt: Scalars['DateTime'],
  readonly promotions: Maybe<ReadonlyArray<Maybe<IComboOrExternalLinkOrItemOrOfferOrPickerOrSection>>>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
}

export interface ITrendingFilter {
  readonly _createdAt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _createdAt_not?: Maybe<Scalars['DateTime']>,
  readonly _id?: Maybe<Scalars['ID']>,
  readonly _id_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _id_matches?: Maybe<Scalars['String']>,
  readonly _id_not?: Maybe<Scalars['ID']>,
  readonly _id_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key?: Maybe<Scalars['String']>,
  readonly _key_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _key_matches?: Maybe<Scalars['String']>,
  readonly _key_not?: Maybe<Scalars['String']>,
  readonly _key_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev?: Maybe<Scalars['String']>,
  readonly _rev_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _rev_matches?: Maybe<Scalars['String']>,
  readonly _rev_not?: Maybe<Scalars['String']>,
  readonly _rev_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type?: Maybe<Scalars['String']>,
  readonly _type_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _type_matches?: Maybe<Scalars['String']>,
  readonly _type_not?: Maybe<Scalars['String']>,
  readonly _type_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly _updatedAt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_gte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lt?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_lte?: Maybe<Scalars['DateTime']>,
  readonly _updatedAt_not?: Maybe<Scalars['DateTime']>,
  readonly is_draft?: Maybe<Scalars['Boolean']>,
  readonly sanityInternalName?: Maybe<Scalars['String']>,
  readonly sanityInternalName_in?: Maybe<ReadonlyArray<Scalars['String']>>,
  readonly sanityInternalName_matches?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not?: Maybe<Scalars['String']>,
  readonly sanityInternalName_not_in?: Maybe<ReadonlyArray<Scalars['String']>>,
}

export interface IUserAccountTranslations {
  readonly __typename?: 'UserAccountTranslations',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly agreeToTerms: Maybe<ILocaleString>,
  readonly limitOneOffer: Maybe<ILocaleString>,
  readonly logInWithTimmyMe: Maybe<ILocaleString>,
  readonly openToVerifyAccount: Maybe<ILocaleString>,
  readonly ordeAndGetRewards: Maybe<ILocaleString>,
  readonly orderAndGetOffers: Maybe<ILocaleString>,
  readonly orderFromYourPhone: Maybe<ILocaleString>,
  readonly previouslyUsedADifferentEmail: Maybe<ILocaleString>,
  readonly protectInformation: Maybe<ILocaleString>,
  readonly reloadYourBalance: Maybe<ILocaleString>,
  readonly reloadingBalance: Maybe<ILocaleString>,
  readonly timmyMePassword: Maybe<ILocaleString>,
  readonly timmyMeUsername: Maybe<ILocaleString>,
}

export interface IVendorConfig {
  readonly __typename?: 'VendorConfig',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly constantPlu: Maybe<Scalars['String']>,
  readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<IPlu>>>,
  readonly parentChildPlu: Maybe<IParentChildPlu>,
  readonly parentSanityId: Maybe<Scalars['String']>,
  readonly pluType: Maybe<Scalars['String']>,
  readonly pullUpLevels: Maybe<Scalars['Float']>,
  readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<IPlu>>>,
  readonly sizeBasedPlu: Maybe<ISizeBasedPlu>,
}

export interface IVendorConfigs {
  readonly __typename?: 'VendorConfigs',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly carrols: Maybe<IVendorConfig>,
  readonly carrolsDelivery: Maybe<IVendorConfig>,
  readonly hdx: Maybe<IVendorConfig>,
  readonly ncr: Maybe<IVendorConfig>,
  readonly ncrDelivery: Maybe<IVendorConfig>,
  readonly productNumber: Maybe<IVendorConfig>,
  readonly productNumberDelivery: Maybe<IVendorConfig>,
  readonly qdi: Maybe<IVendorConfig>,
  readonly qdiDelivery: Maybe<IVendorConfig>,
  readonly qst: Maybe<IVendorConfig>,
  readonly rpos: Maybe<IVendorConfig>,
  readonly rposDelivery: Maybe<IVendorConfig>,
  readonly sicom: Maybe<IVendorConfig>,
  readonly sicomDelivery: Maybe<IVendorConfig>,
  readonly tablet: Maybe<IVendorConfig>,
  readonly tabletDelivery: Maybe<IVendorConfig>,
}

export interface IVendorPlus {
  readonly __typename?: 'VendorPlus',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly carrols: Maybe<Scalars['String']>,
  readonly carrolsDelivery: Maybe<Scalars['String']>,
  readonly ncr: Maybe<Scalars['String']>,
  readonly ncrDelivery: Maybe<Scalars['String']>,
  readonly productNumber: Maybe<Scalars['String']>,
  readonly productNumberDelivery: Maybe<Scalars['String']>,
  readonly qst: Maybe<Scalars['String']>,
  readonly sicom: Maybe<Scalars['String']>,
  readonly sicomDelivery: Maybe<Scalars['String']>,
}

export interface IVerticalLinkListWidget {
  readonly __typename?: 'VerticalLinkListWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly linkWidgets: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>,
}

export interface IVerticalLinkListWithHeaderWidget {
  readonly __typename?: 'VerticalLinkListWithHeaderWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly header: Maybe<ILocaleString>,
  readonly linkWidgets: Maybe<ReadonlyArray<Maybe<ILinkWidget>>>,
}

export interface IVideoWidget {
  readonly __typename?: 'VideoWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly attributionLink: Maybe<Scalars['String']>,
  readonly caption: Maybe<ILocaleString>,
  readonly video: Maybe<ILocaleFile>,
}

export interface IWordmarkAndSocialIcons {
  readonly __typename?: 'WordmarkAndSocialIcons',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly socialIconsWidget: Maybe<ISocialIconsWidget>,
}

export interface IYoutubeWidget {
  readonly __typename?: 'YoutubeWidget',
  readonly _key: Maybe<Scalars['String']>,
  readonly _type: Maybe<Scalars['String']>,
  readonly sanityInternalName: Maybe<Scalars['String']>,
  readonly videoAutoplay: Maybe<Scalars['Boolean']>,
  readonly videoId: Maybe<Scalars['String']>,
}

export type IAboutContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type IAboutContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<(
    { readonly __typename?: 'AppData' }
    & IAboutContentFragment
  )> };

export type IAccountContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type IAccountContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly defaultHeroImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly recentOrderHeroTextLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly communicationPreferencesDisclaimerBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly emailAndPushOptInSettings: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'OptInSettingBoolean' }
      & IOptInSettingBooleanFragment
    ) | (
      { readonly __typename?: 'OptInSettingEmailAndPush' }
      & IOptInSettingEmailAndPushFragment
    ) | (
      { readonly __typename?: 'OptInSettingEnum' }
      & IOptInSettingEnumFragment
    )>>> }> };

export type IAllFeatureIdsQueryVariables = {};


export type IAllFeatureIdsQuery = { readonly __typename?: 'RootQuery', readonly allFeatureAccountForms: ReadonlyArray<{ readonly __typename?: 'FeatureAccountForm', readonly _id: string }>, readonly allFeatureGeolocationModals: ReadonlyArray<{ readonly __typename?: 'FeatureGeolocationModal', readonly _id: string }>, readonly allFeatureHomePages: ReadonlyArray<{ readonly __typename?: 'FeatureHomePage', readonly _id: string }>, readonly allFeatureOffers: ReadonlyArray<{ readonly __typename?: 'FeatureOffers', readonly _id: string }>, readonly allFeatureFooters: ReadonlyArray<{ readonly __typename?: 'FeatureFooter', readonly _id: string }>, readonly allFeatureNavigations: ReadonlyArray<{ readonly __typename?: 'FeatureNavigation', readonly _id: string }>, readonly allFeatureAccountDeletePages: ReadonlyArray<{ readonly __typename?: 'FeatureAccountDeletePage', readonly _id: string }>, readonly allFeatureAccountRequestInfoPages: ReadonlyArray<{ readonly __typename?: 'FeatureAccountRequestInfoPage', readonly _id: string }>, readonly allSupportData: ReadonlyArray<{ readonly __typename?: 'SupportData', readonly _id: string }>, readonly allFeatureStaticMenus: ReadonlyArray<{ readonly __typename?: 'FeatureStaticMenu', readonly _id: string }>, readonly allFeatureMenus: ReadonlyArray<{ readonly __typename?: 'FeatureMenu', readonly _id: string }>, readonly allFeatureKiosks: ReadonlyArray<{ readonly __typename?: 'FeatureKiosk', readonly _id: string }>, readonly allFeatureLayouts: ReadonlyArray<{ readonly __typename?: 'FeatureLayout', readonly _id: string }>, readonly allFeatureDisclaimers: ReadonlyArray<{ readonly __typename?: 'FeatureDisclaimers', readonly _id: string }>, readonly allFeatureAccounts: ReadonlyArray<{ readonly __typename?: 'FeatureAccount', readonly _id: string }>, readonly allFeatureCateringPages: ReadonlyArray<{ readonly __typename?: 'FeatureCateringPage', readonly _id: string }>, readonly allLoyaltyUis: ReadonlyArray<{ readonly __typename?: 'LoyaltyUI', readonly _id: string }>, readonly allFeatureLocationPromos: ReadonlyArray<{ readonly __typename?: 'FeatureLocationPromo', readonly _id: string }>, readonly allFeatureNutritions: ReadonlyArray<{ readonly __typename?: 'FeatureNutrition', readonly _id: string }>, readonly allFeatureGifts: ReadonlyArray<{ readonly __typename?: 'FeatureGift', readonly _id: string }> };

export type ICartContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type ICartContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly loadingGraphics: Maybe<(
      { readonly __typename?: 'LoadingGraphics' }
      & ILoadingGraphicsFragment
    )> }> };

export type IGetComboQueryVariables = {
  id: Scalars['ID']
};


export type IGetComboQuery = { readonly __typename?: 'RootQuery', readonly Combo: Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboFragment
  )> };

export type IContentCardsContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type IContentCardsContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly contentCardsHeader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly contentCardsSubheader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IDayPartsQueryVariables = {
  appDataId: Scalars['ID']
};


export type IDayPartsQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly dayParts: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'DayPart', readonly key: Maybe<string>, readonly endTime: Maybe<string>, readonly startTime: Maybe<string> }>>> }> };

export type IFanFavoritesContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type IFanFavoritesContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly favoriteSection: Maybe<{ readonly __typename?: 'FavoriteSection', readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly fanFavoriteItems: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Combo', readonly _id: string, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> } | { readonly __typename?: 'Item', readonly _id: string, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Offer' } | { readonly __typename?: 'Picker', readonly _id: string, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Section', readonly _id: string, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> }> };

export type IFeatureAccountDeletePageQueryVariables = {
  featureAccountDeletePageId: Scalars['ID']
};


export type IFeatureAccountDeletePageQuery = { readonly __typename?: 'RootQuery', readonly FeatureAccountDeletePage: Maybe<{ readonly __typename?: 'FeatureAccountDeletePage', readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly content: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly confirmButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly cancelButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly errorText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IFeatureAccountFormQueryVariables = {
  featureAccountFormId: Scalars['ID']
};


export type IFeatureAccountFormQuery = { readonly __typename?: 'RootQuery', readonly FeatureAccountForm: Maybe<{ readonly __typename?: 'FeatureAccountForm', readonly postalOrZipDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IFeatureAccountRequestInfoPageQueryVariables = {
  featureAccountRequestInfoPageId: Scalars['ID']
};


export type IFeatureAccountRequestInfoPageQuery = { readonly __typename?: 'RootQuery', readonly FeatureAccountRequestInfoPage: Maybe<{ readonly __typename?: 'FeatureAccountRequestInfoPage', readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly content: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly confirmButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly errorText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IFeatureAccountQueryVariables = {
  featureAccountId: Scalars['ID']
};


export type IFeatureAccountQuery = { readonly __typename?: 'RootQuery', readonly FeatureAccount: Maybe<{ readonly __typename?: 'FeatureAccount', readonly _id: string, readonly emailAndPushOptInSettings: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'OptInSettingBoolean' }
      & IOptInSettingBooleanFragment
    ) | (
      { readonly __typename?: 'OptInSettingEmailAndPush' }
      & IOptInSettingEmailAndPushFragment
    ) | (
      { readonly __typename?: 'OptInSettingEnum' }
      & IOptInSettingEnumFragment
    )>>> }> };

export type IFeatureCateringPageQueryVariables = {
  featureCateringPageId: Scalars['ID']
};


export type IFeatureCateringPageQuery = { readonly __typename?: 'RootQuery', readonly FeatureCateringPage: Maybe<{ readonly __typename?: 'FeatureCateringPage', readonly appUnauthenticated: Maybe<(
      { readonly __typename?: 'CateringPageConfiguration' }
      & ICateringPageConfigurationFragment
    )>, readonly appAuthenticated: Maybe<(
      { readonly __typename?: 'CateringPageConfiguration' }
      & ICateringPageConfigurationFragment
    )>, readonly webUnauthenticated: Maybe<(
      { readonly __typename?: 'CateringPageConfiguration' }
      & ICateringPageConfigurationFragment
    )>, readonly webAuthenticated: Maybe<(
      { readonly __typename?: 'CateringPageConfiguration' }
      & ICateringPageConfigurationFragment
    )> }> };

export type IFeatureDisclaimersQueryVariables = {
  featureDisclaimersId: Scalars['ID']
};


export type IFeatureDisclaimersQuery = { readonly __typename?: 'RootQuery', readonly FeatureDisclaimers: Maybe<{ readonly __typename?: 'FeatureDisclaimers', readonly _id: string, readonly superUpsell: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly calorie: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly price: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly itemAvailability: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly images: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly phoneNumber: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly country: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly offers: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly copyrightAndTrademark: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly reservedRights: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly communicationPreferencesBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }> };

export type IFeatureFooterQueryVariables = {
  featureFooterId: Scalars['ID']
};


export type IFeatureFooterQuery = { readonly __typename?: 'RootQuery', readonly FeatureFooter: Maybe<{ readonly __typename?: 'FeatureFooter', readonly rows: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Row', readonly _key: Maybe<string>, readonly columns: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Column', readonly _key: Maybe<string>, readonly options: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'CopyrightAndLanguageSelector' }
          & ICopyrightAndLanguageSelectorFragment
        ) | (
          { readonly __typename?: 'HighlightedVerticalLinkListWidget' }
          & IHighlightedVerticalLinkListWidgetFragment
        ) | (
          { readonly __typename?: 'HorizontalLinkListWidget' }
          & IHorizontalLinkListWidgetFragment
        ) | (
          { readonly __typename?: 'ImageWidget' }
          & IImageWidgetFragment
        ) | (
          { readonly __typename?: 'SocialIconsWithHeaderWidget' }
          & ISocialIconsWithHeaderWidgetFragment
        ) | (
          { readonly __typename?: 'TextWidget' }
          & ITextWidgetFragment
        ) | (
          { readonly __typename?: 'VerticalLinkListWidget' }
          & IVerticalLinkListWidgetFragment
        ) | (
          { readonly __typename?: 'VerticalLinkListWithHeaderWidget' }
          & IVerticalLinkListWithHeaderWidgetFragment
        ) | (
          { readonly __typename?: 'WordmarkAndSocialIcons' }
          & IWordmarkAndSocialIconsFragment
        )>>> }>>> }>>> }> };

export type IFeatureGeolocationModalQueryVariables = {
  featureGeolocationModalId: Scalars['ID']
};


export type IFeatureGeolocationModalQuery = { readonly __typename?: 'RootQuery', readonly FeatureGeolocationModal: Maybe<{ readonly __typename?: 'FeatureGeolocationModal', readonly logo: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly backgroundImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly deliveryImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IFeatureGiftQueryVariables = {
  featureGiftId: Scalars['ID']
};


export type IFeatureGiftQuery = { readonly __typename?: 'RootQuery', readonly FeatureGift: Maybe<{ readonly __typename?: 'FeatureGift', readonly backgroundImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly subHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly legalDisclaimer: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly receptionModalImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }> }> };

export type IFeatureHomePageQueryVariables = {
  featureHomePageId: Scalars['ID']
};


export type IFeatureHomePageQuery = { readonly __typename?: 'RootQuery', readonly FeatureHomePage: Maybe<{ readonly __typename?: 'FeatureHomePage', readonly appUnauthenticated: Maybe<(
      { readonly __typename?: 'HomePageConfiguration' }
      & IHomePageConfigurationFragment
    )>, readonly appAuthenticated: Maybe<(
      { readonly __typename?: 'HomePageConfiguration' }
      & IHomePageConfigurationFragment
    )>, readonly webUnauthenticated: Maybe<(
      { readonly __typename?: 'HomePageConfiguration' }
      & IHomePageConfigurationFragment
    )>, readonly webAuthenticated: Maybe<(
      { readonly __typename?: 'HomePageConfiguration' }
      & IHomePageConfigurationFragment
    )> }> };

export type IFeatureKioskQueryVariables = {
  featureKioskId: Scalars['ID']
};


export type IFeatureKioskQuery = { readonly __typename?: 'RootQuery', readonly FeatureKiosk: Maybe<{ readonly __typename?: 'FeatureKiosk', readonly _id: string, readonly attractLoopImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IKioskImageFragment
      )> }>, readonly rewardsMainImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IKioskImageFragment = (
  { readonly __typename?: 'Image' }
  & IImageFragment
);

export type IFeatureLayoutQueryVariables = {
  featureLayoutId: Scalars['ID']
};


export type IFeatureLayoutQuery = { readonly __typename?: 'RootQuery', readonly FeatureLayout: Maybe<{ readonly __typename?: 'FeatureLayout', readonly _id: string, readonly defaultHeroImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly recentOrderHeroText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly loadingGraphics: Maybe<(
      { readonly __typename?: 'LoadingGraphics' }
      & ILoadingGraphicsFragment
    )>, readonly geolocationModalImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly appleWalletImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly googlePayImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly giftCardImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly giftCardTextImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IFeatureLocationPromoQueryVariables = {
  featureLocationPromoId: Scalars['ID']
};


export type IFeatureLocationPromoQuery = { readonly __typename?: 'RootQuery', readonly FeatureLocationPromo: Maybe<{ readonly __typename?: 'FeatureLocationPromo', readonly _id: string, readonly promoBackgroundImage: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly menuHeroText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly linkToStaticPage: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }>, readonly bottomText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly failLocationHeader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly failLocationSubtext: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly legalText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IFeatureLoyaltyUiNoRewardQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyUiNoRewardQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly noRewardPoints: Maybe<(
      { readonly __typename?: 'EmptyState' }
      & IEmptyStateFragment
    )> }> };

export type IFeatureLoyaltyUiNotEnrolledQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyUiNotEnrolledQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly notEnrolledState: Maybe<(
      { readonly __typename?: 'EmptyState' }
      & IEmptyStateFragment
    )> }> };

export type IFeatureLoyaltyUiOptInModalQueryVariables = {
  featureLoyaltyUIId: Scalars['ID']
};


export type IFeatureLoyaltyUiOptInModalQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyUI: Maybe<{ readonly __typename?: 'LoyaltyUI', readonly _id: string, readonly optInModal: Maybe<(
      { readonly __typename?: 'OptInModalContent' }
      & IOptInModalFragment
    )>, readonly optInModalError: Maybe<(
      { readonly __typename?: 'OptInModalContent' }
      & IOptInModalFragment
    )>, readonly optInModalLoading: Maybe<{ readonly __typename?: 'OptInModalLoading', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }> };

export type IFeatureMenuQueryVariables = {
  featureMenuId: Scalars['ID']
};


export type IFeatureMenuQuery = { readonly __typename?: 'RootQuery', readonly FeatureMenu: Maybe<{ readonly __typename?: 'FeatureMenu', readonly _id: string, readonly menuHeroImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly menuHeroText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly dayParts: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'DayPart', readonly key: Maybe<string>, readonly endTime: Maybe<string>, readonly startTime: Maybe<string> }>>>, readonly defaultMenu: Maybe<{ readonly __typename?: 'Menu', readonly _id: string }>, readonly cateringMenu: Maybe<{ readonly __typename?: 'Menu', readonly _id: string }>, readonly upsellItemsAtCheckoutRestaurant: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Item', readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }
      & IItemFragment
    )>>>, readonly upsellItemsAtCheckoutDelivery: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Item', readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }
      & IItemFragment
    )>>>, readonly upsellItemsAtCheckoutCatering: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Item', readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }
      & IItemFragment
    )>>> }> };

export type IFeatureNavigationQueryVariables = {
  featureNavigationId: Scalars['ID']
};


export type IFeatureNavigationQuery = { readonly __typename?: 'RootQuery', readonly FeatureNavigation: Maybe<(
    { readonly __typename?: 'FeatureNavigation', readonly aboutMenuEntries: Maybe<(
      { readonly __typename?: 'NavigationSection' }
      & INavigationSectionFragment
    )> }
    & INavigationDesktopFragment
    & INavigationMobileFragment
  )> };

export type IFeatureNutritionQueryVariables = {
  featureNutritionId: Scalars['ID']
};


export type IFeatureNutritionQuery = { readonly __typename?: 'RootQuery', readonly FeatureNutrition: Maybe<{ readonly __typename?: 'FeatureNutrition', readonly _id: string, readonly nutritionTables: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'NutritionTable' }
      & INutritionTableFragment
    )>>> }> };

export type IFeatureOffersQueryVariables = {
  featureOffersId: Scalars['ID']
};


export type IFeatureOffersQuery = { readonly __typename?: 'RootQuery', readonly FeatureOffers: Maybe<{ readonly __typename?: 'FeatureOffers', readonly offersBrowsingPanel: Maybe<(
      { readonly __typename?: 'OffersBrowsingPanel', readonly endOfOffersMessage: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly endOfOffersImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly emptyStateTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly emptyStateBody: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly emptyStateImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }> }
      & IOffersSelectRestaurantCtaFragment
    )>, readonly offersDetailsPanel: Maybe<{ readonly __typename?: 'OffersDetailsPanel', readonly emptyStateTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly emptyStateBody: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly emptyStateImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly emptyStateAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly missingOfferTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly missingOfferBody: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly missingOfferImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly missingOfferAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }>, readonly defaultBackgroundImage: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly sortedOffers: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Offer' }
      & IOffersFragment
    )>>> }> };

export type IFeatureQuizQueryVariables = {
  quizId: Scalars['ID']
};


export type IFeatureQuizQuery = { readonly __typename?: 'RootQuery', readonly FeatureQuiz: Maybe<{ readonly __typename?: 'FeatureQuiz', readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly introPageBackground: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly questionPageBackground: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly resultPageBackground: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly questions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuestionDetails', readonly _id: string, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly responses: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ResponseDetails', readonly _id: string, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly en: Maybe<(
            { readonly __typename?: 'Image' }
            & IImageFragment
          )> }>, readonly resultsValuesDetails: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ResultValueDetails', readonly value: Maybe<number>, readonly result: Maybe<{ readonly __typename?: 'ResultDetails', readonly _id: string, readonly prefix: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }> }> }>>> }>>> }>>>, readonly results: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ResultDetails', readonly _id: string, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly en: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }> }>>> }> };

export type IFeatureStaticMenuQueryVariables = {
  featureStaticMenuId: Scalars['ID']
};


export type IFeatureStaticMenuQuery = { readonly __typename?: 'RootQuery', readonly FeatureStaticMenu: Maybe<(
    { readonly __typename?: 'FeatureStaticMenu' }
    & IItemUnavailableModalFragment
  )> };

export type IAboutContentFragment = { readonly __typename?: 'AppData', readonly _id: string, readonly aboutMenuEntries: Maybe<{ readonly __typename?: 'NavigationSection', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pages: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'NavigationSection', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pages: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'NavigationSection' } | { readonly __typename?: 'StaticPage', readonly title: Maybe<string>, readonly localeTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly path: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }>, readonly localePath: Maybe<{ readonly __typename?: 'LocaleSlug', readonly locale: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }> }>, readonly redirectUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> } | { readonly __typename?: 'StaticPage', readonly title: Maybe<string>, readonly localeTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly path: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }>, readonly localePath: Maybe<{ readonly __typename?: 'LocaleSlug', readonly locale: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }> }>, readonly redirectUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> }>, readonly calorieDisclaimer: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly priceDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly imagesDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly copyrightAndTrademarkDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly reservedRightsDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type INavigationSectionFragment = { readonly __typename?: 'NavigationSection', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pages: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'NavigationSection', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pages: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'NavigationSection' } | { readonly __typename?: 'StaticPage', readonly title: Maybe<string>, readonly localeTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly path: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }>, readonly localePath: Maybe<{ readonly __typename?: 'LocaleSlug', readonly locale: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }> }>, readonly redirectUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> } | { readonly __typename?: 'StaticPage', readonly title: Maybe<string>, readonly localeTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly path: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }>, readonly localePath: Maybe<{ readonly __typename?: 'LocaleSlug', readonly locale: Maybe<{ readonly __typename?: 'Slug', readonly current: Maybe<string> }> }>, readonly redirectUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> };

export type IAllergensFragment = { readonly __typename?: 'OpAllergen', readonly milk: Maybe<number>, readonly eggs: Maybe<number>, readonly fish: Maybe<number>, readonly peanuts: Maybe<number>, readonly shellfish: Maybe<number>, readonly treeNuts: Maybe<number>, readonly soy: Maybe<number>, readonly wheat: Maybe<number>, readonly mustard: Maybe<number>, readonly sesame: Maybe<number>, readonly celery: Maybe<number>, readonly lupin: Maybe<number>, readonly gluten: Maybe<number>, readonly sulphurDioxide: Maybe<number> };

export type IAppDownloadFragment = { readonly __typename?: 'AppDownload', readonly _id: string, readonly details: Maybe<{ readonly __typename?: 'AppDownloadSection', readonly iOSDownloadLink: Maybe<string>, readonly androidDownloadLink: Maybe<string>, readonly primaryImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly headerSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly copy: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly textDecorationLeft: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly textDecorationRight: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )>, readonly submitButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly iOSDownloadImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly androidDownloadImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IBrazeContentCardsFragment = { readonly __typename?: 'BrazeContentCards', readonly _id: string, readonly contentCardsHeader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly contentCardsSubheader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IComboFragment = { readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly showInStaticMenu: Maybe<boolean>, readonly uiPattern: Maybe<string>, readonly hideMainItemDescription: Maybe<boolean>, readonly forceModifiersToBottom: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly mainItem: Maybe<(
    { readonly __typename?: 'Item' }
    & IItemFragment
  )>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ComboSlot', readonly _type: string, readonly _id: string, readonly uiPattern: Maybe<string>, readonly minAmount: Maybe<number>, readonly maxAmount: Maybe<number>, readonly respectMaximum: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )>, readonly optionVisibilitySettings: Maybe<{ readonly __typename?: 'OptionVisibilitySettings', readonly visibleOptions: Maybe<number>, readonly toggleButtonTextClosed: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly toggleButtonTextOpen: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ComboSlotOption', readonly minAmount: Maybe<number>, readonly maxAmount: Maybe<number>, readonly defaultAmount: Maybe<number>, readonly option: Maybe<(
        { readonly __typename?: 'Item' }
        & IItemFragment
      ) | { readonly __typename?: 'Picker', readonly _type: string, readonly uiPattern: Maybe<string>, readonly pickerAspects: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspect', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pickerAspectOptions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspectValue', readonly identifier: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> }>>> } | { readonly __typename?: 'Section' }> }>>> }>>> };

export type IEmptyStateFragment = { readonly __typename?: 'EmptyState', readonly _id: string, readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IImagesFragment
    )> }>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly locale: Maybe<any> }>, readonly buttonAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }> };

export type ICateringPageConfigurationFragment = { readonly __typename?: 'CateringPageConfiguration', readonly components: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'MainHero' }
    & IMainHeroFragment
  )>>> };

export type IHomePageConfigurationFragment = { readonly __typename?: 'HomePageConfiguration', readonly components: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'Alert' }
    & IAlertFrangmentFragment
  ) | (
    { readonly __typename?: 'AppDownload' }
    & IAppDownloadFragment
  ) | (
    { readonly __typename?: 'BrazeContentCards' }
    & IBrazeContentCardsFragment
  ) | (
    { readonly __typename?: 'FanFavorites' }
    & IFanFavoritesFragment
  ) | { readonly __typename?: 'LockedOffers', readonly _id: string } | (
    { readonly __typename?: 'MainHero' }
    & IMainHeroFragment
  ) | (
    { readonly __typename?: 'MarketingTileGroup' }
    & IMarketingTileGroupFragment
  ) | { readonly __typename?: 'OffersSection', readonly _id: string } | (
    { readonly __typename?: 'OurServices' }
    & IOurServicesFragment
  ) | { readonly __typename?: 'RecentItems', readonly _id: string } | { readonly __typename?: 'RollUpTheRimSection', readonly _id: string } | { readonly __typename?: 'ScanForRewards', readonly _id: string } | (
    { readonly __typename?: 'Trending' }
    & ITrendingFragment
  )>>> };

export type IAlertFrangmentFragment = { readonly __typename?: 'Alert', readonly _id: string, readonly heading: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly learnMoreText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly learnMoreUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IMarketingTileFragment = { readonly __typename?: 'MarketingTile', readonly _id: string, readonly textAlignment: Maybe<string>, readonly buttonAlignment: Maybe<string>, readonly textColor: Maybe<string>, readonly backgroundImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IImagesFragment
    )> }>, readonly buttonAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }>, readonly textBlock: Maybe<{ readonly __typename?: 'LocaleTypographyBlock', readonly localeRaw: Maybe<any> }> };

export type IMarketingTileGroupFragment = { readonly __typename?: 'MarketingTileGroup', readonly _id: string, readonly tiles: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'MarketingTile' }
    & IMarketingTileFragment
  ) | { readonly __typename?: 'MarketingTilePair', readonly left: Maybe<(
      { readonly __typename?: 'MarketingTile' }
      & IMarketingTileFragment
    )>, readonly right: Maybe<(
      { readonly __typename?: 'MarketingTile' }
      & IMarketingTileFragment
    )> }>>> };

export type IFanFavoritesFragment = { readonly __typename?: 'FanFavorites', readonly _id: string, readonly fanFavoriteItems: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Combo', readonly _id: string, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> } | { readonly __typename?: 'Item', readonly _id: string, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Offer' } | { readonly __typename?: 'Picker', readonly _id: string, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Section', readonly _id: string, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>>, readonly favoriteSection: Maybe<{ readonly __typename?: 'FavoriteSection', readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IOurServicesFragment = { readonly __typename?: 'OurServices', readonly _id: string, readonly servicesHeaderTextLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly servicesHeroTextLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly ourServicesHeroImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }> };

export type INavigationDesktopFragment = { readonly __typename?: 'FeatureNavigation', readonly navigationDesktop: Maybe<(
    { readonly __typename?: 'NavigationDesktop', readonly _key: Maybe<string>, readonly _type: Maybe<string> }
    & INavigationLinksFragment
    & IAboutMenuEntriesDesktopFragment
  )> };

export type INavigationLinksFragment = { readonly __typename?: 'NavigationDesktop', readonly navigationLinks: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'NavigationDesktopLink' }
    & INavigationLinkFragment
  )>>> };

export type IAboutMenuEntriesDesktopFragment = { readonly __typename?: 'NavigationDesktop', readonly aboutMenuEntries: Maybe<(
    { readonly __typename?: 'NavigationSection' }
    & INavigationSectionFragment
  )> };

export type INavigationLinkFragment = { readonly __typename?: 'NavigationDesktopLink', readonly _key: Maybe<string>, readonly navLink: Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )> };

export type INavigationMobileFragment = { readonly __typename?: 'FeatureNavigation', readonly navigationMobile: Maybe<(
    { readonly __typename?: 'NavigationMobile', readonly _key: Maybe<string>, readonly _type: Maybe<string> }
    & INavigationTabsFragment
    & IAboutMenuEntriesMobileFragment
  )> };

export type INavigationTabsFragment = { readonly __typename?: 'NavigationMobile', readonly navigationTabs: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'NavigationMobileTab' }
    & INavigationTabFragment
  )>>> };

export type IAboutMenuEntriesMobileFragment = { readonly __typename?: 'NavigationMobile', readonly aboutMenuEntries: Maybe<(
    { readonly __typename?: 'NavigationSection' }
    & INavigationSectionFragment
  )> };

export type INavigationTabFragment = { readonly __typename?: 'NavigationMobileTab', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly tabIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly tabIconActive: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly tabLink: Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )> };

export type INutritionItemFragment = { readonly __typename?: 'NutritionItem', readonly _type: Maybe<string>, readonly nutritionKey: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly unit: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly additionalItems: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'NutritionItem', readonly nutritionKey: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly unit: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>> };

export type INutritionItemGroupFragment = { readonly __typename?: 'NutritionItemGroup', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly mainItem: Maybe<(
    { readonly __typename?: 'NutritionItem' }
    & INutritionItemFragment
  )>, readonly lineItems: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'NutritionItem' }
    & INutritionItemFragment
  )>>> };

export type INutritionTableFragment = { readonly __typename?: 'NutritionTable', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly items: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'NutritionItem' }
    & INutritionItemFragment
  ) | (
    { readonly __typename?: 'NutritionItemGroup' }
    & INutritionItemGroupFragment
  )>>> };

export type IItemUnavailableModalFragment = { readonly __typename?: 'FeatureStaticMenu', readonly itemUnavailableModal: Maybe<{ readonly __typename?: 'ItemUnavailableModal', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly continue: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly selectNew: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly itemNotAvailableForDelivery: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type ICopyrightAndLanguageSelectorFragment = { readonly __typename?: 'CopyrightAndLanguageSelector', readonly _type: Maybe<string>, readonly copyrightText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IHighlightedLinkWidgetFragment = { readonly __typename?: 'HighlightedLinkWidget', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> };

export type IHighlightedVerticalLinkListWidgetFragment = { readonly __typename?: 'HighlightedVerticalLinkListWidget', readonly _type: Maybe<string>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly subheader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly highlightedLinks: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'HighlightedLinkWidget' }
    & IHighlightedLinkWidgetFragment
  )>>> };

export type IHorizontalLinkListWidgetFragment = { readonly __typename?: 'HorizontalLinkListWidget', readonly _type: Maybe<string>, readonly linkWidgets: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )>>> };

export type IImageWidgetFragment = { readonly __typename?: 'ImageWidget', readonly _type: Maybe<string>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type ILinkWidgetFragment = { readonly __typename?: 'LinkWidget', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> };

export type ISocialIconsWithHeaderWidgetFragment = { readonly __typename?: 'SocialIconsWithHeaderWidget', readonly _type: Maybe<string>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly socialIconsWidget: Maybe<(
    { readonly __typename?: 'SocialIconsWidget' }
    & ISocialIconsWidgetFragment
  )> };

export type ISocialIconsWidgetFragment = { readonly __typename?: 'SocialIconsWidget', readonly _type: Maybe<string>, readonly instagramUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly facebookUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly youtubeUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly twitterUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> };

export type ITextWidgetFragment = { readonly __typename?: 'TextWidget', readonly _type: Maybe<string>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IVerticalLinkListWithHeaderWidgetFragment = { readonly __typename?: 'VerticalLinkListWithHeaderWidget', readonly _type: Maybe<string>, readonly header: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly linkWidgets: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )>>> };

export type IVerticalLinkListWidgetFragment = { readonly __typename?: 'VerticalLinkListWidget', readonly _type: Maybe<string>, readonly linkWidgets: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'LinkWidget' }
    & ILinkWidgetFragment
  )>>> };

export type IWordmarkAndSocialIconsFragment = { readonly __typename?: 'WordmarkAndSocialIcons', readonly _type: Maybe<string>, readonly socialIconsWidget: Maybe<(
    { readonly __typename?: 'SocialIconsWidget' }
    & ISocialIconsWidgetFragment
  )> };

export type IHeroMaskCardFragment = { readonly __typename?: 'SimpleCard', readonly _key: Maybe<string>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )> };

export type IHeroContentFragment = { readonly __typename?: 'AppData', readonly _id: string, readonly heroTextColor: Maybe<string>, readonly mainHeroImageAuthenticatedLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly mainHeroImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly mainHeroMobileImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly heroTextAuthenticatedLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroTextLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroActionAuthenticated: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly heroAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly heroActionLeft: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly heroActionRight: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly heroSuperTextAuthenticated: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroSubTextAuthenticated: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroSubText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroMaskCards: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'SimpleCard' }
    & IHeroMaskCardFragment
  )>>>, readonly loyaltyHeroAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly loyaltyHeroSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly loyaltyHeroSubText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly heroActionLeftIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly heroActionRightIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }> };

export type IRefFragment = { readonly __typename?: 'Image', readonly asset: Maybe<{ readonly __typename?: 'SanityImageAsset', readonly _id: string }> };

export type IImageFragment = { readonly __typename?: 'Image', readonly hotspot: Maybe<{ readonly __typename?: 'SanityImageHotspot', readonly x: Maybe<number>, readonly y: Maybe<number>, readonly height: Maybe<number>, readonly width: Maybe<number> }>, readonly crop: Maybe<{ readonly __typename?: 'SanityImageCrop', readonly top: Maybe<number>, readonly bottom: Maybe<number>, readonly left: Maybe<number>, readonly right: Maybe<number> }>, readonly asset: Maybe<{ readonly __typename?: 'SanityImageAsset', readonly _id: string, readonly metadata: Maybe<{ readonly __typename?: 'SanityImageMetadata', readonly lqip: Maybe<string>, readonly palette: Maybe<{ readonly __typename?: 'SanityImagePalette', readonly dominant: Maybe<{ readonly __typename?: 'SanityImagePaletteSwatch', readonly background: Maybe<string>, readonly foreground: Maybe<string> }> }> }> }> };

export type IImagesFragment = { readonly __typename?: 'Images', readonly imageDescription: Maybe<string>, readonly app: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )>, readonly kiosk: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )> };

export type IItemOptionFragment = { readonly __typename?: 'ItemOption', readonly componentStyle: Maybe<string>, readonly upsellModifier: Maybe<boolean>, readonly allowMultipleSelections: Maybe<boolean>, readonly injectDefaultSelection: Maybe<boolean>, readonly displayModifierMultiplierName: Maybe<boolean>, readonly minAmount: Maybe<number>, readonly maxAmount: Maybe<number>, readonly _key: Maybe<string>, readonly type: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly displayGroup: Maybe<{ readonly __typename?: 'DisplayGroup', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ItemOptionModifier', readonly default: Maybe<boolean>, readonly _key: Maybe<string>, readonly type: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )>, readonly modifierMultiplier: Maybe<{ readonly __typename?: 'ModifierMultiplier', readonly multiplier: Maybe<number>, readonly prefix: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly vendorConfigs: Maybe<(
        { readonly __typename?: 'VendorConfigs' }
        & IVendorConfigsFragment
      )>, readonly modifier: Maybe<{ readonly __typename?: 'Modifier', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
          { readonly __typename?: 'Image' }
          & IMenuImageFragment
        )>, readonly vendorConfigs: Maybe<(
          { readonly __typename?: 'VendorConfigs' }
          & IVendorConfigsFragment
        )> }> }>, readonly nutrition: Maybe<(
      { readonly __typename?: 'Nutrition' }
      & INutritionFragment
    )> }>>> };

export type IItemFragment = { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly rewardEligible: Maybe<boolean>, readonly labelAsPerPerson: Maybe<boolean>, readonly showInStaticMenu: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )>, readonly nutrition: Maybe<(
    { readonly __typename?: 'Nutrition' }
    & INutritionFragment
  )>, readonly nutritionWithModifiers: Maybe<(
    { readonly __typename?: 'Nutrition' }
    & INutritionFragment
  )>, readonly allergens: Maybe<(
    { readonly __typename?: 'OpAllergen' }
    & IAllergensFragment
  )>, readonly options: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'ItemOption' }
    & IItemOptionFragment
  )>>> };

export type IKioskDataFragment = { readonly __typename?: 'KioskAppData', readonly userNameBlacklist: Maybe<ReadonlyArray<Maybe<string>>>, readonly blacklistCharacterReplaceRules: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'BlacklistCharacterReplaceRule', readonly filter: Maybe<string>, readonly replace: Maybe<string> }>>> };

export type ILoadingGraphicsFragment = { readonly __typename?: 'LoadingGraphics', readonly cartInitialLoader: Maybe<{ readonly __typename?: 'Loader', readonly desktopGraphic: Maybe<(
      { readonly __typename?: 'Image' }
      & IRefFragment
    )>, readonly mobileGraphic: Maybe<(
      { readonly __typename?: 'Image' }
      & IRefFragment
    )>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly text: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IOptInModalFragment = { readonly __typename?: 'OptInModalContent', readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IImagesFragment
    )> }>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IMainHeroFragment = { readonly __typename?: 'MainHero', readonly _id: string, readonly textColor: Maybe<string>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly mobileImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly superText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly mainText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly subText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly action: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly actionRight: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly actionRightIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly actionLeft: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionUrl: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly actionLeftIcon: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>, readonly maskCards: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'SimpleCard' }
    & IHeroMaskCardFragment
  )>>>, readonly loyaltyAction: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IMenuImageFragment = { readonly __typename?: 'Image', readonly hotspot: Maybe<{ readonly __typename?: 'SanityImageHotspot', readonly x: Maybe<number>, readonly y: Maybe<number>, readonly height: Maybe<number>, readonly width: Maybe<number> }>, readonly crop: Maybe<{ readonly __typename?: 'SanityImageCrop', readonly top: Maybe<number>, readonly bottom: Maybe<number>, readonly left: Maybe<number>, readonly right: Maybe<number> }>, readonly asset: Maybe<{ readonly __typename?: 'SanityImageAsset', readonly _id: string, readonly metadata: Maybe<{ readonly __typename?: 'SanityImageMetadata', readonly lqip: Maybe<string>, readonly palette: Maybe<{ readonly __typename?: 'SanityImagePalette', readonly dominant: Maybe<{ readonly __typename?: 'SanityImagePaletteSwatch', readonly background: Maybe<string>, readonly foreground: Maybe<string> }> }> }> }> };

export type IMenuImagesFragment = { readonly __typename?: 'Images', readonly imageDescription: Maybe<string>, readonly app: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly kiosk: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )> };

export type INutritionFragment = { readonly __typename?: 'Nutrition', readonly calories: Maybe<number>, readonly fat: Maybe<number>, readonly saturatedFat: Maybe<number>, readonly transFat: Maybe<number>, readonly cholesterol: Maybe<number>, readonly sodium: Maybe<number>, readonly salt: Maybe<number>, readonly carbohydrates: Maybe<number>, readonly fiber: Maybe<number>, readonly sugar: Maybe<number>, readonly proteins: Maybe<number>, readonly weight: Maybe<number> };

export type IOffersSelectRestaurantCtaFragment = { readonly __typename?: 'OffersBrowsingPanel', readonly offersSelectRestaurantCta: Maybe<{ readonly __typename?: 'OffersSelectRestaurantCta', readonly minimumNumberOfOffers: Maybe<number>, readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly ctaButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> }> };

export type IAllowRedemptionWithoutLoginFragment = { readonly __typename?: 'AllowRedemptionWithoutLogin', readonly ruleSetType: Maybe<string> };

export type IBetweenDatesFragment = { readonly __typename?: 'BetweenDates', readonly endDate: Maybe<any>, readonly startDate: Maybe<any>, readonly ruleSetType: Maybe<string> };

export type IBetweenTimesFragment = { readonly __typename?: 'BetweenTimes', readonly endTime: Maybe<string>, readonly startTime: Maybe<string>, readonly ruleSetType: Maybe<string> };

export type ICartPropertyFragment = { readonly __typename?: 'CartProperty', readonly key: Maybe<string>, readonly negated: Maybe<boolean>, readonly operator: Maybe<string>, readonly value: Maybe<string>, readonly ruleSetType: Maybe<string> };

export type ICoolDownFragment = { readonly __typename?: 'CoolDown', readonly minimumElapsedTimeSeconds: Maybe<number>, readonly ruleSetType: Maybe<string> };

export type IDayOfWeekBandFragment = { readonly __typename?: 'DayOfWeekBand', readonly monday: Maybe<boolean>, readonly tuesday: Maybe<boolean>, readonly wednesday: Maybe<boolean>, readonly thursday: Maybe<boolean>, readonly friday: Maybe<boolean>, readonly saturday: Maybe<boolean>, readonly sunday: Maybe<boolean>, readonly ruleSetType: Maybe<string> };

export type IFirstOrderOnlyFragment = { readonly __typename?: 'FirstOrderOnly', readonly ruleSetType: Maybe<string> };

export type ILimitFragment = { readonly __typename?: 'Limit', readonly interval: Maybe<string>, readonly maximumRedemptions: Maybe<number>, readonly ruleSetType: Maybe<string> };

export type IPaymentCardTypeFragment = { readonly __typename?: 'PaymentCardType', readonly cardType: Maybe<string>, readonly ruleSetType: Maybe<string> };

export type IPurchaseFragment = { readonly __typename?: 'Purchase', readonly quantity: Maybe<number>, readonly sanityId: Maybe<string>, readonly ruleSetType: Maybe<string>, readonly option: Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboMetaFragment
  ) | (
    { readonly __typename?: 'Item' }
    & IItemMetaFragment
  ) | (
    { readonly __typename?: 'Picker' }
    & IPickerMetaFragment
  ) | (
    { readonly __typename?: 'ProductCategory' }
    & IProductCategoryFragment
  )> };

export type IRequiresAssignmentFragment = { readonly __typename?: 'RequiresAssignment', readonly ruleSetType: Maybe<string> };

export type IRestaurantGroupRestrictionListFragment = { readonly __typename?: 'RestaurantGroupRestrictions', readonly ruleSetType: Maybe<string>, readonly restaurantGroupRestrictionList: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RestaurantGroup', readonly restaurants: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Restaurant', readonly number: Maybe<string> }>>> }>>> };

export type IItemMetaFragment = { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> };

export type IComboMetaFragment = { readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem: Maybe<(
    { readonly __typename?: 'Item' }
    & IItemMetaFragment
  )> };

export type IPickerMetaFragment = { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerOption', readonly option: Maybe<(
      { readonly __typename?: 'Combo' }
      & IComboMetaFragment
    ) | (
      { readonly __typename?: 'Item' }
      & IItemMetaFragment
    )> }>>> };

export type IActivateOfferMetaFragment = { readonly __typename?: 'OfferActivation', readonly _type: string };

export type IDiscountOfferMetaFragment = { readonly __typename?: 'OfferDiscount', readonly discountValue: Maybe<number>, readonly discountType: Maybe<string>, readonly _type: string };

export type IOffersFragment = { readonly __typename?: 'Offer', readonly _id: string, readonly _type: string, readonly daypart: Maybe<ReadonlyArray<Maybe<string>>>, readonly forSupport: Maybe<boolean>, readonly offerPrice: Maybe<number>, readonly uiPattern: Maybe<string>, readonly shortCode: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly headerSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly moreInfo: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly howToRedeem: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly backgroundImage: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly offerCTA: Maybe<{ readonly __typename?: 'LinkAction', readonly route: Maybe<string>, readonly actionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly marketPrice: Maybe<{ readonly __typename?: 'Combo', readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> } | { readonly __typename?: 'Item', readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> }>, readonly localizedImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
      { readonly __typename?: 'Images' }
      & IMenuImagesFragment
    )> }>, readonly option: Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboMetaFragment
  ) | (
    { readonly __typename?: 'Item' }
    & IItemMetaFragment
  ) | (
    { readonly __typename?: 'OfferActivation' }
    & IActivateOfferMetaFragment
  ) | (
    { readonly __typename?: 'OfferDiscount' }
    & IDiscountOfferMetaFragment
  ) | (
    { readonly __typename?: 'Picker' }
    & IPickerMetaFragment
  )>, readonly lockedOffersPanel: Maybe<{ readonly __typename?: 'LockedOffersPanel', readonly completedChallengeHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly completedChallengeDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>, readonly promoCodePanel: Maybe<{ readonly __typename?: 'PromoCodePanel', readonly promoCodeLink: Maybe<string>, readonly campaignId: Maybe<string>, readonly promoCodeDescription: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly promoCodeLabel: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'AllowRedemptionWithoutLogin' }
    & IAllowRedemptionWithoutLoginFragment
  ) | { readonly __typename?: 'And', readonly ruleSetType: Maybe<string>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    )>>> } | (
    { readonly __typename?: 'BetweenDates' }
    & IBetweenDatesFragment
  ) | (
    { readonly __typename?: 'BetweenTimes' }
    & IBetweenTimesFragment
  ) | { readonly __typename?: 'CartContainsPlu' } | (
    { readonly __typename?: 'CartProperty' }
    & ICartPropertyFragment
  ) | (
    { readonly __typename?: 'CoolDown' }
    & ICoolDownFragment
  ) | (
    { readonly __typename?: 'DayOfWeekBand' }
    & IDayOfWeekBandFragment
  ) | (
    { readonly __typename?: 'FirstOrderOnly' }
    & IFirstOrderOnlyFragment
  ) | (
    { readonly __typename?: 'Limit' }
    & ILimitFragment
  ) | { readonly __typename?: 'Or', readonly ruleSetType: Maybe<string>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    )>>> } | (
    { readonly __typename?: 'OrderHistory' }
    & IOrderHistoryFragment
  ) | (
    { readonly __typename?: 'PaymentCardType' }
    & IPaymentCardTypeFragment
  ) | (
    { readonly __typename?: 'Purchase' }
    & IPurchaseFragment
  ) | (
    { readonly __typename?: 'RequiresAssignment' }
    & IRequiresAssignmentFragment
  ) | (
    { readonly __typename?: 'RestaurantGroupRestrictions' }
    & IRestaurantGroupRestrictionListFragment
  )>>>, readonly vendorConfigs: Maybe<(
    { readonly __typename?: 'VendorConfigs' }
    & IVendorConfigsFragment
  )> };

export type IOptInSettingBooleanFragment = { readonly __typename?: 'OptInSettingBoolean', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly key: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IOptInSettingEmailAndPushFragment = { readonly __typename?: 'OptInSettingEmailAndPush', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly pushKey: Maybe<string>, readonly emailKey: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IOptInSettingEnumFragment = { readonly __typename?: 'OptInSettingEnum', readonly _key: Maybe<string>, readonly _type: Maybe<string>, readonly key: Maybe<string>, readonly enumStrings: Maybe<ReadonlyArray<Maybe<string>>>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type IOrderHistoryFragment = { readonly __typename?: 'OrderHistory', readonly rangeType: Maybe<string>, readonly from: Maybe<any>, readonly to: Maybe<any>, readonly lastNSeconds: Maybe<number>, readonly isSequential: Maybe<boolean>, readonly ruleSetType: Maybe<string>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'And', readonly ruleSetType: Maybe<string>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    )>>> } | (
    { readonly __typename?: 'BetweenTimes' }
    & IBetweenTimesFragment
  ) | { readonly __typename?: 'CartContainsPlu' } | (
    { readonly __typename?: 'CartProperty' }
    & ICartPropertyFragment
  ) | (
    { readonly __typename?: 'DayOfWeekBand' }
    & IDayOfWeekBandFragment
  ) | { readonly __typename?: 'Or', readonly ruleSetType: Maybe<string>, readonly ruleSet: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'AllowRedemptionWithoutLogin' }
      & IAllowRedemptionWithoutLoginFragment
    ) | (
      { readonly __typename?: 'BetweenDates' }
      & IBetweenDatesFragment
    ) | (
      { readonly __typename?: 'BetweenTimes' }
      & IBetweenTimesFragment
    ) | { readonly __typename?: 'CartContainsPlu' } | (
      { readonly __typename?: 'CartProperty' }
      & ICartPropertyFragment
    ) | (
      { readonly __typename?: 'CoolDown' }
      & ICoolDownFragment
    ) | (
      { readonly __typename?: 'DayOfWeekBand' }
      & IDayOfWeekBandFragment
    ) | (
      { readonly __typename?: 'FirstOrderOnly' }
      & IFirstOrderOnlyFragment
    ) | (
      { readonly __typename?: 'Limit' }
      & ILimitFragment
    ) | (
      { readonly __typename?: 'PaymentCardType' }
      & IPaymentCardTypeFragment
    ) | (
      { readonly __typename?: 'Purchase' }
      & IPurchaseFragment
    ) | (
      { readonly __typename?: 'RequiresAssignment' }
      & IRequiresAssignmentFragment
    ) | (
      { readonly __typename?: 'RestaurantGroupRestrictions' }
      & IRestaurantGroupRestrictionListFragment
    )>>> } | (
    { readonly __typename?: 'PaymentCardType' }
    & IPaymentCardTypeFragment
  ) | (
    { readonly __typename?: 'Purchase' }
    & IPurchaseFragment
  )>>> };

export type IPickerFragment = { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly showInStaticMenu: Maybe<boolean>, readonly uiPattern: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pickerDefaults: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerItemMapping', readonly _key: Maybe<string>, readonly pickerAspectValueIdentifier: Maybe<string>, readonly pickerAspect: Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> }>>>, readonly pickerAspects: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly pickerAspectOptions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspectValue', readonly identifier: Maybe<string>, readonly hideNameInItemPreview: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      )> }>>> }>>>, readonly pickerAspectItemOptionMappings: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerAspectItemOptions', readonly pickerAspect: Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ListItem', readonly value: Maybe<string> }>>> }>>>, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerOption', readonly _key: Maybe<string>, readonly default: Maybe<boolean>, readonly type: Maybe<string>, readonly pickerItemMappings: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerItemMapping', readonly pickerAspectValueIdentifier: Maybe<string>, readonly pickerAspect: Maybe<{ readonly __typename?: 'PickerAspect', readonly _id: string }> }>>>, readonly option: Maybe<(
      { readonly __typename?: 'Combo', readonly _key: Maybe<string>, readonly _id: string }
      & IComboFragment
    ) | (
      { readonly __typename?: 'Item', readonly _key: Maybe<string> }
      & IItemFragment
    )> }>>>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly quickConfigs: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'QuickConfig' }
    & IQuickConfigFragment
  )>>> };

export type IProductCategoryFragment = { readonly __typename?: 'ProductCategory', readonly _id: string, readonly hierarchyLevel: Maybe<string>, readonly ruleSetType: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )> };

export type IQuickConfigFragment = { readonly __typename?: 'QuickConfig', readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rules: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'QuickConfigRule', readonly itemOptions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'ListItem', readonly value: Maybe<string> }>>>, readonly modifier: Maybe<{ readonly __typename?: 'ListItem', readonly value: Maybe<string> }> }>>> };

export type ISectionFragment = { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly daypart: Maybe<ReadonlyArray<Maybe<string>>>, readonly showInStaticMenu: Maybe<boolean>, readonly redirectLink: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly image: Maybe<(
    { readonly __typename?: 'Image' }
    & IMenuImageFragment
  )>, readonly carouselImage: Maybe<(
    { readonly __typename?: 'Image' }
    & IImageFragment
  )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly headerSuperText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly headerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly options: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'Combo' }
    & IComboFragment
  ) | (
    { readonly __typename?: 'Item' }
    & IItemFragment
  ) | { readonly __typename?: 'Offer' } | (
    { readonly __typename?: 'Picker' }
    & IPickerFragment
  ) | { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly uiPattern: Maybe<string>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly redirectLink: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly imageDescription: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly options: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Combo' }
      & IComboFragment
    ) | (
      { readonly __typename?: 'Item' }
      & IItemFragment
    ) | { readonly __typename?: 'Offer' } | (
      { readonly __typename?: 'Picker' }
      & IPickerFragment
    ) | { readonly __typename?: 'Section', readonly _type: string, readonly _id: string, readonly uiPattern: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly options: Maybe<ReadonlyArray<Maybe<(
        { readonly __typename?: 'Combo' }
        & IComboFragment
      ) | (
        { readonly __typename?: 'Item' }
        & IItemFragment
      ) | { readonly __typename?: 'Offer' } | (
        { readonly __typename?: 'Picker' }
        & IPickerFragment
      ) | { readonly __typename?: 'Section' }>>> }>>> }>>> };

export type ISiteAlertFragment = { readonly __typename?: 'AppData', readonly siteAlert: Maybe<{ readonly __typename?: 'Alert', readonly heading: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly learnMoreText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly learnMoreUrl: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type ITabDetailContentFragment = { readonly __typename?: 'TabDetailContent', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }> };

export type ITitleAndBodyFragment = { readonly __typename?: 'TitleAndBody', readonly title: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly body: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> };

export type ITrendingFragment = { readonly __typename?: 'Trending', readonly _id: string, readonly promotions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )> } | { readonly __typename?: 'ExternalLink', readonly _key: Maybe<string>, readonly url: Maybe<string>, readonly type: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )> } | { readonly __typename?: 'Offer', readonly _id: string, readonly _type: string } | { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )> } | { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
      { readonly __typename?: 'Image' }
      & IImageFragment
    )> }>>> };

export type IVendorConfigFragment = { readonly __typename?: 'VendorConfig', readonly pluType: Maybe<string>, readonly parentSanityId: Maybe<string>, readonly pullUpLevels: Maybe<number>, readonly constantPlu: Maybe<string>, readonly quantityBasedPlu: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Plu', readonly quantity: Maybe<number>, readonly plu: Maybe<string>, readonly qualifier: Maybe<string> }>>>, readonly multiConstantPlus: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Plu', readonly quantity: Maybe<number>, readonly plu: Maybe<string>, readonly qualifier: Maybe<string> }>>>, readonly parentChildPlu: Maybe<{ readonly __typename?: 'ParentChildPlu', readonly plu: Maybe<string>, readonly childPlu: Maybe<string> }>, readonly sizeBasedPlu: Maybe<{ readonly __typename?: 'SizeBasedPlu', readonly comboPlu: Maybe<string>, readonly comboSize: Maybe<string> }> };

export type IVendorConfigsFragment = { readonly __typename?: 'VendorConfigs', readonly carrols: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly carrolsDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly ncr: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly ncrDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly productNumber: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly productNumberDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly sicom: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly sicomDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qdi: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly qdiDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly rpos: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly tablet: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )>, readonly tabletDelivery: Maybe<(
    { readonly __typename?: 'VendorConfig' }
    & IVendorConfigFragment
  )> };

export type IHeroContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type IHeroContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<(
    { readonly __typename?: 'AppData' }
    & IHeroContentFragment
  )> };

export type IGetItemQueryVariables = {
  id: Scalars['ID']
};


export type IGetItemQuery = { readonly __typename?: 'RootQuery', readonly Item: Maybe<(
    { readonly __typename?: 'Item' }
    & IItemFragment
  )> };

export type IKioskAppDataQueryVariables = {
  appDataId: Scalars['ID']
};


export type IKioskAppDataQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly kioskAppData: Maybe<(
      { readonly __typename?: 'KioskAppData' }
      & IKioskDataFragment
    )> }> };

export type ILoyaltyContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type ILoyaltyContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly giftCardImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly giftCardTextImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly appleWalletImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly googlePayImage: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly rewardsMainImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type ISingleLoyaltyContentQueryVariables = {};


export type ISingleLoyaltyContentQuery = { readonly __typename?: 'RootQuery', readonly allLoyaltyContents: ReadonlyArray<{ readonly __typename?: 'LoyaltyContent', readonly _id: string }> };

export type IBirthdayLegalTextQueryVariables = {
  loyaltyContentId: Scalars['ID']
};


export type IBirthdayLegalTextQuery = { readonly __typename?: 'RootQuery', readonly LoyaltyContent: Maybe<{ readonly __typename?: 'LoyaltyContent', readonly birthdayLegalText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IMainMenuContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type IMainMenuContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly calorieDisclaimer: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly cateringMenu: Maybe<{ readonly __typename?: 'Menu', readonly _id: string }>, readonly defaultMenu: Maybe<{ readonly __typename?: 'Menu', readonly _id: string }>, readonly menuHeroImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly menuHeroTextLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly superUpsellDisclaimer: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }> };

export type IPosDataQueryVariables = {
  id: Scalars['ID']
};


export type IPosDataQuery = { readonly __typename?: 'RootQuery', readonly RestaurantPosData: Maybe<{ readonly __typename?: 'RestaurantPosData', readonly _id: string, readonly disableChickenSandwich: Maybe<boolean>, readonly plus: Maybe<string>, readonly deliveryPLUs: Maybe<string> }> };

export type INutritionContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type INutritionContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly calorieDisclaimer: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }> };

export type IOurServicesContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type IOurServicesContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly servicesHeaderTextLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly servicesHeroTextLocale: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly ourServicesHeroImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IGetPickerQueryVariables = {
  id: Scalars['ID']
};


export type IGetPickerQuery = { readonly __typename?: 'RootQuery', readonly Picker: Maybe<(
    { readonly __typename?: 'Picker' }
    & IPickerFragment
  )> };

export type IGetProductCategoryQueryVariables = {
  id: Scalars['ID']
};


export type IGetProductCategoryQuery = { readonly __typename?: 'RootQuery', readonly ProductCategory: Maybe<(
    { readonly __typename?: 'ProductCategory' }
    & IProductCategoryFragment
  )> };

export type IPromotionsContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type IPromotionsContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly promotions: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Combo', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      )> } | { readonly __typename?: 'ExternalLink', readonly _key: Maybe<string>, readonly url: Maybe<string>, readonly type: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
          { readonly __typename?: 'Image' }
          & IImageFragment
        )> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly link: Maybe<{ readonly __typename?: 'LocaleUrl', readonly locale: Maybe<string> }> } | { readonly __typename?: 'Item', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      )> } | { readonly __typename?: 'Offer', readonly _id: string, readonly _type: string } | { readonly __typename?: 'Picker', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IMenuImageFragment
      )> } | { readonly __typename?: 'Section', readonly _id: string, readonly _type: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>>> }> };

export type ILoyaltyRewardsByEngineIdQueryVariables = {
  ids: ReadonlyArray<Scalars['String']>
};


export type ILoyaltyRewardsByEngineIdQuery = { readonly __typename?: 'RootQuery', readonly allRewards: ReadonlyArray<{ readonly __typename?: 'Reward', readonly _id: string, readonly loyaltyEngineId: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly en: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly enRaw: Maybe<any> }>, readonly moreInfo: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly enRaw: Maybe<any> }>, readonly howToRedeem: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly enRaw: Maybe<any> }>, readonly backgroundImage: Maybe<(
      { readonly __typename?: 'Image' }
      & IMenuImageFragment
    )>, readonly image: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly incentives: Maybe<ReadonlyArray<Maybe<{ readonly __typename: 'Combo', readonly _id: string, readonly _type: string, readonly mainItem: Maybe<{ readonly __typename?: 'Item', readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }> } | { readonly __typename: 'Item', readonly _id: string, readonly _type: string, readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> } | { readonly __typename: 'OfferDiscount', readonly _id: string, readonly _type: string } | { readonly __typename: 'Picker', readonly _id: string, readonly _type: string, readonly options: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'PickerOption', readonly option: Maybe<{ readonly __typename: 'Combo', readonly mainItem: Maybe<{ readonly __typename?: 'Item', readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }> } | { readonly __typename: 'Item', readonly operationalItem: Maybe<{ readonly __typename?: 'OpItem', readonly daypart: Maybe<ReadonlyArray<Maybe<string>>> }> }> }>>> }>>>, readonly vendorConfigs: Maybe<(
      { readonly __typename?: 'VendorConfigs' }
      & IVendorConfigsFragment
    )> }> };

export type IGetAllRollUpTheRimsQueryVariables = {};


export type IGetAllRollUpTheRimsQuery = { readonly __typename?: 'RootQuery', readonly allRollUpTheRims: ReadonlyArray<{ readonly __typename?: 'RollUpTheRim', readonly _id: string, readonly firstDrawing: Maybe<any>, readonly secondDrawing: Maybe<any>, readonly thirdDrawing: Maybe<any>, readonly fourthDrawing: Maybe<any>, readonly gamePlayHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly gamePlayTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameErrorHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly gameErrorBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameRollButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly gamePlayImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly desktopGamePlayImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly gamePlayButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly rollsRemainingText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameplayRollAudio: Maybe<{ readonly __typename?: 'File', readonly asset: Maybe<{ readonly __typename?: 'SanityFileAsset', readonly url: Maybe<string> }> }>, readonly gameplayWinAudio: Maybe<{ readonly __typename?: 'File', readonly asset: Maybe<{ readonly __typename?: 'SanityFileAsset', readonly url: Maybe<string> }> }>, readonly timelineHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly timelineTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly timelineComponents: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'TimelineComponents', readonly key: Maybe<string>, readonly state: Maybe<string>, readonly timelineEventType: Maybe<string>, readonly headerColor: Maybe<string>, readonly timelineHeader: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly description: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly buttonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
          { readonly __typename?: 'Images' }
          & IImagesFragment
        )> }> }>>>, readonly timelinePrizeClaimedText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly timelineRollSharedText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly timelineConfetti: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly emptyTimelineTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly emptyTimelineButtonBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly emptyTimelineImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly timelineButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly timelineTextLoadMore: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly desktopShareImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly prizesHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly prizesSeparator: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly prizesTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly prizesButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly prizesImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly planeImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly sponsorTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly sponsorsImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly desktopPrizesImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly sharedLandingBadLinkButtonBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly sharedLandingBadLinkHeaderBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly sharedLandingBadLinkTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly sharedLandingBadLinkImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly shareRollTo: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollYouHave: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollShare: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollIncrementText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollReclaimButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollsDisclaimer: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly winnersHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly winnersTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly winnersButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly reusablesHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly reusablesTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly reusablesButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly reusablesImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly desktopReusablesImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly modalTimelineHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly endText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly countdownText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly entriesText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly nextDrawText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly moneyStackImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly prizes: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Prizes', readonly excludeInAlberta: Maybe<boolean>, readonly numberAwarded: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly header: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly text: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
          { readonly __typename?: 'Images' }
          & IImagesFragment
        )> }>, readonly buttonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>>, readonly rulesLinkText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rulesLinkPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly footerLinks: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'RutrFooter', readonly _key: Maybe<string>, readonly footerLinkLocalizedPath: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly footerLinkText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly footerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly footerTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>>>, readonly modalWinnersHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly modalWinnersTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly gameNeedHelp: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly cupImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly gameBackgroundImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly gameButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly rewardsHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly rewards: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'Rewards', readonly key: Maybe<string>, readonly requireSkillsQuestion: Maybe<boolean>, readonly rewardName: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly image: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
          { readonly __typename?: 'Images' }
          & IImagesFragment
        )> }>, readonly rewardYouWonMessageBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly allSetBlurbBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>>, readonly allSetHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly allSetEmailSentText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly allSetLegalBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly allSetClaimFailedHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly errorTimelineText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly errorTimelineButtonText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly errorTimelineImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly homepageHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly homepageCupImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly homepageBackgroundImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly enterButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly rulesText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly rrrollButtonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareRollHeader: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareRollTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareRollURL: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollLinkTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollReclaimQuestionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollReclaimDescriptionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly shareRollsImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly shareRollsBackgroundImage: Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>, readonly howManyTextBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly shareRolluttonText: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly rollupAnimationFrames: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'LocaleImages', readonly locale: Maybe<(
        { readonly __typename?: 'Images' }
        & IImagesFragment
      )> }>>>, readonly skillsQuestionHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly skillsQuestionDescriptionText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly skillsQuestionMathBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly skillsQuestionHintText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly skillsQuestionReleaseBlock: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }>, readonly skillsQuestionAcknowledgeText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly localeSwitchModalHeaderText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly localeSwitchModalPrimaryText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly localeSwitchModalSecondaryText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly localeSwitchModalDisclaimerText: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type IGetSectionQueryVariables = {
  id: Scalars['ID']
};


export type IGetSectionQuery = { readonly __typename?: 'RootQuery', readonly Section: Maybe<(
    { readonly __typename?: 'Section' }
    & ISectionFragment
  )> };

export type ISignupContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type ISignupContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly phoneNumberDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly countryDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }> };

export type ISingleAppDataQueryVariables = {};


export type ISingleAppDataQuery = { readonly __typename?: 'RootQuery', readonly allAppData: ReadonlyArray<{ readonly __typename?: 'AppData', readonly _id: string }> };

export type ISiteAlertQueryVariables = {
  appDataId: Scalars['ID']
};


export type ISiteAlertQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<(
    { readonly __typename?: 'AppData', readonly _id: string }
    & ISiteAlertFragment
  )> };

export type ISortedOffersQueryVariables = {
  appDataId: Scalars['ID']
};


export type ISortedOffersQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly offersDisclaimer: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly sortedOffers: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Offer' }
      & IOffersFragment
    )>>> }> };

export type IStaticPagesContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type IStaticPagesContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly defaultHeroImageLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }> }> };

export type IStoreLocatorContentQueryVariables = {
  appDataId: Scalars['ID']
};


export type IStoreLocatorContentQuery = { readonly __typename?: 'RootQuery', readonly AppData: Maybe<{ readonly __typename?: 'AppData', readonly _id: string, readonly geolocationModalImageUseLocale: Maybe<{ readonly __typename?: 'LocaleImage', readonly locale: Maybe<(
        { readonly __typename?: 'Image' }
        & IImageFragment
      )> }>, readonly storeLocatorContent: Maybe<{ readonly __typename?: 'StoreLocatorContent', readonly searchThisAreaButtonLabel: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly tabsStoreLocatorContent: Maybe<{ readonly __typename?: 'TabsStoreLocatorContent', readonly nearbyTab: Maybe<(
          { readonly __typename?: 'TabDetailContent' }
          & ITabDetailContentFragment
        )>, readonly favoritesTab: Maybe<(
          { readonly __typename?: 'TabDetailContent' }
          & ITabDetailContentFragment
        )>, readonly recentTab: Maybe<(
          { readonly __typename?: 'TabDetailContent' }
          & ITabDetailContentFragment
        )> }> }> }> };

export type IGetSupportDataQueryVariables = {
  supportDataId: Scalars['ID']
};


export type IGetSupportDataQuery = { readonly __typename?: 'RootQuery', readonly SupportData: Maybe<{ readonly __typename?: 'SupportData', readonly _id: string, readonly supportCategoryGroups: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportCategoryGroup', readonly _id: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportSubcategories: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId: Maybe<string>, readonly supportSubcategoryForwardToOrders: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportSubcategoryFaqs: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent: Maybe<string>, readonly supportFaqTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportFaqContent: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>> }>>> }>>>, readonly deliveryNeverArriveSubcategory: Maybe<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly deliveryMissingItemsSubcategory: Maybe<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId: Maybe<string>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }> }>, readonly orderingIssuesCategoryGroup: Maybe<{ readonly __typename?: 'SupportCategoryGroup', readonly _id: string }>, readonly supportDataFaqs: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent: Maybe<string>, readonly supportFaqTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportFaqContent: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>> }> };

export type IGetSupportSubcategoryQueryVariables = {
  id: Scalars['ID']
};


export type IGetSupportSubcategoryQuery = { readonly __typename?: 'RootQuery', readonly SupportSubcategory: Maybe<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly _type: string, readonly _createdAt: any, readonly _key: Maybe<string>, readonly _rev: string, readonly _updatedAt: any, readonly knowledgeForceIssueId: Maybe<string>, readonly directTicketProcessingPercentage: Maybe<number>, readonly supportSubcategoryForwardToOrders: Maybe<boolean>, readonly supportSubcategorySubmitToSutherland: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportSubcategoryFaqs: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent: Maybe<string>, readonly supportFaqTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportFaqContent: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>>, readonly supportSubcategoryFaq: Maybe<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent: Maybe<string>, readonly supportFaqTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportFaqContent: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }> }> };

export type IGetSupportCategoryGroupQueryVariables = {
  id: Scalars['ID']
};


export type IGetSupportCategoryGroupQuery = { readonly __typename?: 'RootQuery', readonly SupportCategoryGroup: Maybe<{ readonly __typename?: 'SupportCategoryGroup', readonly _id: string, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportSubcategories: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportSubcategory', readonly _id: string, readonly knowledgeForceIssueId: Maybe<string>, readonly supportSubcategoryForwardToOrders: Maybe<boolean>, readonly name: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportSubcategoryFaqs: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'SupportFaq', readonly supportFaqMParticleEvent: Maybe<string>, readonly supportFaqTitle: Maybe<{ readonly __typename?: 'LocaleString', readonly locale: Maybe<string> }>, readonly supportFaqContent: Maybe<{ readonly __typename?: 'LocaleBlockContent', readonly localeRaw: Maybe<any> }> }>>> }>>> }> };

export const ImageFragmentFragmentDoc = gql`
    fragment ImageFragment on Image {
  hotspot {
    x
    y
    height
    width
  }
  crop {
    top
    bottom
    left
    right
  }
  asset {
    metadata {
      lqip
      palette {
        dominant {
          background
          foreground
        }
      }
    }
    _id
  }
}
    `;
export const KioskImageFragmentFragmentDoc = gql`
    fragment KioskImageFragment on Image {
  ...ImageFragment
}
    ${ImageFragmentFragmentDoc}`;
export const AboutContentFragmentDoc = gql`
    fragment AboutContent on AppData {
  _id
  aboutMenuEntries {
    name {
      locale: en
    }
    pages {
      ... on StaticPage {
        title
        localeTitle {
          locale: en
        }
        path {
          current
        }
        localePath {
          locale: en {
            current
          }
        }
        redirectUrl {
          locale: en
        }
      }
      ... on NavigationSection {
        name {
          locale: en
        }
        pages {
          ... on StaticPage {
            title
            localeTitle {
              locale: en
            }
            path {
              current
            }
            localePath {
              locale: en {
                current
              }
            }
            redirectUrl {
              locale: en
            }
          }
        }
      }
    }
  }
  calorieDisclaimer {
    localeRaw: enRaw
  }
  priceDisclaimer {
    locale: en
  }
  imagesDisclaimer {
    locale: en
  }
  copyrightAndTrademarkDisclaimer {
    locale: en
  }
  reservedRightsDisclaimer {
    locale: en
  }
}
    `;
export const ImagesFragmentFragmentDoc = gql`
    fragment ImagesFragment on Images {
  app {
    ...ImageFragment
  }
  kiosk {
    ...ImageFragment
  }
  imageDescription
}
    ${ImageFragmentFragmentDoc}`;
export const EmptyStateFragmentFragmentDoc = gql`
    fragment EmptyStateFragment on EmptyState {
  _id
  headerText {
    locale: en
  }
  image {
    locale: en {
      ...ImagesFragment
    }
  }
  title {
    locale: en
  }
  description {
    locale: enRaw
  }
  buttonAction {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
    route
  }
}
    ${ImagesFragmentFragmentDoc}`;
export const HeroMaskCardFragmentDoc = gql`
    fragment HeroMaskCard on SimpleCard {
  _key
  title {
    locale: en
  }
  description {
    locale: en
  }
  image {
    ...ImageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export const MainHeroFragmentFragmentDoc = gql`
    fragment MainHeroFragment on MainHero {
  _id
  image {
    locale: en {
      ...ImageFragment
    }
  }
  mobileImage {
    locale: en {
      ...ImageFragment
    }
  }
  superText {
    locale: en
  }
  mainText {
    locale: en
  }
  subText {
    locale: en
  }
  textColor
  action {
    route
    actionUrl {
      locale: en
    }
    actionText {
      locale: en
    }
  }
  actionRight {
    route
    actionUrl {
      locale: en
    }
    actionText {
      locale: en
    }
  }
  actionRightIcon {
    locale: en {
      ...ImageFragment
    }
  }
  actionLeft {
    route
    actionUrl {
      locale: en
    }
    actionText {
      locale: en
    }
  }
  actionLeftIcon {
    locale: en {
      ...ImageFragment
    }
  }
  maskCards {
    ...HeroMaskCard
  }
  loyaltyAction {
    route
    actionText {
      locale: en
    }
  }
}
    ${ImageFragmentFragmentDoc}
${HeroMaskCardFragmentDoc}`;
export const CateringPageConfigurationFragmentFragmentDoc = gql`
    fragment CateringPageConfigurationFragment on CateringPageConfiguration {
  components {
    ... on MainHero {
      ...MainHeroFragment
    }
  }
}
    ${MainHeroFragmentFragmentDoc}`;
export const BrazeContentCardsFragmentFragmentDoc = gql`
    fragment BrazeContentCardsFragment on BrazeContentCards {
  _id
  contentCardsHeader: sectionheader {
    locale: en
  }
  contentCardsSubheader: sectionSubheader {
    locale: en
  }
}
    `;
export const AlertFrangmentFragmentDoc = gql`
    fragment AlertFrangment on Alert {
  _id
  heading {
    locale: en
  }
  body {
    locale: en
  }
  learnMoreText {
    locale: en
  }
  learnMoreUrl {
    locale: en
  }
}
    `;
export const MarketingTileFragmentFragmentDoc = gql`
    fragment MarketingTileFragment on MarketingTile {
  _id
  textAlignment
  backgroundImage {
    locale: en {
      ...ImagesFragment
    }
  }
  buttonAction {
    actionText {
      locale: en
    }
    actionUrl {
      locale: en
    }
    route
  }
  buttonAlignment
  textColor
  textBlock {
    localeRaw: enRaw
  }
}
    ${ImagesFragmentFragmentDoc}`;
export const MarketingTileGroupFragmentFragmentDoc = gql`
    fragment MarketingTileGroupFragment on MarketingTileGroup {
  _id
  tiles {
    ... on MarketingTile {
      ...MarketingTileFragment
    }
    ... on MarketingTilePair {
      left {
        ...MarketingTileFragment
      }
      right {
        ...MarketingTileFragment
      }
    }
  }
}
    ${MarketingTileFragmentFragmentDoc}`;
export const MenuImageFragmentFragmentDoc = gql`
    fragment MenuImageFragment on Image {
  hotspot {
    x
    y
    height
    width
  }
  crop {
    top
    bottom
    left
    right
  }
  asset {
    metadata {
      lqip
      palette {
        dominant {
          background
          foreground
        }
      }
    }
    _id
  }
}
    `;
export const TrendingFragmentFragmentDoc = gql`
    fragment TrendingFragment on Trending {
  _id
  promotions {
    ... on Picker {
      _id
      _type
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      image {
        ...MenuImageFragment
      }
    }
    ... on Item {
      _id
      _type
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      image {
        ...MenuImageFragment
      }
    }
    ... on Combo {
      _id
      _type
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      image {
        ...MenuImageFragment
      }
    }
    ... on Section {
      _id
      _type
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      image {
        ...ImageFragment
      }
    }
    ... on Offer {
      _id
      _type
    }
    ... on ExternalLink {
      _key
      type: _type
      name {
        locale: en
      }
      image {
        locale: en {
          ...ImageFragment
        }
      }
      description {
        locale: en
      }
      link {
        locale: en
      }
      url
    }
  }
}
    ${MenuImageFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;
export const FanFavoritesFragmentFragmentDoc = gql`
    fragment FanFavoritesFragment on FanFavorites {
  _id
  fanFavoriteItems {
    ... on Picker {
      _id
      image {
        ...MenuImageFragment
      }
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      imageDescription {
        locale: en
      }
    }
    ... on Item {
      _id
      image {
        ...MenuImageFragment
      }
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      imageDescription {
        locale: en
      }
    }
    ... on Combo {
      _id
      image {
        ...MenuImageFragment
      }
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
    }
    ... on Section {
      _id
      image {
        ...MenuImageFragment
      }
      name {
        locale: en
      }
      description {
        localeRaw: enRaw
      }
      imageDescription {
        locale: en
      }
    }
  }
  favoriteSection {
    headerText {
      locale: en
    }
  }
}
    ${MenuImageFragmentFragmentDoc}`;
export const OurServicesFragmentFragmentDoc = gql`
    fragment OurServicesFragment on OurServices {
  _id
  servicesHeaderTextLocale {
    locale: en
  }
  servicesHeroTextLocale {
    locale: en
  }
  ourServicesHeroImageLocale {
    locale: en {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const AppDownloadFragmentFragmentDoc = gql`
    fragment AppDownloadFragment on AppDownload {
  _id
  details {
    primaryImage {
      locale: en {
        ...ImageFragment
      }
    }
    headerSuperText {
      locale: en
    }
    header {
      locale: en
    }
    copy {
      locale: en
    }
    textDecorationLeft {
      ...ImageFragment
    }
    textDecorationRight {
      ...ImageFragment
    }
    submitButtonText {
      locale: en
    }
    iOSDownloadLink
    iOSDownloadImage {
      locale: en {
        ...ImageFragment
      }
    }
    androidDownloadLink
    androidDownloadImage {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const HomePageConfigurationFragmentFragmentDoc = gql`
    fragment HomePageConfigurationFragment on HomePageConfiguration {
  components {
    ... on MainHero {
      ...MainHeroFragment
    }
    ... on BrazeContentCards {
      ...BrazeContentCardsFragment
    }
    ... on Alert {
      ...AlertFrangment
    }
    ... on MarketingTileGroup {
      ...MarketingTileGroupFragment
    }
    ... on OffersSection {
      _id
    }
    ... on Trending {
      ...TrendingFragment
    }
    ... on FanFavorites {
      ...FanFavoritesFragment
    }
    ... on OurServices {
      ...OurServicesFragment
    }
    ... on AppDownload {
      ...AppDownloadFragment
    }
    ... on ScanForRewards {
      _id
    }
    ... on RollUpTheRimSection {
      _id
    }
    ... on RecentItems {
      _id
    }
    ... on LockedOffers {
      _id
    }
  }
}
    ${MainHeroFragmentFragmentDoc}
${BrazeContentCardsFragmentFragmentDoc}
${AlertFrangmentFragmentDoc}
${MarketingTileGroupFragmentFragmentDoc}
${TrendingFragmentFragmentDoc}
${FanFavoritesFragmentFragmentDoc}
${OurServicesFragmentFragmentDoc}
${AppDownloadFragmentFragmentDoc}`;
export const LinkWidgetFragmentFragmentDoc = gql`
    fragment LinkWidgetFragment on LinkWidget {
  _key
  _type
  text {
    locale: en
  }
  link {
    locale: en
  }
}
    `;
export const NavigationLinkFragmentFragmentDoc = gql`
    fragment NavigationLinkFragment on NavigationDesktopLink {
  _key
  navLink {
    ... on LinkWidget {
      ...LinkWidgetFragment
    }
  }
}
    ${LinkWidgetFragmentFragmentDoc}`;
export const NavigationLinksFragmentFragmentDoc = gql`
    fragment NavigationLinksFragment on NavigationDesktop {
  navigationLinks {
    ...NavigationLinkFragment
  }
}
    ${NavigationLinkFragmentFragmentDoc}`;
export const NavigationSectionFragmentFragmentDoc = gql`
    fragment NavigationSectionFragment on NavigationSection {
  name {
    locale: en
  }
  pages {
    ... on StaticPage {
      title
      localeTitle {
        locale: en
      }
      path {
        current
      }
      localePath {
        locale: en {
          current
        }
      }
      redirectUrl {
        locale: en
      }
    }
    ... on NavigationSection {
      name {
        locale: en
      }
      pages {
        ... on StaticPage {
          title
          localeTitle {
            locale: en
          }
          path {
            current
          }
          localePath {
            locale: en {
              current
            }
          }
          redirectUrl {
            locale: en
          }
        }
      }
    }
  }
}
    `;
export const AboutMenuEntriesDesktopFragmentFragmentDoc = gql`
    fragment AboutMenuEntriesDesktopFragment on NavigationDesktop {
  aboutMenuEntries {
    ...NavigationSectionFragment
  }
}
    ${NavigationSectionFragmentFragmentDoc}`;
export const NavigationDesktopFragmentFragmentDoc = gql`
    fragment NavigationDesktopFragment on FeatureNavigation {
  navigationDesktop {
    _key
    _type
    ...NavigationLinksFragment
    ...AboutMenuEntriesDesktopFragment
  }
}
    ${NavigationLinksFragmentFragmentDoc}
${AboutMenuEntriesDesktopFragmentFragmentDoc}`;
export const NavigationTabFragmentFragmentDoc = gql`
    fragment NavigationTabFragment on NavigationMobileTab {
  _key
  _type
  tabIcon {
    locale: en {
      ...ImageFragment
    }
  }
  tabIconActive {
    locale: en {
      ...ImageFragment
    }
  }
  tabLink {
    ... on LinkWidget {
      ...LinkWidgetFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}
${LinkWidgetFragmentFragmentDoc}`;
export const NavigationTabsFragmentFragmentDoc = gql`
    fragment NavigationTabsFragment on NavigationMobile {
  navigationTabs {
    ...NavigationTabFragment
  }
}
    ${NavigationTabFragmentFragmentDoc}`;
export const AboutMenuEntriesMobileFragmentFragmentDoc = gql`
    fragment AboutMenuEntriesMobileFragment on NavigationMobile {
  aboutMenuEntries {
    ...NavigationSectionFragment
  }
}
    ${NavigationSectionFragmentFragmentDoc}`;
export const NavigationMobileFragmentFragmentDoc = gql`
    fragment NavigationMobileFragment on FeatureNavigation {
  navigationMobile {
    _key
    _type
    ...NavigationTabsFragment
    ...AboutMenuEntriesMobileFragment
  }
}
    ${NavigationTabsFragmentFragmentDoc}
${AboutMenuEntriesMobileFragmentFragmentDoc}`;
export const NutritionItemFragmentFragmentDoc = gql`
    fragment NutritionItemFragment on NutritionItem {
  _type
  nutritionKey
  name {
    locale: en
  }
  unit {
    locale: en
  }
  additionalItems {
    ... on NutritionItem {
      nutritionKey
      name {
        locale: en
      }
      unit {
        locale: en
      }
    }
  }
}
    `;
export const NutritionItemGroupFragmentFragmentDoc = gql`
    fragment NutritionItemGroupFragment on NutritionItemGroup {
  _key
  _type
  mainItem {
    ...NutritionItemFragment
  }
  lineItems {
    ...NutritionItemFragment
  }
}
    ${NutritionItemFragmentFragmentDoc}`;
export const NutritionTableFragmentFragmentDoc = gql`
    fragment NutritionTableFragment on NutritionTable {
  _key
  _type
  title {
    locale: en
  }
  items {
    ... on NutritionItem {
      ...NutritionItemFragment
    }
    ... on NutritionItemGroup {
      ...NutritionItemGroupFragment
    }
  }
}
    ${NutritionItemFragmentFragmentDoc}
${NutritionItemGroupFragmentFragmentDoc}`;
export const ItemUnavailableModalFragmentFragmentDoc = gql`
    fragment itemUnavailableModalFragment on FeatureStaticMenu {
  itemUnavailableModal {
    _key
    _type
    header {
      locale: en
    }
    body {
      locale: en
    }
    continue {
      locale: en
    }
    selectNew {
      locale: en
    }
    itemNotAvailableForDelivery {
      locale: en
    }
    image {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const CopyrightAndLanguageSelectorFragmentFragmentDoc = gql`
    fragment CopyrightAndLanguageSelectorFragment on CopyrightAndLanguageSelector {
  _type
  copyrightText {
    locale: en
  }
}
    `;
export const HighlightedLinkWidgetFragmentFragmentDoc = gql`
    fragment HighlightedLinkWidgetFragment on HighlightedLinkWidget {
  _key
  _type
  text {
    locale: en
  }
  link {
    locale: en
  }
}
    `;
export const HighlightedVerticalLinkListWidgetFragmentFragmentDoc = gql`
    fragment HighlightedVerticalLinkListWidgetFragment on HighlightedVerticalLinkListWidget {
  _type
  header {
    locale: en
  }
  subheader {
    locale: en
  }
  highlightedLinks {
    ...HighlightedLinkWidgetFragment
  }
}
    ${HighlightedLinkWidgetFragmentFragmentDoc}`;
export const HorizontalLinkListWidgetFragmentFragmentDoc = gql`
    fragment HorizontalLinkListWidgetFragment on HorizontalLinkListWidget {
  _type
  linkWidgets {
    ...LinkWidgetFragment
  }
}
    ${LinkWidgetFragmentFragmentDoc}`;
export const ImageWidgetFragmentFragmentDoc = gql`
    fragment ImageWidgetFragment on ImageWidget {
  _type
  image {
    locale: en {
      ...ImageFragment
    }
  }
  imageDescription {
    locale: en
  }
}
    ${ImageFragmentFragmentDoc}`;
export const SocialIconsWidgetFragmentFragmentDoc = gql`
    fragment SocialIconsWidgetFragment on SocialIconsWidget {
  _type
  instagramUrl {
    locale: en
  }
  facebookUrl {
    locale: en
  }
  youtubeUrl {
    locale: en
  }
  twitterUrl {
    locale: en
  }
}
    `;
export const SocialIconsWithHeaderWidgetFragmentFragmentDoc = gql`
    fragment SocialIconsWithHeaderWidgetFragment on SocialIconsWithHeaderWidget {
  _type
  header {
    locale: en
  }
  socialIconsWidget {
    ...SocialIconsWidgetFragment
  }
}
    ${SocialIconsWidgetFragmentFragmentDoc}`;
export const TextWidgetFragmentFragmentDoc = gql`
    fragment TextWidgetFragment on TextWidget {
  _type
  text {
    locale: en
  }
}
    `;
export const VerticalLinkListWithHeaderWidgetFragmentFragmentDoc = gql`
    fragment VerticalLinkListWithHeaderWidgetFragment on VerticalLinkListWithHeaderWidget {
  _type
  header {
    locale: en
  }
  linkWidgets {
    ...LinkWidgetFragment
  }
}
    ${LinkWidgetFragmentFragmentDoc}`;
export const VerticalLinkListWidgetFragmentFragmentDoc = gql`
    fragment VerticalLinkListWidgetFragment on VerticalLinkListWidget {
  _type
  linkWidgets {
    ...LinkWidgetFragment
  }
}
    ${LinkWidgetFragmentFragmentDoc}`;
export const WordmarkAndSocialIconsFragmentFragmentDoc = gql`
    fragment WordmarkAndSocialIconsFragment on WordmarkAndSocialIcons {
  _type
  socialIconsWidget {
    ...SocialIconsWidgetFragment
  }
}
    ${SocialIconsWidgetFragmentFragmentDoc}`;
export const HeroContentFragmentDoc = gql`
    fragment HeroContent on AppData {
  _id
  mainHeroImageAuthenticatedLocale {
    locale: en {
      ...ImageFragment
    }
  }
  mainHeroImageLocale {
    locale: en {
      ...ImageFragment
    }
  }
  mainHeroMobileImageLocale {
    locale: en {
      ...ImageFragment
    }
  }
  heroTextAuthenticatedLocale {
    locale: en
  }
  heroTextLocale {
    locale: en
  }
  heroTextColor
  heroActionAuthenticated {
    route
    actionText {
      locale: en
    }
  }
  heroAction {
    route
    actionText {
      locale: en
    }
  }
  heroActionLeft {
    actionText {
      locale: en
    }
    route
  }
  heroActionRight {
    actionText {
      locale: en
    }
    route
  }
  heroSuperTextAuthenticated {
    locale: en
  }
  heroSuperText {
    locale: en
  }
  heroSubTextAuthenticated {
    locale: en
  }
  heroSubText {
    locale: en
  }
  heroMaskCards {
    ...HeroMaskCard
  }
  loyaltyHeroAction {
    route
    actionText {
      locale: en
    }
  }
  loyaltyHeroSuperText {
    locale: en
  }
  loyaltyHeroSubText {
    locale: en
  }
  heroActionLeftIcon {
    locale: en {
      ...ImageFragment
    }
  }
  heroActionRightIcon {
    locale: en {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}
${HeroMaskCardFragmentDoc}`;
export const KioskDataFragmentFragmentDoc = gql`
    fragment KioskDataFragment on KioskAppData {
  userNameBlacklist
  blacklistCharacterReplaceRules {
    filter
    replace
  }
}
    `;
export const RefFragmentDoc = gql`
    fragment ref on Image {
  asset {
    _id
  }
}
    `;
export const LoadingGraphicsFragmentFragmentDoc = gql`
    fragment LoadingGraphicsFragment on LoadingGraphics {
  cartInitialLoader {
    desktopGraphic {
      ...ref
    }
    mobileGraphic {
      ...ref
    }
    title {
      locale: en
    }
    text {
      locale: en
    }
  }
}
    ${RefFragmentDoc}`;
export const OptInModalFragmentFragmentDoc = gql`
    fragment OptInModalFragment on OptInModalContent {
  image {
    locale: en {
      ...ImagesFragment
    }
  }
  title {
    locale: en
  }
  description {
    locale: en
  }
  buttonText {
    locale: en
  }
}
    ${ImagesFragmentFragmentDoc}`;
export const OffersSelectRestaurantCtaFragmentFragmentDoc = gql`
    fragment OffersSelectRestaurantCtaFragment on OffersBrowsingPanel {
  offersSelectRestaurantCta {
    title {
      locale: en
    }
    body {
      locale: en
    }
    ctaButtonText {
      locale: en
    }
    link {
      locale: en
    }
    minimumNumberOfOffers
  }
}
    `;
export const VendorConfigFragmentFragmentDoc = gql`
    fragment VendorConfigFragment on VendorConfig {
  pluType
  parentSanityId
  pullUpLevels
  constantPlu
  quantityBasedPlu {
    quantity
    plu
    qualifier
  }
  multiConstantPlus {
    quantity
    plu
    qualifier
  }
  parentChildPlu {
    plu
    childPlu
  }
  sizeBasedPlu {
    comboPlu
    comboSize
  }
}
    `;
export const VendorConfigsFragmentFragmentDoc = gql`
    fragment VendorConfigsFragment on VendorConfigs {
  carrols {
    ...VendorConfigFragment
  }
  carrolsDelivery {
    ...VendorConfigFragment
  }
  ncr {
    ...VendorConfigFragment
  }
  ncrDelivery {
    ...VendorConfigFragment
  }
  productNumber {
    ...VendorConfigFragment
  }
  productNumberDelivery {
    ...VendorConfigFragment
  }
  sicom {
    ...VendorConfigFragment
  }
  sicomDelivery {
    ...VendorConfigFragment
  }
  qdi {
    ...VendorConfigFragment
  }
  qdiDelivery {
    ...VendorConfigFragment
  }
  rpos {
    ...VendorConfigFragment
  }
  tablet {
    ...VendorConfigFragment
  }
  tabletDelivery {
    ...VendorConfigFragment
  }
}
    ${VendorConfigFragmentFragmentDoc}`;
export const MenuImagesFragmentFragmentDoc = gql`
    fragment MenuImagesFragment on Images {
  app {
    ...MenuImageFragment
  }
  kiosk {
    ...MenuImageFragment
  }
  imageDescription
}
    ${MenuImageFragmentFragmentDoc}`;
export const ItemMetaFragmentFragmentDoc = gql`
    fragment ItemMetaFragment on Item {
  _id
  _type
  operationalItem {
    daypart
  }
}
    `;
export const ComboMetaFragmentFragmentDoc = gql`
    fragment ComboMetaFragment on Combo {
  _id
  _type
  mainItem {
    ...ItemMetaFragment
  }
}
    ${ItemMetaFragmentFragmentDoc}`;
export const PickerMetaFragmentFragmentDoc = gql`
    fragment PickerMetaFragment on Picker {
  _id
  _type
  options {
    option {
      ...ItemMetaFragment
      ...ComboMetaFragment
    }
  }
}
    ${ItemMetaFragmentFragmentDoc}
${ComboMetaFragmentFragmentDoc}`;
export const ActivateOfferMetaFragmentFragmentDoc = gql`
    fragment ActivateOfferMetaFragment on OfferActivation {
  _type
}
    `;
export const DiscountOfferMetaFragmentFragmentDoc = gql`
    fragment DiscountOfferMetaFragment on OfferDiscount {
  discountValue
  discountType
  _type
}
    `;
export const AllowRedemptionWithoutLoginFragmentDoc = gql`
    fragment AllowRedemptionWithoutLogin on AllowRedemptionWithoutLogin {
  ruleSetType: _type
}
    `;
export const BetweenDatesFragmentDoc = gql`
    fragment BetweenDates on BetweenDates {
  ruleSetType: _type
  endDate
  startDate
}
    `;
export const BetweenTimesFragmentDoc = gql`
    fragment BetweenTimes on BetweenTimes {
  ruleSetType: _type
  endTime
  startTime
}
    `;
export const CartPropertyFragmentDoc = gql`
    fragment CartProperty on CartProperty {
  ruleSetType: _type
  key
  negated
  operator
  value
}
    `;
export const CoolDownFragmentDoc = gql`
    fragment CoolDown on CoolDown {
  ruleSetType: _type
  minimumElapsedTimeSeconds
}
    `;
export const DayOfWeekBandFragmentDoc = gql`
    fragment DayOfWeekBand on DayOfWeekBand {
  ruleSetType: _type
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  sunday
}
    `;
export const FirstOrderOnlyFragmentDoc = gql`
    fragment FirstOrderOnly on FirstOrderOnly {
  ruleSetType: _type
}
    `;
export const LimitFragmentDoc = gql`
    fragment Limit on Limit {
  ruleSetType: _type
  interval
  maximumRedemptions
}
    `;
export const PaymentCardTypeFragmentDoc = gql`
    fragment PaymentCardType on PaymentCardType {
  ruleSetType: _type
  cardType
}
    `;
export const ProductCategoryFragmentFragmentDoc = gql`
    fragment ProductCategoryFragment on ProductCategory {
  ruleSetType: _type
  _id
  name {
    locale: en
  }
  image {
    ...MenuImageFragment
  }
  hierarchyLevel
}
    ${MenuImageFragmentFragmentDoc}`;
export const PurchaseFragmentDoc = gql`
    fragment Purchase on Purchase {
  ruleSetType: _type
  quantity
  sanityId
  option {
    ...ProductCategoryFragment
    ...ComboMetaFragment
    ...ItemMetaFragment
    ...PickerMetaFragment
  }
}
    ${ProductCategoryFragmentFragmentDoc}
${ComboMetaFragmentFragmentDoc}
${ItemMetaFragmentFragmentDoc}
${PickerMetaFragmentFragmentDoc}`;
export const RequiresAssignmentFragmentDoc = gql`
    fragment RequiresAssignment on RequiresAssignment {
  ruleSetType: _type
}
    `;
export const RestaurantGroupRestrictionListFragmentFragmentDoc = gql`
    fragment RestaurantGroupRestrictionListFragment on RestaurantGroupRestrictions {
  ruleSetType: _type
  restaurantGroupRestrictionList {
    restaurants {
      number
    }
  }
}
    `;
export const OrderHistoryFragmentFragmentDoc = gql`
    fragment OrderHistoryFragment on OrderHistory {
  ruleSetType: _type
  rangeType
  from
  to
  lastNSeconds
  isSequential
  ruleSet {
    ... on BetweenTimes {
      ...BetweenTimes
    }
    ... on CartProperty {
      ...CartProperty
    }
    ... on DayOfWeekBand {
      ...DayOfWeekBand
    }
    ... on PaymentCardType {
      ...PaymentCardType
    }
    ... on Purchase {
      ...Purchase
    }
    ... on And {
      ruleSetType: _type
      ruleSet {
        ... on AllowRedemptionWithoutLogin {
          ...AllowRedemptionWithoutLogin
        }
        ... on BetweenDates {
          ...BetweenDates
        }
        ... on BetweenTimes {
          ...BetweenTimes
        }
        ... on CartProperty {
          ...CartProperty
        }
        ... on CoolDown {
          ...CoolDown
        }
        ... on DayOfWeekBand {
          ...DayOfWeekBand
        }
        ... on FirstOrderOnly {
          ...FirstOrderOnly
        }
        ... on Limit {
          ...Limit
        }
        ... on PaymentCardType {
          ...PaymentCardType
        }
        ... on Purchase {
          ...Purchase
        }
        ... on RequiresAssignment {
          ...RequiresAssignment
        }
        ... on RestaurantGroupRestrictions {
          ...RestaurantGroupRestrictionListFragment
        }
      }
    }
    ... on Or {
      ruleSetType: _type
      ruleSet {
        ... on AllowRedemptionWithoutLogin {
          ...AllowRedemptionWithoutLogin
        }
        ... on BetweenDates {
          ...BetweenDates
        }
        ... on BetweenTimes {
          ...BetweenTimes
        }
        ... on CartProperty {
          ...CartProperty
        }
        ... on CoolDown {
          ...CoolDown
        }
        ... on DayOfWeekBand {
          ...DayOfWeekBand
        }
        ... on FirstOrderOnly {
          ...FirstOrderOnly
        }
        ... on Limit {
          ...Limit
        }
        ... on PaymentCardType {
          ...PaymentCardType
        }
        ... on Purchase {
          ...Purchase
        }
        ... on RequiresAssignment {
          ...RequiresAssignment
        }
        ... on RestaurantGroupRestrictions {
          ...RestaurantGroupRestrictionListFragment
        }
      }
    }
  }
}
    ${BetweenTimesFragmentDoc}
${CartPropertyFragmentDoc}
${DayOfWeekBandFragmentDoc}
${PaymentCardTypeFragmentDoc}
${PurchaseFragmentDoc}
${AllowRedemptionWithoutLoginFragmentDoc}
${BetweenDatesFragmentDoc}
${CoolDownFragmentDoc}
${FirstOrderOnlyFragmentDoc}
${LimitFragmentDoc}
${RequiresAssignmentFragmentDoc}
${RestaurantGroupRestrictionListFragmentFragmentDoc}`;
export const OffersFragmentFragmentDoc = gql`
    fragment OffersFragment on Offer {
  _id
  _type
  name {
    localeRaw: enRaw
  }
  headerSuperText {
    locale: en
  }
  description {
    localeRaw: enRaw
  }
  moreInfo {
    localeRaw: enRaw
  }
  howToRedeem {
    localeRaw: enRaw
  }
  backgroundImage {
    ...MenuImageFragment
  }
  offerCTA {
    actionText {
      locale: en
    }
    route
  }
  daypart
  forSupport
  offerPrice
  marketPrice {
    ... on Item {
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
    ... on Combo {
      vendorConfigs {
        ...VendorConfigsFragment
      }
    }
  }
  localizedImage {
    locale: en {
      ...MenuImagesFragment
    }
  }
  option {
    ...ComboMetaFragment
    ...ItemMetaFragment
    ...PickerMetaFragment
    ...ActivateOfferMetaFragment
    ...DiscountOfferMetaFragment
  }
  uiPattern
  lockedOffersPanel {
    completedChallengeHeader {
      localeRaw: enRaw
    }
    completedChallengeDescription {
      localeRaw: enRaw
    }
  }
  promoCodePanel {
    promoCodeDescription {
      localeRaw: enRaw
    }
    promoCodeLabel {
      localeRaw: enRaw
    }
    promoCodeLink
    campaignId
  }
  shortCode
  ruleSet {
    ... on AllowRedemptionWithoutLogin {
      ...AllowRedemptionWithoutLogin
    }
    ... on BetweenDates {
      ...BetweenDates
    }
    ... on BetweenTimes {
      ...BetweenTimes
    }
    ... on CartProperty {
      ...CartProperty
    }
    ... on CoolDown {
      ...CoolDown
    }
    ... on DayOfWeekBand {
      ...DayOfWeekBand
    }
    ... on FirstOrderOnly {
      ...FirstOrderOnly
    }
    ... on Limit {
      ...Limit
    }
    ... on OrderHistory {
      ...OrderHistoryFragment
    }
    ... on PaymentCardType {
      ...PaymentCardType
    }
    ... on Purchase {
      ...Purchase
    }
    ... on RequiresAssignment {
      ...RequiresAssignment
    }
    ... on RestaurantGroupRestrictions {
      ...RestaurantGroupRestrictionListFragment
    }
    ... on And {
      ruleSetType: _type
      ruleSet {
        ... on AllowRedemptionWithoutLogin {
          ...AllowRedemptionWithoutLogin
        }
        ... on BetweenDates {
          ...BetweenDates
        }
        ... on BetweenTimes {
          ...BetweenTimes
        }
        ... on CartProperty {
          ...CartProperty
        }
        ... on CoolDown {
          ...CoolDown
        }
        ... on DayOfWeekBand {
          ...DayOfWeekBand
        }
        ... on FirstOrderOnly {
          ...FirstOrderOnly
        }
        ... on Limit {
          ...Limit
        }
        ... on PaymentCardType {
          ...PaymentCardType
        }
        ... on Purchase {
          ...Purchase
        }
        ... on RequiresAssignment {
          ...RequiresAssignment
        }
        ... on RestaurantGroupRestrictions {
          ...RestaurantGroupRestrictionListFragment
        }
      }
    }
    ... on Or {
      ruleSetType: _type
      ruleSet {
        ... on AllowRedemptionWithoutLogin {
          ...AllowRedemptionWithoutLogin
        }
        ... on BetweenDates {
          ...BetweenDates
        }
        ... on BetweenTimes {
          ...BetweenTimes
        }
        ... on CartProperty {
          ...CartProperty
        }
        ... on CoolDown {
          ...CoolDown
        }
        ... on DayOfWeekBand {
          ...DayOfWeekBand
        }
        ... on FirstOrderOnly {
          ...FirstOrderOnly
        }
        ... on Limit {
          ...Limit
        }
        ... on PaymentCardType {
          ...PaymentCardType
        }
        ... on Purchase {
          ...Purchase
        }
        ... on RequiresAssignment {
          ...RequiresAssignment
        }
        ... on RestaurantGroupRestrictions {
          ...RestaurantGroupRestrictionListFragment
        }
      }
    }
  }
  vendorConfigs {
    ...VendorConfigsFragment
  }
}
    ${MenuImageFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}
${MenuImagesFragmentFragmentDoc}
${ComboMetaFragmentFragmentDoc}
${ItemMetaFragmentFragmentDoc}
${PickerMetaFragmentFragmentDoc}
${ActivateOfferMetaFragmentFragmentDoc}
${DiscountOfferMetaFragmentFragmentDoc}
${AllowRedemptionWithoutLoginFragmentDoc}
${BetweenDatesFragmentDoc}
${BetweenTimesFragmentDoc}
${CartPropertyFragmentDoc}
${CoolDownFragmentDoc}
${DayOfWeekBandFragmentDoc}
${FirstOrderOnlyFragmentDoc}
${LimitFragmentDoc}
${OrderHistoryFragmentFragmentDoc}
${PaymentCardTypeFragmentDoc}
${PurchaseFragmentDoc}
${RequiresAssignmentFragmentDoc}
${RestaurantGroupRestrictionListFragmentFragmentDoc}`;
export const OptInSettingBooleanFragmentFragmentDoc = gql`
    fragment OptInSettingBooleanFragment on OptInSettingBoolean {
  _key
  _type
  key
  name {
    locale: en
  }
  description {
    locale: en
  }
}
    `;
export const OptInSettingEmailAndPushFragmentFragmentDoc = gql`
    fragment OptInSettingEmailAndPushFragment on OptInSettingEmailAndPush {
  _key
  _type
  pushKey
  emailKey
  name {
    locale: en
  }
  description {
    locale: en
  }
}
    `;
export const OptInSettingEnumFragmentFragmentDoc = gql`
    fragment OptInSettingEnumFragment on OptInSettingEnum {
  _key
  _type
  key
  enumStrings
  name {
    locale: en
  }
  description {
    locale: en
  }
}
    `;
export const NutritionFragmentFragmentDoc = gql`
    fragment NutritionFragment on Nutrition {
  calories
  fat
  saturatedFat
  transFat
  cholesterol
  sodium
  salt
  carbohydrates
  fiber
  sugar
  proteins
  weight
}
    `;
export const AllergensFragmentFragmentDoc = gql`
    fragment AllergensFragment on OpAllergen {
  milk
  eggs
  fish
  peanuts
  shellfish
  treeNuts
  soy
  wheat
  mustard
  sesame
  celery
  lupin
  gluten
  sulphurDioxide
}
    `;
export const ItemOptionFragmentFragmentDoc = gql`
    fragment ItemOptionFragment on ItemOption {
  name {
    locale: en
  }
  displayGroup {
    name {
      locale: en
    }
  }
  componentStyle
  upsellModifier
  allowMultipleSelections
  injectDefaultSelection
  displayModifierMultiplierName
  minAmount
  maxAmount
  _key
  type: _type
  options {
    default
    _key
    type: _type
    name {
      locale: en
    }
    vendorConfigs {
      ...VendorConfigsFragment
    }
    modifierMultiplier {
      multiplier
      prefix {
        locale: en
      }
      vendorConfigs {
        ...VendorConfigsFragment
      }
      modifier {
        name {
          locale: en
        }
        image {
          ...MenuImageFragment
        }
        vendorConfigs {
          ...VendorConfigsFragment
        }
      }
    }
    nutrition {
      ...NutritionFragment
    }
  }
}
    ${VendorConfigsFragmentFragmentDoc}
${MenuImageFragmentFragmentDoc}
${NutritionFragmentFragmentDoc}`;
export const ItemFragmentFragmentDoc = gql`
    fragment ItemFragment on Item {
  _id
  _type
  name {
    locale: en
  }
  image {
    ...MenuImageFragment
  }
  rewardEligible
  labelAsPerPerson
  operationalItem {
    daypart
  }
  vendorConfigs {
    ...VendorConfigsFragment
  }
  nutrition {
    ...NutritionFragment
  }
  nutritionWithModifiers {
    ...NutritionFragment
  }
  allergens {
    ...AllergensFragment
  }
  showInStaticMenu
  options {
    ...ItemOptionFragment
  }
}
    ${MenuImageFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}
${NutritionFragmentFragmentDoc}
${AllergensFragmentFragmentDoc}
${ItemOptionFragmentFragmentDoc}`;
export const ComboFragmentFragmentDoc = gql`
    fragment ComboFragment on Combo {
  _id
  _type
  name {
    locale: en
  }
  image {
    ...MenuImageFragment
  }
  mainItem {
    ...ItemFragment
  }
  showInStaticMenu
  uiPattern
  hideMainItemDescription
  forceModifiersToBottom
  vendorConfigs {
    ...VendorConfigsFragment
  }
  options {
    name {
      locale: en
    }
    _type
    _id
    vendorConfigs {
      ...VendorConfigsFragment
    }
    uiPattern
    minAmount
    maxAmount
    respectMaximum
    optionVisibilitySettings {
      visibleOptions
      toggleButtonTextClosed {
        locale: en
      }
      toggleButtonTextOpen {
        locale: en
      }
    }
    options {
      minAmount
      maxAmount
      defaultAmount
      option {
        ... on Item {
          ...ItemFragment
        }
        ... on Picker {
          _type
          uiPattern
          pickerAspects {
            name {
              locale: en
            }
            pickerAspectOptions {
              name {
                locale: en
              }
              identifier
            }
          }
        }
      }
    }
  }
}
    ${MenuImageFragmentFragmentDoc}
${ItemFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}`;
export const QuickConfigFragmentFragmentDoc = gql`
    fragment QuickConfigFragment on QuickConfig {
  name {
    locale: en
  }
  rules {
    itemOptions {
      value
    }
    modifier {
      value
    }
  }
}
    `;
export const PickerFragmentFragmentDoc = gql`
    fragment PickerFragment on Picker {
  _id
  _type
  name {
    locale: en
  }
  pickerDefaults {
    _key
    pickerAspect {
      _id
      name {
        locale: en
      }
    }
    pickerAspectValueIdentifier
  }
  showInStaticMenu
  pickerAspects {
    _id
    _type
    name {
      locale: en
    }
    uiPattern
    pickerAspectOptions {
      identifier
      name {
        locale: en
      }
      description {
        locale: en
      }
      image {
        ...MenuImageFragment
      }
      hideNameInItemPreview
    }
  }
  pickerAspectItemOptionMappings {
    pickerAspect {
      _id
      name {
        locale: en
      }
    }
    options {
      value
    }
  }
  options {
    type: _type
    _key
    pickerItemMappings {
      pickerAspectValueIdentifier
      pickerAspect {
        _id
      }
    }
    option {
      ... on Combo {
        _key
        _id
        ...ComboFragment
      }
      ... on Item {
        _key
        ...ItemFragment
      }
    }
    default
  }
  image {
    ...MenuImageFragment
  }
  imageDescription {
    locale: en
  }
  description {
    localeRaw: enRaw
  }
  quickConfigs {
    ...QuickConfigFragment
  }
  uiPattern
}
    ${MenuImageFragmentFragmentDoc}
${ComboFragmentFragmentDoc}
${ItemFragmentFragmentDoc}
${QuickConfigFragmentFragmentDoc}`;
export const SectionFragmentFragmentDoc = gql`
    fragment SectionFragment on Section {
  _id
  _type
  redirectLink {
    locale: en
  }
  uiPattern
  daypart
  showInStaticMenu
  image {
    ...MenuImageFragment
  }
  carouselImage {
    ...ImageFragment
  }
  name {
    locale: en
  }
  headerSuperText {
    locale: en
  }
  headerText {
    locale: en
  }
  imageDescription {
    locale: en
  }
  options {
    ... on Picker {
      ...PickerFragment
    }
    ... on Item {
      ...ItemFragment
    }
    ... on Combo {
      ...ComboFragment
    }
    ... on Section {
      _id
      _type
      description {
        localeRaw: enRaw
      }
      redirectLink {
        locale: en
      }
      uiPattern
      image {
        ...MenuImageFragment
      }
      name {
        locale: en
      }
      imageDescription {
        locale: en
      }
      options {
        ... on Picker {
          ...PickerFragment
        }
        ... on Item {
          ...ItemFragment
        }
        ... on Combo {
          ...ComboFragment
        }
        ... on Section {
          name {
            locale: en
          }
          _type
          _id
          uiPattern
          options {
            ... on Picker {
              ...PickerFragment
            }
            ... on Item {
              ...ItemFragment
            }
            ... on Combo {
              ...ComboFragment
            }
          }
        }
      }
    }
  }
}
    ${MenuImageFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${PickerFragmentFragmentDoc}
${ItemFragmentFragmentDoc}
${ComboFragmentFragmentDoc}`;
export const SiteAlertFragmentDoc = gql`
    fragment SiteAlert on AppData {
  siteAlert {
    heading {
      locale: en
    }
    body {
      locale: en
    }
    learnMoreText {
      locale: en
    }
    learnMoreUrl {
      locale: en
    }
  }
}
    `;
export const TabDetailContentFragmentFragmentDoc = gql`
    fragment TabDetailContentFragment on TabDetailContent {
  title {
    locale: en
  }
  body {
    locale: en
  }
  image {
    locale: en {
      ...ImageFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}`;
export const TitleAndBodyFragmentFragmentDoc = gql`
    fragment TitleAndBodyFragment on TitleAndBody {
  title {
    locale: en
  }
  body {
    locale: en
  }
}
    `;
export const AboutContentDocument = gql`
    query aboutContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    ...AboutContent
  }
}
    ${AboutContentFragmentDoc}`;

/**
 * __useAboutContentQuery__
 *
 * To run a query within a React component, call `useAboutContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAboutContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAboutContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useAboutContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IAboutContentQuery, IAboutContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IAboutContentQuery, IAboutContentQueryVariables>(AboutContentDocument, baseOptions);
      }
export function useAboutContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IAboutContentQuery, IAboutContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IAboutContentQuery, IAboutContentQueryVariables>(AboutContentDocument, baseOptions);
        }
export type AboutContentQueryHookResult = ReturnType<typeof useAboutContentQuery>;
export type AboutContentLazyQueryHookResult = ReturnType<typeof useAboutContentLazyQuery>;
export type AboutContentQueryResult = ApolloReactCommon.QueryResult<IAboutContentQuery, IAboutContentQueryVariables>;
export const AccountContentDocument = gql`
    query accountContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    defaultHeroImageLocale {
      locale: en {
        ...ImageFragment
      }
    }
    recentOrderHeroTextLocale {
      locale: en
    }
    communicationPreferencesDisclaimerBlock {
      localeRaw: enRaw
    }
    emailAndPushOptInSettings {
      ...OptInSettingBooleanFragment
      ...OptInSettingEnumFragment
      ...OptInSettingEmailAndPushFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}
${OptInSettingBooleanFragmentFragmentDoc}
${OptInSettingEnumFragmentFragmentDoc}
${OptInSettingEmailAndPushFragmentFragmentDoc}`;

/**
 * __useAccountContentQuery__
 *
 * To run a query within a React component, call `useAccountContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useAccountContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IAccountContentQuery, IAccountContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IAccountContentQuery, IAccountContentQueryVariables>(AccountContentDocument, baseOptions);
      }
export function useAccountContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IAccountContentQuery, IAccountContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IAccountContentQuery, IAccountContentQueryVariables>(AccountContentDocument, baseOptions);
        }
export type AccountContentQueryHookResult = ReturnType<typeof useAccountContentQuery>;
export type AccountContentLazyQueryHookResult = ReturnType<typeof useAccountContentLazyQuery>;
export type AccountContentQueryResult = ApolloReactCommon.QueryResult<IAccountContentQuery, IAccountContentQueryVariables>;
export const AllFeatureIdsDocument = gql`
    query allFeatureIds {
  allFeatureAccountForms(limit: 1) {
    _id
  }
  allFeatureGeolocationModals(limit: 1) {
    _id
  }
  allFeatureHomePages(limit: 1) {
    _id
  }
  allFeatureOffers(limit: 1) {
    _id
  }
  allFeatureFooters(limit: 1) {
    _id
  }
  allFeatureNavigations(limit: 1) {
    _id
  }
  allFeatureAccountDeletePages(limit: 1) {
    _id
  }
  allFeatureAccountRequestInfoPages(limit: 1) {
    _id
  }
  allSupportData(limit: 1) {
    _id
  }
  allFeatureStaticMenus(limit: 1) {
    _id
  }
  allFeatureMenus(limit: 1) {
    _id
  }
  allFeatureKiosks(limit: 1) {
    _id
  }
  allFeatureLayouts(limit: 1) {
    _id
  }
  allFeatureDisclaimers(limit: 1) {
    _id
  }
  allFeatureAccounts(limit: 1) {
    _id
  }
  allFeatureCateringPages(limit: 1) {
    _id
  }
  allLoyaltyUis(limit: 1) {
    _id
  }
  allFeatureLocationPromos(limit: 1) {
    _id
  }
  allFeatureNutritions(limit: 1) {
    _id
  }
  allFeatureGifts(limit: 1) {
    _id
  }
}
    `;

/**
 * __useAllFeatureIdsQuery__
 *
 * To run a query within a React component, call `useAllFeatureIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFeatureIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFeatureIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFeatureIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IAllFeatureIdsQuery, IAllFeatureIdsQueryVariables>) {
        return ApolloReactHooks.useQuery<IAllFeatureIdsQuery, IAllFeatureIdsQueryVariables>(AllFeatureIdsDocument, baseOptions);
      }
export function useAllFeatureIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IAllFeatureIdsQuery, IAllFeatureIdsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IAllFeatureIdsQuery, IAllFeatureIdsQueryVariables>(AllFeatureIdsDocument, baseOptions);
        }
export type AllFeatureIdsQueryHookResult = ReturnType<typeof useAllFeatureIdsQuery>;
export type AllFeatureIdsLazyQueryHookResult = ReturnType<typeof useAllFeatureIdsLazyQuery>;
export type AllFeatureIdsQueryResult = ApolloReactCommon.QueryResult<IAllFeatureIdsQuery, IAllFeatureIdsQueryVariables>;
export const CartContentDocument = gql`
    query cartContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    loadingGraphics {
      ...LoadingGraphicsFragment
    }
  }
}
    ${LoadingGraphicsFragmentFragmentDoc}`;

/**
 * __useCartContentQuery__
 *
 * To run a query within a React component, call `useCartContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useCartContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ICartContentQuery, ICartContentQueryVariables>) {
        return ApolloReactHooks.useQuery<ICartContentQuery, ICartContentQueryVariables>(CartContentDocument, baseOptions);
      }
export function useCartContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ICartContentQuery, ICartContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ICartContentQuery, ICartContentQueryVariables>(CartContentDocument, baseOptions);
        }
export type CartContentQueryHookResult = ReturnType<typeof useCartContentQuery>;
export type CartContentLazyQueryHookResult = ReturnType<typeof useCartContentLazyQuery>;
export type CartContentQueryResult = ApolloReactCommon.QueryResult<ICartContentQuery, ICartContentQueryVariables>;
export const GetComboDocument = gql`
    query GetCombo($id: ID!) {
  Combo(id: $id) {
    ...ComboFragment
  }
}
    ${ComboFragmentFragmentDoc}`;

/**
 * __useGetComboQuery__
 *
 * To run a query within a React component, call `useGetComboQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComboQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComboQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetComboQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetComboQuery, IGetComboQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetComboQuery, IGetComboQueryVariables>(GetComboDocument, baseOptions);
      }
export function useGetComboLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetComboQuery, IGetComboQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetComboQuery, IGetComboQueryVariables>(GetComboDocument, baseOptions);
        }
export type GetComboQueryHookResult = ReturnType<typeof useGetComboQuery>;
export type GetComboLazyQueryHookResult = ReturnType<typeof useGetComboLazyQuery>;
export type GetComboQueryResult = ApolloReactCommon.QueryResult<IGetComboQuery, IGetComboQueryVariables>;
export const ContentCardsContentDocument = gql`
    query contentCardsContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    contentCardsHeader {
      locale: en
    }
    contentCardsSubheader {
      locale: en
    }
  }
}
    `;

/**
 * __useContentCardsContentQuery__
 *
 * To run a query within a React component, call `useContentCardsContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentCardsContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentCardsContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useContentCardsContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IContentCardsContentQuery, IContentCardsContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IContentCardsContentQuery, IContentCardsContentQueryVariables>(ContentCardsContentDocument, baseOptions);
      }
export function useContentCardsContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IContentCardsContentQuery, IContentCardsContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IContentCardsContentQuery, IContentCardsContentQueryVariables>(ContentCardsContentDocument, baseOptions);
        }
export type ContentCardsContentQueryHookResult = ReturnType<typeof useContentCardsContentQuery>;
export type ContentCardsContentLazyQueryHookResult = ReturnType<typeof useContentCardsContentLazyQuery>;
export type ContentCardsContentQueryResult = ApolloReactCommon.QueryResult<IContentCardsContentQuery, IContentCardsContentQueryVariables>;
export const DayPartsDocument = gql`
    query dayParts($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    dayParts {
      key
      endTime
      startTime
    }
  }
}
    `;

/**
 * __useDayPartsQuery__
 *
 * To run a query within a React component, call `useDayPartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDayPartsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDayPartsQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useDayPartsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IDayPartsQuery, IDayPartsQueryVariables>) {
        return ApolloReactHooks.useQuery<IDayPartsQuery, IDayPartsQueryVariables>(DayPartsDocument, baseOptions);
      }
export function useDayPartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IDayPartsQuery, IDayPartsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IDayPartsQuery, IDayPartsQueryVariables>(DayPartsDocument, baseOptions);
        }
export type DayPartsQueryHookResult = ReturnType<typeof useDayPartsQuery>;
export type DayPartsLazyQueryHookResult = ReturnType<typeof useDayPartsLazyQuery>;
export type DayPartsQueryResult = ApolloReactCommon.QueryResult<IDayPartsQuery, IDayPartsQueryVariables>;
export const FanFavoritesContentDocument = gql`
    query fanFavoritesContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    favoriteSection {
      headerText {
        locale: en
      }
    }
    fanFavoriteItems {
      ... on Picker {
        _id
        image {
          ...MenuImageFragment
        }
        name {
          locale: en
        }
        description {
          localeRaw: enRaw
        }
        imageDescription {
          locale: en
        }
      }
      ... on Item {
        _id
        image {
          ...MenuImageFragment
        }
        name {
          locale: en
        }
        description {
          localeRaw: enRaw
        }
        imageDescription {
          locale: en
        }
      }
      ... on Combo {
        _id
        image {
          ...MenuImageFragment
        }
        name {
          locale: en
        }
        description {
          localeRaw: enRaw
        }
      }
      ... on Section {
        _id
        image {
          ...MenuImageFragment
        }
        name {
          locale: en
        }
        description {
          localeRaw: enRaw
        }
        imageDescription {
          locale: en
        }
      }
    }
  }
}
    ${MenuImageFragmentFragmentDoc}`;

/**
 * __useFanFavoritesContentQuery__
 *
 * To run a query within a React component, call `useFanFavoritesContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFanFavoritesContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFanFavoritesContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useFanFavoritesContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFanFavoritesContentQuery, IFanFavoritesContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IFanFavoritesContentQuery, IFanFavoritesContentQueryVariables>(FanFavoritesContentDocument, baseOptions);
      }
export function useFanFavoritesContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFanFavoritesContentQuery, IFanFavoritesContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFanFavoritesContentQuery, IFanFavoritesContentQueryVariables>(FanFavoritesContentDocument, baseOptions);
        }
export type FanFavoritesContentQueryHookResult = ReturnType<typeof useFanFavoritesContentQuery>;
export type FanFavoritesContentLazyQueryHookResult = ReturnType<typeof useFanFavoritesContentLazyQuery>;
export type FanFavoritesContentQueryResult = ApolloReactCommon.QueryResult<IFanFavoritesContentQuery, IFanFavoritesContentQueryVariables>;
export const FeatureAccountDeletePageDocument = gql`
    query featureAccountDeletePage($featureAccountDeletePageId: ID!) {
  FeatureAccountDeletePage(id: $featureAccountDeletePageId) {
    headerText {
      locale: en
    }
    content {
      locale: enRaw
    }
    confirmButtonText {
      locale: en
    }
    cancelButtonText {
      locale: en
    }
    errorText {
      locale: en
    }
  }
}
    `;

/**
 * __useFeatureAccountDeletePageQuery__
 *
 * To run a query within a React component, call `useFeatureAccountDeletePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAccountDeletePageQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAccountDeletePageQuery({
 *   variables: {
 *      featureAccountDeletePageId: // value for 'featureAccountDeletePageId'
 *   },
 * });
 */
export function useFeatureAccountDeletePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureAccountDeletePageQuery, IFeatureAccountDeletePageQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureAccountDeletePageQuery, IFeatureAccountDeletePageQueryVariables>(FeatureAccountDeletePageDocument, baseOptions);
      }
export function useFeatureAccountDeletePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAccountDeletePageQuery, IFeatureAccountDeletePageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureAccountDeletePageQuery, IFeatureAccountDeletePageQueryVariables>(FeatureAccountDeletePageDocument, baseOptions);
        }
export type FeatureAccountDeletePageQueryHookResult = ReturnType<typeof useFeatureAccountDeletePageQuery>;
export type FeatureAccountDeletePageLazyQueryHookResult = ReturnType<typeof useFeatureAccountDeletePageLazyQuery>;
export type FeatureAccountDeletePageQueryResult = ApolloReactCommon.QueryResult<IFeatureAccountDeletePageQuery, IFeatureAccountDeletePageQueryVariables>;
export const FeatureAccountFormDocument = gql`
    query featureAccountForm($featureAccountFormId: ID!) {
  FeatureAccountForm(id: $featureAccountFormId) {
    postalOrZipDisclaimer {
      locale: en
    }
  }
}
    `;

/**
 * __useFeatureAccountFormQuery__
 *
 * To run a query within a React component, call `useFeatureAccountFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAccountFormQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAccountFormQuery({
 *   variables: {
 *      featureAccountFormId: // value for 'featureAccountFormId'
 *   },
 * });
 */
export function useFeatureAccountFormQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>(FeatureAccountFormDocument, baseOptions);
      }
export function useFeatureAccountFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>(FeatureAccountFormDocument, baseOptions);
        }
export type FeatureAccountFormQueryHookResult = ReturnType<typeof useFeatureAccountFormQuery>;
export type FeatureAccountFormLazyQueryHookResult = ReturnType<typeof useFeatureAccountFormLazyQuery>;
export type FeatureAccountFormQueryResult = ApolloReactCommon.QueryResult<IFeatureAccountFormQuery, IFeatureAccountFormQueryVariables>;
export const FeatureAccountRequestInfoPageDocument = gql`
    query featureAccountRequestInfoPage($featureAccountRequestInfoPageId: ID!) {
  FeatureAccountRequestInfoPage(id: $featureAccountRequestInfoPageId) {
    headerText {
      locale: en
    }
    content {
      locale: enRaw
    }
    confirmButtonText {
      locale: en
    }
    errorText {
      locale: en
    }
  }
}
    `;

/**
 * __useFeatureAccountRequestInfoPageQuery__
 *
 * To run a query within a React component, call `useFeatureAccountRequestInfoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAccountRequestInfoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAccountRequestInfoPageQuery({
 *   variables: {
 *      featureAccountRequestInfoPageId: // value for 'featureAccountRequestInfoPageId'
 *   },
 * });
 */
export function useFeatureAccountRequestInfoPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureAccountRequestInfoPageQuery, IFeatureAccountRequestInfoPageQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureAccountRequestInfoPageQuery, IFeatureAccountRequestInfoPageQueryVariables>(FeatureAccountRequestInfoPageDocument, baseOptions);
      }
export function useFeatureAccountRequestInfoPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAccountRequestInfoPageQuery, IFeatureAccountRequestInfoPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureAccountRequestInfoPageQuery, IFeatureAccountRequestInfoPageQueryVariables>(FeatureAccountRequestInfoPageDocument, baseOptions);
        }
export type FeatureAccountRequestInfoPageQueryHookResult = ReturnType<typeof useFeatureAccountRequestInfoPageQuery>;
export type FeatureAccountRequestInfoPageLazyQueryHookResult = ReturnType<typeof useFeatureAccountRequestInfoPageLazyQuery>;
export type FeatureAccountRequestInfoPageQueryResult = ApolloReactCommon.QueryResult<IFeatureAccountRequestInfoPageQuery, IFeatureAccountRequestInfoPageQueryVariables>;
export const FeatureAccountDocument = gql`
    query featureAccount($featureAccountId: ID!) {
  FeatureAccount(id: $featureAccountId) {
    _id
    emailAndPushOptInSettings {
      ...OptInSettingBooleanFragment
      ...OptInSettingEnumFragment
      ...OptInSettingEmailAndPushFragment
    }
  }
}
    ${OptInSettingBooleanFragmentFragmentDoc}
${OptInSettingEnumFragmentFragmentDoc}
${OptInSettingEmailAndPushFragmentFragmentDoc}`;

/**
 * __useFeatureAccountQuery__
 *
 * To run a query within a React component, call `useFeatureAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAccountQuery({
 *   variables: {
 *      featureAccountId: // value for 'featureAccountId'
 *   },
 * });
 */
export function useFeatureAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureAccountQuery, IFeatureAccountQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureAccountQuery, IFeatureAccountQueryVariables>(FeatureAccountDocument, baseOptions);
      }
export function useFeatureAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureAccountQuery, IFeatureAccountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureAccountQuery, IFeatureAccountQueryVariables>(FeatureAccountDocument, baseOptions);
        }
export type FeatureAccountQueryHookResult = ReturnType<typeof useFeatureAccountQuery>;
export type FeatureAccountLazyQueryHookResult = ReturnType<typeof useFeatureAccountLazyQuery>;
export type FeatureAccountQueryResult = ApolloReactCommon.QueryResult<IFeatureAccountQuery, IFeatureAccountQueryVariables>;
export const FeatureCateringPageDocument = gql`
    query featureCateringPage($featureCateringPageId: ID!) {
  FeatureCateringPage(id: $featureCateringPageId) {
    appUnauthenticated {
      ...CateringPageConfigurationFragment
    }
    appAuthenticated {
      ...CateringPageConfigurationFragment
    }
    webUnauthenticated {
      ...CateringPageConfigurationFragment
    }
    webAuthenticated {
      ...CateringPageConfigurationFragment
    }
  }
}
    ${CateringPageConfigurationFragmentFragmentDoc}`;

/**
 * __useFeatureCateringPageQuery__
 *
 * To run a query within a React component, call `useFeatureCateringPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureCateringPageQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureCateringPageQuery({
 *   variables: {
 *      featureCateringPageId: // value for 'featureCateringPageId'
 *   },
 * });
 */
export function useFeatureCateringPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureCateringPageQuery, IFeatureCateringPageQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureCateringPageQuery, IFeatureCateringPageQueryVariables>(FeatureCateringPageDocument, baseOptions);
      }
export function useFeatureCateringPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureCateringPageQuery, IFeatureCateringPageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureCateringPageQuery, IFeatureCateringPageQueryVariables>(FeatureCateringPageDocument, baseOptions);
        }
export type FeatureCateringPageQueryHookResult = ReturnType<typeof useFeatureCateringPageQuery>;
export type FeatureCateringPageLazyQueryHookResult = ReturnType<typeof useFeatureCateringPageLazyQuery>;
export type FeatureCateringPageQueryResult = ApolloReactCommon.QueryResult<IFeatureCateringPageQuery, IFeatureCateringPageQueryVariables>;
export const FeatureDisclaimersDocument = gql`
    query featureDisclaimers($featureDisclaimersId: ID!) {
  FeatureDisclaimers(id: $featureDisclaimersId) {
    _id
    superUpsell {
      localeRaw: enRaw
    }
    calorie {
      localeRaw: enRaw
    }
    price {
      locale: en
    }
    itemAvailability {
      locale: en
    }
    images {
      locale: en
    }
    phoneNumber {
      locale: en
    }
    country {
      locale: en
    }
    offers {
      locale: en
    }
    copyrightAndTrademark {
      locale: en
    }
    reservedRights {
      locale: en
    }
    communicationPreferencesBlock {
      localeRaw: enRaw
    }
  }
}
    `;

/**
 * __useFeatureDisclaimersQuery__
 *
 * To run a query within a React component, call `useFeatureDisclaimersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureDisclaimersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureDisclaimersQuery({
 *   variables: {
 *      featureDisclaimersId: // value for 'featureDisclaimersId'
 *   },
 * });
 */
export function useFeatureDisclaimersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>(FeatureDisclaimersDocument, baseOptions);
      }
export function useFeatureDisclaimersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>(FeatureDisclaimersDocument, baseOptions);
        }
export type FeatureDisclaimersQueryHookResult = ReturnType<typeof useFeatureDisclaimersQuery>;
export type FeatureDisclaimersLazyQueryHookResult = ReturnType<typeof useFeatureDisclaimersLazyQuery>;
export type FeatureDisclaimersQueryResult = ApolloReactCommon.QueryResult<IFeatureDisclaimersQuery, IFeatureDisclaimersQueryVariables>;
export const FeatureFooterDocument = gql`
    query featureFooter($featureFooterId: ID!) {
  FeatureFooter(id: $featureFooterId) {
    rows {
      _key
      columns {
        _key
        options {
          ... on CopyrightAndLanguageSelector {
            ...CopyrightAndLanguageSelectorFragment
          }
          ... on HighlightedVerticalLinkListWidget {
            ...HighlightedVerticalLinkListWidgetFragment
          }
          ... on HorizontalLinkListWidget {
            ...HorizontalLinkListWidgetFragment
          }
          ... on ImageWidget {
            ...ImageWidgetFragment
          }
          ... on SocialIconsWithHeaderWidget {
            ...SocialIconsWithHeaderWidgetFragment
          }
          ... on TextWidget {
            ...TextWidgetFragment
          }
          ... on VerticalLinkListWidget {
            ...VerticalLinkListWidgetFragment
          }
          ... on VerticalLinkListWithHeaderWidget {
            ...VerticalLinkListWithHeaderWidgetFragment
          }
          ... on WordmarkAndSocialIcons {
            ...WordmarkAndSocialIconsFragment
          }
        }
      }
    }
  }
}
    ${CopyrightAndLanguageSelectorFragmentFragmentDoc}
${HighlightedVerticalLinkListWidgetFragmentFragmentDoc}
${HorizontalLinkListWidgetFragmentFragmentDoc}
${ImageWidgetFragmentFragmentDoc}
${SocialIconsWithHeaderWidgetFragmentFragmentDoc}
${TextWidgetFragmentFragmentDoc}
${VerticalLinkListWidgetFragmentFragmentDoc}
${VerticalLinkListWithHeaderWidgetFragmentFragmentDoc}
${WordmarkAndSocialIconsFragmentFragmentDoc}`;

/**
 * __useFeatureFooterQuery__
 *
 * To run a query within a React component, call `useFeatureFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFooterQuery({
 *   variables: {
 *      featureFooterId: // value for 'featureFooterId'
 *   },
 * });
 */
export function useFeatureFooterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureFooterQuery, IFeatureFooterQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureFooterQuery, IFeatureFooterQueryVariables>(FeatureFooterDocument, baseOptions);
      }
export function useFeatureFooterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureFooterQuery, IFeatureFooterQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureFooterQuery, IFeatureFooterQueryVariables>(FeatureFooterDocument, baseOptions);
        }
export type FeatureFooterQueryHookResult = ReturnType<typeof useFeatureFooterQuery>;
export type FeatureFooterLazyQueryHookResult = ReturnType<typeof useFeatureFooterLazyQuery>;
export type FeatureFooterQueryResult = ApolloReactCommon.QueryResult<IFeatureFooterQuery, IFeatureFooterQueryVariables>;
export const FeatureGeolocationModalDocument = gql`
    query featureGeolocationModal($featureGeolocationModalId: ID!) {
  FeatureGeolocationModal(id: $featureGeolocationModalId) {
    logo {
      locale: en {
        ...ImageFragment
      }
    }
    header {
      locale: en
    }
    body {
      locale: en
    }
    backgroundImage {
      locale: en {
        ...ImageFragment
      }
    }
    deliveryImage {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureGeolocationModalQuery__
 *
 * To run a query within a React component, call `useFeatureGeolocationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureGeolocationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureGeolocationModalQuery({
 *   variables: {
 *      featureGeolocationModalId: // value for 'featureGeolocationModalId'
 *   },
 * });
 */
export function useFeatureGeolocationModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureGeolocationModalQuery, IFeatureGeolocationModalQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureGeolocationModalQuery, IFeatureGeolocationModalQueryVariables>(FeatureGeolocationModalDocument, baseOptions);
      }
export function useFeatureGeolocationModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureGeolocationModalQuery, IFeatureGeolocationModalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureGeolocationModalQuery, IFeatureGeolocationModalQueryVariables>(FeatureGeolocationModalDocument, baseOptions);
        }
export type FeatureGeolocationModalQueryHookResult = ReturnType<typeof useFeatureGeolocationModalQuery>;
export type FeatureGeolocationModalLazyQueryHookResult = ReturnType<typeof useFeatureGeolocationModalLazyQuery>;
export type FeatureGeolocationModalQueryResult = ApolloReactCommon.QueryResult<IFeatureGeolocationModalQuery, IFeatureGeolocationModalQueryVariables>;
export const FeatureGiftDocument = gql`
    query featureGift($featureGiftId: ID!) {
  FeatureGift(id: $featureGiftId) {
    backgroundImage {
      locale: en {
        ...ImagesFragment
      }
    }
    header {
      locale: en
    }
    subHeader {
      locale: enRaw
    }
    legalDisclaimer {
      locale: enRaw
    }
    receptionModalImage {
      locale: en {
        ...ImagesFragment
      }
    }
  }
}
    ${ImagesFragmentFragmentDoc}`;

/**
 * __useFeatureGiftQuery__
 *
 * To run a query within a React component, call `useFeatureGiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureGiftQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureGiftQuery({
 *   variables: {
 *      featureGiftId: // value for 'featureGiftId'
 *   },
 * });
 */
export function useFeatureGiftQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureGiftQuery, IFeatureGiftQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureGiftQuery, IFeatureGiftQueryVariables>(FeatureGiftDocument, baseOptions);
      }
export function useFeatureGiftLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureGiftQuery, IFeatureGiftQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureGiftQuery, IFeatureGiftQueryVariables>(FeatureGiftDocument, baseOptions);
        }
export type FeatureGiftQueryHookResult = ReturnType<typeof useFeatureGiftQuery>;
export type FeatureGiftLazyQueryHookResult = ReturnType<typeof useFeatureGiftLazyQuery>;
export type FeatureGiftQueryResult = ApolloReactCommon.QueryResult<IFeatureGiftQuery, IFeatureGiftQueryVariables>;
export const FeatureHomePageDocument = gql`
    query featureHomePage($featureHomePageId: ID!) {
  FeatureHomePage(id: $featureHomePageId) {
    appUnauthenticated {
      ...HomePageConfigurationFragment
    }
    appAuthenticated {
      ...HomePageConfigurationFragment
    }
    webUnauthenticated {
      ...HomePageConfigurationFragment
    }
    webAuthenticated {
      ...HomePageConfigurationFragment
    }
  }
}
    ${HomePageConfigurationFragmentFragmentDoc}`;

/**
 * __useFeatureHomePageQuery__
 *
 * To run a query within a React component, call `useFeatureHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureHomePageQuery({
 *   variables: {
 *      featureHomePageId: // value for 'featureHomePageId'
 *   },
 * });
 */
export function useFeatureHomePageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureHomePageQuery, IFeatureHomePageQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureHomePageQuery, IFeatureHomePageQueryVariables>(FeatureHomePageDocument, baseOptions);
      }
export function useFeatureHomePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureHomePageQuery, IFeatureHomePageQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureHomePageQuery, IFeatureHomePageQueryVariables>(FeatureHomePageDocument, baseOptions);
        }
export type FeatureHomePageQueryHookResult = ReturnType<typeof useFeatureHomePageQuery>;
export type FeatureHomePageLazyQueryHookResult = ReturnType<typeof useFeatureHomePageLazyQuery>;
export type FeatureHomePageQueryResult = ApolloReactCommon.QueryResult<IFeatureHomePageQuery, IFeatureHomePageQueryVariables>;
export const FeatureKioskDocument = gql`
    query featureKiosk($featureKioskId: ID!) {
  FeatureKiosk(id: $featureKioskId) {
    _id
    attractLoopImage {
      locale: en {
        ...KioskImageFragment
      }
    }
    rewardsMainImage {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${KioskImageFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureKioskQuery__
 *
 * To run a query within a React component, call `useFeatureKioskQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureKioskQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureKioskQuery({
 *   variables: {
 *      featureKioskId: // value for 'featureKioskId'
 *   },
 * });
 */
export function useFeatureKioskQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureKioskQuery, IFeatureKioskQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureKioskQuery, IFeatureKioskQueryVariables>(FeatureKioskDocument, baseOptions);
      }
export function useFeatureKioskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureKioskQuery, IFeatureKioskQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureKioskQuery, IFeatureKioskQueryVariables>(FeatureKioskDocument, baseOptions);
        }
export type FeatureKioskQueryHookResult = ReturnType<typeof useFeatureKioskQuery>;
export type FeatureKioskLazyQueryHookResult = ReturnType<typeof useFeatureKioskLazyQuery>;
export type FeatureKioskQueryResult = ApolloReactCommon.QueryResult<IFeatureKioskQuery, IFeatureKioskQueryVariables>;
export const FeatureLayoutDocument = gql`
    query featureLayout($featureLayoutId: ID!) {
  FeatureLayout(id: $featureLayoutId) {
    _id
    defaultHeroImage {
      locale: en {
        ...ImageFragment
      }
    }
    recentOrderHeroText {
      locale: en
    }
    loadingGraphics {
      ...LoadingGraphicsFragment
    }
    geolocationModalImage {
      locale: en {
        ...ImageFragment
      }
    }
    appleWalletImage {
      locale: en {
        ...ImageFragment
      }
    }
    googlePayImage {
      locale: en {
        ...ImageFragment
      }
    }
    giftCardImage {
      locale: en {
        ...ImageFragment
      }
    }
    giftCardTextImage {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}
${LoadingGraphicsFragmentFragmentDoc}`;

/**
 * __useFeatureLayoutQuery__
 *
 * To run a query within a React component, call `useFeatureLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLayoutQuery({
 *   variables: {
 *      featureLayoutId: // value for 'featureLayoutId'
 *   },
 * });
 */
export function useFeatureLayoutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>(FeatureLayoutDocument, baseOptions);
      }
export function useFeatureLayoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>(FeatureLayoutDocument, baseOptions);
        }
export type FeatureLayoutQueryHookResult = ReturnType<typeof useFeatureLayoutQuery>;
export type FeatureLayoutLazyQueryHookResult = ReturnType<typeof useFeatureLayoutLazyQuery>;
export type FeatureLayoutQueryResult = ApolloReactCommon.QueryResult<IFeatureLayoutQuery, IFeatureLayoutQueryVariables>;
export const FeatureLocationPromoDocument = gql`
    query featureLocationPromo($featureLocationPromoId: ID!) {
  FeatureLocationPromo(id: $featureLocationPromoId) {
    _id
    promoBackgroundImage {
      ...ImageFragment
    }
    menuHeroText {
      locale: en
    }
    linkToStaticPage {
      actionText {
        locale: en
      }
      actionUrl {
        locale: en
      }
      route
    }
    bottomText {
      locale: en
    }
    failLocationHeader {
      locale: en
    }
    failLocationSubtext {
      locale: en
    }
    legalText {
      locale: en
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureLocationPromoQuery__
 *
 * To run a query within a React component, call `useFeatureLocationPromoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLocationPromoQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLocationPromoQuery({
 *   variables: {
 *      featureLocationPromoId: // value for 'featureLocationPromoId'
 *   },
 * });
 */
export function useFeatureLocationPromoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLocationPromoQuery, IFeatureLocationPromoQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLocationPromoQuery, IFeatureLocationPromoQueryVariables>(FeatureLocationPromoDocument, baseOptions);
      }
export function useFeatureLocationPromoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLocationPromoQuery, IFeatureLocationPromoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLocationPromoQuery, IFeatureLocationPromoQueryVariables>(FeatureLocationPromoDocument, baseOptions);
        }
export type FeatureLocationPromoQueryHookResult = ReturnType<typeof useFeatureLocationPromoQuery>;
export type FeatureLocationPromoLazyQueryHookResult = ReturnType<typeof useFeatureLocationPromoLazyQuery>;
export type FeatureLocationPromoQueryResult = ApolloReactCommon.QueryResult<IFeatureLocationPromoQuery, IFeatureLocationPromoQueryVariables>;
export const FeatureLoyaltyUiNoRewardDocument = gql`
    query featureLoyaltyUINoReward($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    noRewardPoints {
      ...EmptyStateFragment
    }
  }
}
    ${EmptyStateFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyUiNoRewardQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyUiNoRewardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyUiNoRewardQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyUiNoRewardQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyUiNoRewardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>(FeatureLoyaltyUiNoRewardDocument, baseOptions);
      }
export function useFeatureLoyaltyUiNoRewardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>(FeatureLoyaltyUiNoRewardDocument, baseOptions);
        }
export type FeatureLoyaltyUiNoRewardQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNoRewardQuery>;
export type FeatureLoyaltyUiNoRewardLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNoRewardLazyQuery>;
export type FeatureLoyaltyUiNoRewardQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyUiNoRewardQuery, IFeatureLoyaltyUiNoRewardQueryVariables>;
export const FeatureLoyaltyUiNotEnrolledDocument = gql`
    query featureLoyaltyUINotEnrolled($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    notEnrolledState {
      ...EmptyStateFragment
    }
  }
}
    ${EmptyStateFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyUiNotEnrolledQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyUiNotEnrolledQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyUiNotEnrolledQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyUiNotEnrolledQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyUiNotEnrolledQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>(FeatureLoyaltyUiNotEnrolledDocument, baseOptions);
      }
export function useFeatureLoyaltyUiNotEnrolledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>(FeatureLoyaltyUiNotEnrolledDocument, baseOptions);
        }
export type FeatureLoyaltyUiNotEnrolledQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNotEnrolledQuery>;
export type FeatureLoyaltyUiNotEnrolledLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiNotEnrolledLazyQuery>;
export type FeatureLoyaltyUiNotEnrolledQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyUiNotEnrolledQuery, IFeatureLoyaltyUiNotEnrolledQueryVariables>;
export const FeatureLoyaltyUiOptInModalDocument = gql`
    query featureLoyaltyUIOptInModal($featureLoyaltyUIId: ID!) {
  LoyaltyUI(id: $featureLoyaltyUIId) {
    _id
    optInModal {
      ...OptInModalFragment
    }
    optInModalError {
      ...OptInModalFragment
    }
    optInModalLoading {
      title {
        locale: en
      }
      description {
        locale: en
      }
    }
  }
}
    ${OptInModalFragmentFragmentDoc}`;

/**
 * __useFeatureLoyaltyUiOptInModalQuery__
 *
 * To run a query within a React component, call `useFeatureLoyaltyUiOptInModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLoyaltyUiOptInModalQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLoyaltyUiOptInModalQuery({
 *   variables: {
 *      featureLoyaltyUIId: // value for 'featureLoyaltyUIId'
 *   },
 * });
 */
export function useFeatureLoyaltyUiOptInModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureLoyaltyUiOptInModalQuery, IFeatureLoyaltyUiOptInModalQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureLoyaltyUiOptInModalQuery, IFeatureLoyaltyUiOptInModalQueryVariables>(FeatureLoyaltyUiOptInModalDocument, baseOptions);
      }
export function useFeatureLoyaltyUiOptInModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureLoyaltyUiOptInModalQuery, IFeatureLoyaltyUiOptInModalQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureLoyaltyUiOptInModalQuery, IFeatureLoyaltyUiOptInModalQueryVariables>(FeatureLoyaltyUiOptInModalDocument, baseOptions);
        }
export type FeatureLoyaltyUiOptInModalQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiOptInModalQuery>;
export type FeatureLoyaltyUiOptInModalLazyQueryHookResult = ReturnType<typeof useFeatureLoyaltyUiOptInModalLazyQuery>;
export type FeatureLoyaltyUiOptInModalQueryResult = ApolloReactCommon.QueryResult<IFeatureLoyaltyUiOptInModalQuery, IFeatureLoyaltyUiOptInModalQueryVariables>;
export const FeatureMenuDocument = gql`
    query featureMenu($featureMenuId: ID!) {
  FeatureMenu(id: $featureMenuId) {
    _id
    menuHeroImage {
      locale: en {
        ...ImageFragment
      }
    }
    menuHeroText {
      locale: en
    }
    dayParts {
      key
      endTime
      startTime
    }
    defaultMenu {
      _id
    }
    cateringMenu {
      _id
    }
    upsellItemsAtCheckoutRestaurant {
      ... on Item {
        ...ItemFragment
        description {
          localeRaw: enRaw
        }
      }
    }
    upsellItemsAtCheckoutDelivery {
      ... on Item {
        ...ItemFragment
        description {
          localeRaw: enRaw
        }
      }
    }
    upsellItemsAtCheckoutCatering {
      ... on Item {
        ...ItemFragment
        description {
          localeRaw: enRaw
        }
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}
${ItemFragmentFragmentDoc}`;

/**
 * __useFeatureMenuQuery__
 *
 * To run a query within a React component, call `useFeatureMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureMenuQuery({
 *   variables: {
 *      featureMenuId: // value for 'featureMenuId'
 *   },
 * });
 */
export function useFeatureMenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureMenuQuery, IFeatureMenuQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureMenuQuery, IFeatureMenuQueryVariables>(FeatureMenuDocument, baseOptions);
      }
export function useFeatureMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureMenuQuery, IFeatureMenuQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureMenuQuery, IFeatureMenuQueryVariables>(FeatureMenuDocument, baseOptions);
        }
export type FeatureMenuQueryHookResult = ReturnType<typeof useFeatureMenuQuery>;
export type FeatureMenuLazyQueryHookResult = ReturnType<typeof useFeatureMenuLazyQuery>;
export type FeatureMenuQueryResult = ApolloReactCommon.QueryResult<IFeatureMenuQuery, IFeatureMenuQueryVariables>;
export const FeatureNavigationDocument = gql`
    query featureNavigation($featureNavigationId: ID!) {
  FeatureNavigation(id: $featureNavigationId) {
    ...NavigationDesktopFragment
    ...NavigationMobileFragment
    aboutMenuEntries {
      ...NavigationSectionFragment
    }
  }
}
    ${NavigationDesktopFragmentFragmentDoc}
${NavigationMobileFragmentFragmentDoc}
${NavigationSectionFragmentFragmentDoc}`;

/**
 * __useFeatureNavigationQuery__
 *
 * To run a query within a React component, call `useFeatureNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureNavigationQuery({
 *   variables: {
 *      featureNavigationId: // value for 'featureNavigationId'
 *   },
 * });
 */
export function useFeatureNavigationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>(FeatureNavigationDocument, baseOptions);
      }
export function useFeatureNavigationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>(FeatureNavigationDocument, baseOptions);
        }
export type FeatureNavigationQueryHookResult = ReturnType<typeof useFeatureNavigationQuery>;
export type FeatureNavigationLazyQueryHookResult = ReturnType<typeof useFeatureNavigationLazyQuery>;
export type FeatureNavigationQueryResult = ApolloReactCommon.QueryResult<IFeatureNavigationQuery, IFeatureNavigationQueryVariables>;
export const FeatureNutritionDocument = gql`
    query featureNutrition($featureNutritionId: ID!) {
  FeatureNutrition(id: $featureNutritionId) {
    _id
    nutritionTables {
      ...NutritionTableFragment
    }
  }
}
    ${NutritionTableFragmentFragmentDoc}`;

/**
 * __useFeatureNutritionQuery__
 *
 * To run a query within a React component, call `useFeatureNutritionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureNutritionQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureNutritionQuery({
 *   variables: {
 *      featureNutritionId: // value for 'featureNutritionId'
 *   },
 * });
 */
export function useFeatureNutritionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>(FeatureNutritionDocument, baseOptions);
      }
export function useFeatureNutritionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>(FeatureNutritionDocument, baseOptions);
        }
export type FeatureNutritionQueryHookResult = ReturnType<typeof useFeatureNutritionQuery>;
export type FeatureNutritionLazyQueryHookResult = ReturnType<typeof useFeatureNutritionLazyQuery>;
export type FeatureNutritionQueryResult = ApolloReactCommon.QueryResult<IFeatureNutritionQuery, IFeatureNutritionQueryVariables>;
export const FeatureOffersDocument = gql`
    query featureOffers($featureOffersId: ID!) {
  FeatureOffers(id: $featureOffersId) {
    offersBrowsingPanel {
      endOfOffersMessage {
        locale: en
      }
      endOfOffersImage {
        locale: en {
          ...ImageFragment
        }
      }
      emptyStateTitle {
        locale: en
      }
      emptyStateBody {
        locale: en
      }
      emptyStateImage {
        locale: en {
          ...ImageFragment
        }
      }
      ...OffersSelectRestaurantCtaFragment
    }
    offersDetailsPanel {
      emptyStateTitle {
        locale: en
      }
      emptyStateBody {
        locale: en
      }
      emptyStateImage {
        locale: en {
          ...ImageFragment
        }
      }
      emptyStateAction {
        actionText {
          locale: en
        }
        route
      }
      missingOfferTitle {
        locale: en
      }
      missingOfferBody {
        locale: en
      }
      missingOfferImage {
        locale: en {
          ...ImageFragment
        }
      }
      missingOfferAction {
        actionText {
          locale: en
        }
        route
      }
    }
    defaultBackgroundImage {
      ...ImageFragment
    }
    sortedOffers {
      ...OffersFragment
    }
  }
}
    ${ImageFragmentFragmentDoc}
${OffersSelectRestaurantCtaFragmentFragmentDoc}
${OffersFragmentFragmentDoc}`;

/**
 * __useFeatureOffersQuery__
 *
 * To run a query within a React component, call `useFeatureOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureOffersQuery({
 *   variables: {
 *      featureOffersId: // value for 'featureOffersId'
 *   },
 * });
 */
export function useFeatureOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureOffersQuery, IFeatureOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureOffersQuery, IFeatureOffersQueryVariables>(FeatureOffersDocument, baseOptions);
      }
export function useFeatureOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureOffersQuery, IFeatureOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureOffersQuery, IFeatureOffersQueryVariables>(FeatureOffersDocument, baseOptions);
        }
export type FeatureOffersQueryHookResult = ReturnType<typeof useFeatureOffersQuery>;
export type FeatureOffersLazyQueryHookResult = ReturnType<typeof useFeatureOffersLazyQuery>;
export type FeatureOffersQueryResult = ApolloReactCommon.QueryResult<IFeatureOffersQuery, IFeatureOffersQueryVariables>;
export const FeatureQuizDocument = gql`
    query FeatureQuiz($quizId: ID!) {
  FeatureQuiz(id: $quizId) {
    description {
      en
    }
    introPageBackground {
      ...ImageFragment
    }
    questionPageBackground {
      ...ImageFragment
    }
    resultPageBackground {
      ...ImageFragment
    }
    questions {
      _id
      text {
        en
      }
      responses {
        _id
        text {
          en
        }
        image {
          en {
            ...ImageFragment
          }
        }
        resultsValuesDetails {
          result {
            _id
            prefix {
              en
            }
            text {
              en
            }
          }
          value
        }
      }
    }
    results {
      _id
      text {
        en
      }
      image {
        en {
          ...ImageFragment
        }
      }
      description {
        en
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useFeatureQuizQuery__
 *
 * To run a query within a React component, call `useFeatureQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureQuizQuery({
 *   variables: {
 *      quizId: // value for 'quizId'
 *   },
 * });
 */
export function useFeatureQuizQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureQuizQuery, IFeatureQuizQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureQuizQuery, IFeatureQuizQueryVariables>(FeatureQuizDocument, baseOptions);
      }
export function useFeatureQuizLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureQuizQuery, IFeatureQuizQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureQuizQuery, IFeatureQuizQueryVariables>(FeatureQuizDocument, baseOptions);
        }
export type FeatureQuizQueryHookResult = ReturnType<typeof useFeatureQuizQuery>;
export type FeatureQuizLazyQueryHookResult = ReturnType<typeof useFeatureQuizLazyQuery>;
export type FeatureQuizQueryResult = ApolloReactCommon.QueryResult<IFeatureQuizQuery, IFeatureQuizQueryVariables>;
export const FeatureStaticMenuDocument = gql`
    query featureStaticMenu($featureStaticMenuId: ID!) {
  FeatureStaticMenu(id: $featureStaticMenuId) {
    ...itemUnavailableModalFragment
  }
}
    ${ItemUnavailableModalFragmentFragmentDoc}`;

/**
 * __useFeatureStaticMenuQuery__
 *
 * To run a query within a React component, call `useFeatureStaticMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureStaticMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureStaticMenuQuery({
 *   variables: {
 *      featureStaticMenuId: // value for 'featureStaticMenuId'
 *   },
 * });
 */
export function useFeatureStaticMenuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>) {
        return ApolloReactHooks.useQuery<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>(FeatureStaticMenuDocument, baseOptions);
      }
export function useFeatureStaticMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>(FeatureStaticMenuDocument, baseOptions);
        }
export type FeatureStaticMenuQueryHookResult = ReturnType<typeof useFeatureStaticMenuQuery>;
export type FeatureStaticMenuLazyQueryHookResult = ReturnType<typeof useFeatureStaticMenuLazyQuery>;
export type FeatureStaticMenuQueryResult = ApolloReactCommon.QueryResult<IFeatureStaticMenuQuery, IFeatureStaticMenuQueryVariables>;
export const HeroContentDocument = gql`
    query heroContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    ...HeroContent
  }
}
    ${HeroContentFragmentDoc}`;

/**
 * __useHeroContentQuery__
 *
 * To run a query within a React component, call `useHeroContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeroContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeroContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useHeroContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IHeroContentQuery, IHeroContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IHeroContentQuery, IHeroContentQueryVariables>(HeroContentDocument, baseOptions);
      }
export function useHeroContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IHeroContentQuery, IHeroContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IHeroContentQuery, IHeroContentQueryVariables>(HeroContentDocument, baseOptions);
        }
export type HeroContentQueryHookResult = ReturnType<typeof useHeroContentQuery>;
export type HeroContentLazyQueryHookResult = ReturnType<typeof useHeroContentLazyQuery>;
export type HeroContentQueryResult = ApolloReactCommon.QueryResult<IHeroContentQuery, IHeroContentQueryVariables>;
export const GetItemDocument = gql`
    query GetItem($id: ID!) {
  Item(id: $id) {
    ...ItemFragment
  }
}
    ${ItemFragmentFragmentDoc}`;

/**
 * __useGetItemQuery__
 *
 * To run a query within a React component, call `useGetItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItemQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetItemQuery, IGetItemQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetItemQuery, IGetItemQueryVariables>(GetItemDocument, baseOptions);
      }
export function useGetItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetItemQuery, IGetItemQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetItemQuery, IGetItemQueryVariables>(GetItemDocument, baseOptions);
        }
export type GetItemQueryHookResult = ReturnType<typeof useGetItemQuery>;
export type GetItemLazyQueryHookResult = ReturnType<typeof useGetItemLazyQuery>;
export type GetItemQueryResult = ApolloReactCommon.QueryResult<IGetItemQuery, IGetItemQueryVariables>;
export const KioskAppDataDocument = gql`
    query kioskAppData($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    kioskAppData {
      ...KioskDataFragment
    }
  }
}
    ${KioskDataFragmentFragmentDoc}`;

/**
 * __useKioskAppDataQuery__
 *
 * To run a query within a React component, call `useKioskAppDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useKioskAppDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKioskAppDataQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useKioskAppDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IKioskAppDataQuery, IKioskAppDataQueryVariables>) {
        return ApolloReactHooks.useQuery<IKioskAppDataQuery, IKioskAppDataQueryVariables>(KioskAppDataDocument, baseOptions);
      }
export function useKioskAppDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IKioskAppDataQuery, IKioskAppDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IKioskAppDataQuery, IKioskAppDataQueryVariables>(KioskAppDataDocument, baseOptions);
        }
export type KioskAppDataQueryHookResult = ReturnType<typeof useKioskAppDataQuery>;
export type KioskAppDataLazyQueryHookResult = ReturnType<typeof useKioskAppDataLazyQuery>;
export type KioskAppDataQueryResult = ApolloReactCommon.QueryResult<IKioskAppDataQuery, IKioskAppDataQueryVariables>;
export const LoyaltyContentDocument = gql`
    query loyaltyContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    giftCardImage {
      locale: en {
        ...ImageFragment
      }
    }
    giftCardTextImage {
      locale: en {
        ...ImageFragment
      }
    }
    appleWalletImage {
      locale: en {
        ...ImageFragment
      }
    }
    googlePayImage {
      locale: en {
        ...ImageFragment
      }
    }
    rewardsMainImageLocale {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useLoyaltyContentQuery__
 *
 * To run a query within a React component, call `useLoyaltyContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useLoyaltyContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyContentQuery, ILoyaltyContentQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyContentQuery, ILoyaltyContentQueryVariables>(LoyaltyContentDocument, baseOptions);
      }
export function useLoyaltyContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyContentQuery, ILoyaltyContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyContentQuery, ILoyaltyContentQueryVariables>(LoyaltyContentDocument, baseOptions);
        }
export type LoyaltyContentQueryHookResult = ReturnType<typeof useLoyaltyContentQuery>;
export type LoyaltyContentLazyQueryHookResult = ReturnType<typeof useLoyaltyContentLazyQuery>;
export type LoyaltyContentQueryResult = ApolloReactCommon.QueryResult<ILoyaltyContentQuery, ILoyaltyContentQueryVariables>;
export const SingleLoyaltyContentDocument = gql`
    query singleLoyaltyContent {
  allLoyaltyContents(limit: 1) {
    _id
  }
}
    `;

/**
 * __useSingleLoyaltyContentQuery__
 *
 * To run a query within a React component, call `useSingleLoyaltyContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleLoyaltyContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleLoyaltyContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useSingleLoyaltyContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>) {
        return ApolloReactHooks.useQuery<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>(SingleLoyaltyContentDocument, baseOptions);
      }
export function useSingleLoyaltyContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>(SingleLoyaltyContentDocument, baseOptions);
        }
export type SingleLoyaltyContentQueryHookResult = ReturnType<typeof useSingleLoyaltyContentQuery>;
export type SingleLoyaltyContentLazyQueryHookResult = ReturnType<typeof useSingleLoyaltyContentLazyQuery>;
export type SingleLoyaltyContentQueryResult = ApolloReactCommon.QueryResult<ISingleLoyaltyContentQuery, ISingleLoyaltyContentQueryVariables>;
export const BirthdayLegalTextDocument = gql`
    query birthdayLegalText($loyaltyContentId: ID!) {
  LoyaltyContent(id: $loyaltyContentId) {
    birthdayLegalText {
      locale: en
    }
  }
}
    `;

/**
 * __useBirthdayLegalTextQuery__
 *
 * To run a query within a React component, call `useBirthdayLegalTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useBirthdayLegalTextQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBirthdayLegalTextQuery({
 *   variables: {
 *      loyaltyContentId: // value for 'loyaltyContentId'
 *   },
 * });
 */
export function useBirthdayLegalTextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>) {
        return ApolloReactHooks.useQuery<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>(BirthdayLegalTextDocument, baseOptions);
      }
export function useBirthdayLegalTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>(BirthdayLegalTextDocument, baseOptions);
        }
export type BirthdayLegalTextQueryHookResult = ReturnType<typeof useBirthdayLegalTextQuery>;
export type BirthdayLegalTextLazyQueryHookResult = ReturnType<typeof useBirthdayLegalTextLazyQuery>;
export type BirthdayLegalTextQueryResult = ApolloReactCommon.QueryResult<IBirthdayLegalTextQuery, IBirthdayLegalTextQueryVariables>;
export const MainMenuContentDocument = gql`
    query mainMenuContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    calorieDisclaimer {
      localeRaw: enRaw
    }
    cateringMenu {
      _id
    }
    defaultMenu {
      _id
    }
    menuHeroImageLocale {
      locale: en {
        ...ImageFragment
      }
    }
    menuHeroTextLocale {
      locale: en
    }
    superUpsellDisclaimer {
      localeRaw: enRaw
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useMainMenuContentQuery__
 *
 * To run a query within a React component, call `useMainMenuContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainMenuContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainMenuContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useMainMenuContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IMainMenuContentQuery, IMainMenuContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IMainMenuContentQuery, IMainMenuContentQueryVariables>(MainMenuContentDocument, baseOptions);
      }
export function useMainMenuContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IMainMenuContentQuery, IMainMenuContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IMainMenuContentQuery, IMainMenuContentQueryVariables>(MainMenuContentDocument, baseOptions);
        }
export type MainMenuContentQueryHookResult = ReturnType<typeof useMainMenuContentQuery>;
export type MainMenuContentLazyQueryHookResult = ReturnType<typeof useMainMenuContentLazyQuery>;
export type MainMenuContentQueryResult = ApolloReactCommon.QueryResult<IMainMenuContentQuery, IMainMenuContentQueryVariables>;
export const PosDataDocument = gql`
    query posData($id: ID!) {
  RestaurantPosData(id: $id) {
    _id
    disableChickenSandwich
    plus
    deliveryPLUs
  }
}
    `;

/**
 * __usePosDataQuery__
 *
 * To run a query within a React component, call `usePosDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePosDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePosDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePosDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IPosDataQuery, IPosDataQueryVariables>) {
        return ApolloReactHooks.useQuery<IPosDataQuery, IPosDataQueryVariables>(PosDataDocument, baseOptions);
      }
export function usePosDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IPosDataQuery, IPosDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IPosDataQuery, IPosDataQueryVariables>(PosDataDocument, baseOptions);
        }
export type PosDataQueryHookResult = ReturnType<typeof usePosDataQuery>;
export type PosDataLazyQueryHookResult = ReturnType<typeof usePosDataLazyQuery>;
export type PosDataQueryResult = ApolloReactCommon.QueryResult<IPosDataQuery, IPosDataQueryVariables>;
export const NutritionContentDocument = gql`
    query nutritionContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    calorieDisclaimer {
      localeRaw: enRaw
    }
  }
}
    `;

/**
 * __useNutritionContentQuery__
 *
 * To run a query within a React component, call `useNutritionContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutritionContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutritionContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useNutritionContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<INutritionContentQuery, INutritionContentQueryVariables>) {
        return ApolloReactHooks.useQuery<INutritionContentQuery, INutritionContentQueryVariables>(NutritionContentDocument, baseOptions);
      }
export function useNutritionContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<INutritionContentQuery, INutritionContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<INutritionContentQuery, INutritionContentQueryVariables>(NutritionContentDocument, baseOptions);
        }
export type NutritionContentQueryHookResult = ReturnType<typeof useNutritionContentQuery>;
export type NutritionContentLazyQueryHookResult = ReturnType<typeof useNutritionContentLazyQuery>;
export type NutritionContentQueryResult = ApolloReactCommon.QueryResult<INutritionContentQuery, INutritionContentQueryVariables>;
export const OurServicesContentDocument = gql`
    query ourServicesContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    servicesHeaderTextLocale {
      locale: en
    }
    servicesHeroTextLocale {
      locale: en
    }
    ourServicesHeroImageLocale {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useOurServicesContentQuery__
 *
 * To run a query within a React component, call `useOurServicesContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOurServicesContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOurServicesContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useOurServicesContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IOurServicesContentQuery, IOurServicesContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IOurServicesContentQuery, IOurServicesContentQueryVariables>(OurServicesContentDocument, baseOptions);
      }
export function useOurServicesContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IOurServicesContentQuery, IOurServicesContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IOurServicesContentQuery, IOurServicesContentQueryVariables>(OurServicesContentDocument, baseOptions);
        }
export type OurServicesContentQueryHookResult = ReturnType<typeof useOurServicesContentQuery>;
export type OurServicesContentLazyQueryHookResult = ReturnType<typeof useOurServicesContentLazyQuery>;
export type OurServicesContentQueryResult = ApolloReactCommon.QueryResult<IOurServicesContentQuery, IOurServicesContentQueryVariables>;
export const GetPickerDocument = gql`
    query GetPicker($id: ID!) {
  Picker(id: $id) {
    ...PickerFragment
  }
}
    ${PickerFragmentFragmentDoc}`;

/**
 * __useGetPickerQuery__
 *
 * To run a query within a React component, call `useGetPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPickerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetPickerQuery, IGetPickerQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetPickerQuery, IGetPickerQueryVariables>(GetPickerDocument, baseOptions);
      }
export function useGetPickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetPickerQuery, IGetPickerQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetPickerQuery, IGetPickerQueryVariables>(GetPickerDocument, baseOptions);
        }
export type GetPickerQueryHookResult = ReturnType<typeof useGetPickerQuery>;
export type GetPickerLazyQueryHookResult = ReturnType<typeof useGetPickerLazyQuery>;
export type GetPickerQueryResult = ApolloReactCommon.QueryResult<IGetPickerQuery, IGetPickerQueryVariables>;
export const GetProductCategoryDocument = gql`
    query GetProductCategory($id: ID!) {
  ProductCategory(id: $id) {
    ...ProductCategoryFragment
  }
}
    ${ProductCategoryFragmentFragmentDoc}`;

/**
 * __useGetProductCategoryQuery__
 *
 * To run a query within a React component, call `useGetProductCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>(GetProductCategoryDocument, baseOptions);
      }
export function useGetProductCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>(GetProductCategoryDocument, baseOptions);
        }
export type GetProductCategoryQueryHookResult = ReturnType<typeof useGetProductCategoryQuery>;
export type GetProductCategoryLazyQueryHookResult = ReturnType<typeof useGetProductCategoryLazyQuery>;
export type GetProductCategoryQueryResult = ApolloReactCommon.QueryResult<IGetProductCategoryQuery, IGetProductCategoryQueryVariables>;
export const PromotionsContentDocument = gql`
    query promotionsContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    promotions {
      ... on Picker {
        _id
        _type
        name {
          locale: en
        }
        description {
          localeRaw: enRaw
        }
        image {
          ...MenuImageFragment
        }
      }
      ... on Item {
        _id
        _type
        name {
          locale: en
        }
        description {
          localeRaw: enRaw
        }
        image {
          ...MenuImageFragment
        }
      }
      ... on Combo {
        _id
        _type
        name {
          locale: en
        }
        description {
          localeRaw: enRaw
        }
        image {
          ...MenuImageFragment
        }
      }
      ... on Section {
        _id
        _type
        name {
          locale: en
        }
        description {
          localeRaw: enRaw
        }
        image {
          ...ImageFragment
        }
      }
      ... on Offer {
        _id
        _type
      }
      ... on ExternalLink {
        _key
        type: _type
        name {
          locale: en
        }
        image {
          locale: en {
            ...ImageFragment
          }
        }
        description {
          locale: en
        }
        link {
          locale: en
        }
        url
      }
    }
  }
}
    ${MenuImageFragmentFragmentDoc}
${ImageFragmentFragmentDoc}`;

/**
 * __usePromotionsContentQuery__
 *
 * To run a query within a React component, call `usePromotionsContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromotionsContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromotionsContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function usePromotionsContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IPromotionsContentQuery, IPromotionsContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IPromotionsContentQuery, IPromotionsContentQueryVariables>(PromotionsContentDocument, baseOptions);
      }
export function usePromotionsContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IPromotionsContentQuery, IPromotionsContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IPromotionsContentQuery, IPromotionsContentQueryVariables>(PromotionsContentDocument, baseOptions);
        }
export type PromotionsContentQueryHookResult = ReturnType<typeof usePromotionsContentQuery>;
export type PromotionsContentLazyQueryHookResult = ReturnType<typeof usePromotionsContentLazyQuery>;
export type PromotionsContentQueryResult = ApolloReactCommon.QueryResult<IPromotionsContentQuery, IPromotionsContentQueryVariables>;
export const LoyaltyRewardsByEngineIdDocument = gql`
    query LoyaltyRewardsByEngineId($ids: [String!]!) {
  allRewards(where: {loyaltyEngineId_in: $ids}) {
    _id
    loyaltyEngineId
    name {
      en
    }
    description {
      enRaw
    }
    moreInfo {
      enRaw
    }
    howToRedeem {
      enRaw
    }
    backgroundImage {
      ...MenuImageFragment
    }
    image {
      locale: en {
        ...ImageFragment
      }
    }
    incentives {
      __typename
      ... on Combo {
        _id
        _type
        mainItem {
          operationalItem {
            daypart
          }
        }
      }
      ... on Item {
        _id
        _type
        operationalItem {
          daypart
        }
      }
      ... on Picker {
        _id
        _type
        options {
          option {
            __typename
            ... on Combo {
              mainItem {
                operationalItem {
                  daypart
                }
              }
            }
            ... on Item {
              operationalItem {
                daypart
              }
            }
          }
        }
      }
      ... on OfferDiscount {
        _id
        _type
      }
    }
    vendorConfigs {
      ...VendorConfigsFragment
    }
  }
}
    ${MenuImageFragmentFragmentDoc}
${ImageFragmentFragmentDoc}
${VendorConfigsFragmentFragmentDoc}`;

/**
 * __useLoyaltyRewardsByEngineIdQuery__
 *
 * To run a query within a React component, call `useLoyaltyRewardsByEngineIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyRewardsByEngineIdQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyRewardsByEngineIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoyaltyRewardsByEngineIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ILoyaltyRewardsByEngineIdQuery, ILoyaltyRewardsByEngineIdQueryVariables>) {
        return ApolloReactHooks.useQuery<ILoyaltyRewardsByEngineIdQuery, ILoyaltyRewardsByEngineIdQueryVariables>(LoyaltyRewardsByEngineIdDocument, baseOptions);
      }
export function useLoyaltyRewardsByEngineIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ILoyaltyRewardsByEngineIdQuery, ILoyaltyRewardsByEngineIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ILoyaltyRewardsByEngineIdQuery, ILoyaltyRewardsByEngineIdQueryVariables>(LoyaltyRewardsByEngineIdDocument, baseOptions);
        }
export type LoyaltyRewardsByEngineIdQueryHookResult = ReturnType<typeof useLoyaltyRewardsByEngineIdQuery>;
export type LoyaltyRewardsByEngineIdLazyQueryHookResult = ReturnType<typeof useLoyaltyRewardsByEngineIdLazyQuery>;
export type LoyaltyRewardsByEngineIdQueryResult = ApolloReactCommon.QueryResult<ILoyaltyRewardsByEngineIdQuery, ILoyaltyRewardsByEngineIdQueryVariables>;
export const GetAllRollUpTheRimsDocument = gql`
    query GetAllRollUpTheRims {
  allRollUpTheRims(limit: 1) {
    _id
    gamePlayHeader {
      localeRaw: enRaw
    }
    gameHeaderText {
      locale: en
    }
    gamePlayTextBlock {
      localeRaw: enRaw
    }
    gameErrorHeaderText {
      locale: en
    }
    gameErrorBlock {
      localeRaw: enRaw
    }
    gameErrorHeaderText {
      locale: en
    }
    gameRollButtonText {
      locale: en
    }
    gamePlayImage {
      locale: en {
        ...ImagesFragment
      }
    }
    desktopGamePlayImage {
      locale: en {
        ...ImagesFragment
      }
    }
    gamePlayButtonText {
      localeRaw: enRaw
    }
    rollsRemainingText {
      localeRaw: enRaw
    }
    gameplayRollAudio {
      asset {
        url
      }
    }
    gameplayWinAudio {
      asset {
        url
      }
    }
    timelineHeader {
      localeRaw: enRaw
    }
    timelineTextBlock {
      localeRaw: enRaw
    }
    timelineComponents {
      key
      state
      timelineEventType
      headerColor
      timelineHeader {
        locale: en
      }
      description {
        locale: en
      }
      buttonText {
        locale: en
      }
      image {
        locale: en {
          ...ImagesFragment
        }
      }
    }
    timelinePrizeClaimedText {
      locale: en
    }
    timelineRollSharedText {
      locale: en
    }
    timelineConfetti {
      locale: en {
        ...ImagesFragment
      }
    }
    emptyTimelineTextBlock {
      localeRaw: enRaw
    }
    emptyTimelineButtonBlock {
      localeRaw: enRaw
    }
    emptyTimelineImage {
      locale: en {
        ...ImagesFragment
      }
    }
    timelineButtonText {
      localeRaw: enRaw
    }
    timelineTextLoadMore {
      locale: en
    }
    shareHeader {
      localeRaw: enRaw
    }
    shareTextBlock {
      localeRaw: enRaw
    }
    shareButtonText {
      localeRaw: enRaw
    }
    shareImage {
      locale: en {
        ...ImagesFragment
      }
    }
    desktopShareImage {
      locale: en {
        ...ImagesFragment
      }
    }
    prizesHeader {
      localeRaw: enRaw
    }
    prizesSeparator {
      localeRaw: enRaw
    }
    prizesTextBlock {
      localeRaw: enRaw
    }
    prizesButtonText {
      localeRaw: enRaw
    }
    prizesImage {
      locale: en {
        ...ImagesFragment
      }
    }
    planeImage {
      locale: en {
        ...ImagesFragment
      }
    }
    sponsorTitle {
      locale: en
    }
    sponsorsImage {
      locale: en {
        ...ImagesFragment
      }
    }
    desktopPrizesImage {
      locale: en {
        ...ImagesFragment
      }
    }
    sharedLandingBadLinkButtonBlock {
      localeRaw: enRaw
    }
    sharedLandingBadLinkHeaderBlock {
      localeRaw: enRaw
    }
    sharedLandingBadLinkTextBlock {
      localeRaw: enRaw
    }
    sharedLandingBadLinkImage {
      locale: en {
        ...ImagesFragment
      }
    }
    shareRollTo {
      locale: en
    }
    shareRollYouHave {
      locale: en
    }
    shareRollShare {
      locale: en
    }
    shareRollIncrementText {
      locale: en
    }
    shareRollReclaimButtonText {
      locale: en
    }
    shareRollsDisclaimer {
      localeRaw: enRaw
    }
    winnersHeader {
      localeRaw: enRaw
    }
    winnersTextBlock {
      localeRaw: enRaw
    }
    winnersButtonText {
      localeRaw: enRaw
    }
    reusablesHeader {
      localeRaw: enRaw
    }
    reusablesTextBlock {
      localeRaw: enRaw
    }
    reusablesButtonText {
      localeRaw: enRaw
    }
    reusablesImage {
      locale: en {
        ...ImagesFragment
      }
    }
    desktopReusablesImage {
      locale: en {
        ...ImagesFragment
      }
    }
    modalTimelineHeader {
      localeRaw: enRaw
    }
    endText {
      localeRaw: enRaw
    }
    countdownText {
      localeRaw: enRaw
    }
    entriesText {
      localeRaw: enRaw
    }
    nextDrawText {
      localeRaw: enRaw
    }
    firstDrawing
    secondDrawing
    thirdDrawing
    fourthDrawing
    moneyStackImage {
      locale: en {
        ...ImagesFragment
      }
    }
    prizes {
      numberAwarded {
        localeRaw: enRaw
      }
      header {
        localeRaw: enRaw
      }
      text {
        localeRaw: enRaw
      }
      image {
        locale: en {
          ...ImagesFragment
        }
      }
      excludeInAlberta
      buttonText {
        localeRaw: enRaw
      }
    }
    rulesLinkText {
      locale: en
    }
    rulesLinkPath {
      locale: en
    }
    rulesLinkPath {
      locale: en
    }
    footerLinks {
      _key
      footerLinkLocalizedPath {
        locale: en
      }
      footerLinkText {
        locale: en
      }
      footerText {
        locale: en
      }
      footerTitle {
        locale: en
      }
    }
    modalWinnersHeader {
      localeRaw: enRaw
    }
    modalWinnersTextBlock {
      localeRaw: enRaw
    }
    gameHeader {
      localeRaw: enRaw
    }
    gameTextBlock {
      localeRaw: enRaw
    }
    gameNeedHelp {
      locale: en
    }
    cupImage {
      locale: en {
        ...ImagesFragment
      }
    }
    gameBackgroundImage {
      locale: en {
        ...ImagesFragment
      }
    }
    gameButtonText {
      localeRaw: enRaw
    }
    rewardsHeaderText {
      locale: en
    }
    rewards {
      key
      rewardName {
        locale: en
      }
      image {
        locale: en {
          ...ImagesFragment
        }
      }
      requireSkillsQuestion
      rewardYouWonMessageBlock {
        localeRaw: enRaw
      }
      allSetBlurbBlock {
        localeRaw: enRaw
      }
    }
    allSetHeaderText {
      locale: en
    }
    allSetEmailSentText {
      locale: en
    }
    allSetLegalBlock {
      localeRaw: enRaw
    }
    allSetClaimFailedHeaderText {
      locale: en
    }
    errorTimelineText {
      locale: en
    }
    errorTimelineButtonText {
      locale: en
    }
    errorTimelineImage {
      locale: en {
        ...ImagesFragment
      }
    }
    homepageHeader {
      localeRaw: enRaw
    }
    homepageCupImage {
      locale: en {
        ...ImagesFragment
      }
    }
    homepageBackgroundImage {
      locale: en {
        ...ImagesFragment
      }
    }
    enterButtonText {
      localeRaw: enRaw
    }
    rulesText {
      localeRaw: enRaw
    }
    rrrollButtonText {
      localeRaw: enRaw
    }
    shareRollHeader {
      localeRaw: enRaw
    }
    shareRollTextBlock {
      localeRaw: enRaw
    }
    shareRollURL {
      locale: en
    }
    shareRollLinkTitle {
      locale: en
    }
    shareRollReclaimQuestionText {
      locale: en
    }
    shareRollReclaimDescriptionText {
      locale: en
    }
    shareRollsImage {
      locale: en {
        ...ImagesFragment
      }
    }
    shareRollsBackgroundImage {
      locale: en {
        ...ImagesFragment
      }
    }
    howManyTextBlock {
      localeRaw: enRaw
    }
    shareRolluttonText {
      localeRaw: enRaw
    }
    rollupAnimationFrames {
      locale: en {
        ...ImagesFragment
      }
    }
    skillsQuestionHeaderText {
      locale: en
    }
    skillsQuestionDescriptionText {
      locale: en
    }
    skillsQuestionMathBlock {
      localeRaw: enRaw
    }
    skillsQuestionHintText {
      locale: en
    }
    skillsQuestionReleaseBlock {
      localeRaw: enRaw
    }
    skillsQuestionAcknowledgeText {
      locale: en
    }
    localeSwitchModalHeaderText {
      locale: en
    }
    localeSwitchModalPrimaryText {
      locale: en
    }
    localeSwitchModalSecondaryText {
      locale: en
    }
    localeSwitchModalDisclaimerText {
      locale: en
    }
  }
}
    ${ImagesFragmentFragmentDoc}`;

/**
 * __useGetAllRollUpTheRimsQuery__
 *
 * To run a query within a React component, call `useGetAllRollUpTheRimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRollUpTheRimsQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRollUpTheRimsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRollUpTheRimsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetAllRollUpTheRimsQuery, IGetAllRollUpTheRimsQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetAllRollUpTheRimsQuery, IGetAllRollUpTheRimsQueryVariables>(GetAllRollUpTheRimsDocument, baseOptions);
      }
export function useGetAllRollUpTheRimsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetAllRollUpTheRimsQuery, IGetAllRollUpTheRimsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetAllRollUpTheRimsQuery, IGetAllRollUpTheRimsQueryVariables>(GetAllRollUpTheRimsDocument, baseOptions);
        }
export type GetAllRollUpTheRimsQueryHookResult = ReturnType<typeof useGetAllRollUpTheRimsQuery>;
export type GetAllRollUpTheRimsLazyQueryHookResult = ReturnType<typeof useGetAllRollUpTheRimsLazyQuery>;
export type GetAllRollUpTheRimsQueryResult = ApolloReactCommon.QueryResult<IGetAllRollUpTheRimsQuery, IGetAllRollUpTheRimsQueryVariables>;
export const GetSectionDocument = gql`
    query GetSection($id: ID!) {
  Section(id: $id) {
    ...SectionFragment
  }
}
    ${SectionFragmentFragmentDoc}`;

/**
 * __useGetSectionQuery__
 *
 * To run a query within a React component, call `useGetSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetSectionQuery, IGetSectionQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetSectionQuery, IGetSectionQueryVariables>(GetSectionDocument, baseOptions);
      }
export function useGetSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSectionQuery, IGetSectionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetSectionQuery, IGetSectionQueryVariables>(GetSectionDocument, baseOptions);
        }
export type GetSectionQueryHookResult = ReturnType<typeof useGetSectionQuery>;
export type GetSectionLazyQueryHookResult = ReturnType<typeof useGetSectionLazyQuery>;
export type GetSectionQueryResult = ApolloReactCommon.QueryResult<IGetSectionQuery, IGetSectionQueryVariables>;
export const SignupContentDocument = gql`
    query signupContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    phoneNumberDisclaimer {
      locale: en
    }
    countryDisclaimer {
      locale: en
    }
  }
}
    `;

/**
 * __useSignupContentQuery__
 *
 * To run a query within a React component, call `useSignupContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignupContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignupContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useSignupContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISignupContentQuery, ISignupContentQueryVariables>) {
        return ApolloReactHooks.useQuery<ISignupContentQuery, ISignupContentQueryVariables>(SignupContentDocument, baseOptions);
      }
export function useSignupContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISignupContentQuery, ISignupContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ISignupContentQuery, ISignupContentQueryVariables>(SignupContentDocument, baseOptions);
        }
export type SignupContentQueryHookResult = ReturnType<typeof useSignupContentQuery>;
export type SignupContentLazyQueryHookResult = ReturnType<typeof useSignupContentLazyQuery>;
export type SignupContentQueryResult = ApolloReactCommon.QueryResult<ISignupContentQuery, ISignupContentQueryVariables>;
export const SingleAppDataDocument = gql`
    query singleAppData {
  allAppData(limit: 1) {
    _id
  }
}
    `;

/**
 * __useSingleAppDataQuery__
 *
 * To run a query within a React component, call `useSingleAppDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAppDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAppDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useSingleAppDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISingleAppDataQuery, ISingleAppDataQueryVariables>) {
        return ApolloReactHooks.useQuery<ISingleAppDataQuery, ISingleAppDataQueryVariables>(SingleAppDataDocument, baseOptions);
      }
export function useSingleAppDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISingleAppDataQuery, ISingleAppDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ISingleAppDataQuery, ISingleAppDataQueryVariables>(SingleAppDataDocument, baseOptions);
        }
export type SingleAppDataQueryHookResult = ReturnType<typeof useSingleAppDataQuery>;
export type SingleAppDataLazyQueryHookResult = ReturnType<typeof useSingleAppDataLazyQuery>;
export type SingleAppDataQueryResult = ApolloReactCommon.QueryResult<ISingleAppDataQuery, ISingleAppDataQueryVariables>;
export const SiteAlertDocument = gql`
    query siteAlert($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    ...SiteAlert
  }
}
    ${SiteAlertFragmentDoc}`;

/**
 * __useSiteAlertQuery__
 *
 * To run a query within a React component, call `useSiteAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAlertQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useSiteAlertQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISiteAlertQuery, ISiteAlertQueryVariables>) {
        return ApolloReactHooks.useQuery<ISiteAlertQuery, ISiteAlertQueryVariables>(SiteAlertDocument, baseOptions);
      }
export function useSiteAlertLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISiteAlertQuery, ISiteAlertQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ISiteAlertQuery, ISiteAlertQueryVariables>(SiteAlertDocument, baseOptions);
        }
export type SiteAlertQueryHookResult = ReturnType<typeof useSiteAlertQuery>;
export type SiteAlertLazyQueryHookResult = ReturnType<typeof useSiteAlertLazyQuery>;
export type SiteAlertQueryResult = ApolloReactCommon.QueryResult<ISiteAlertQuery, ISiteAlertQueryVariables>;
export const SortedOffersDocument = gql`
    query sortedOffers($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    offersDisclaimer {
      locale: en
    }
    sortedOffers {
      ...OffersFragment
    }
  }
}
    ${OffersFragmentFragmentDoc}`;

/**
 * __useSortedOffersQuery__
 *
 * To run a query within a React component, call `useSortedOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSortedOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSortedOffersQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useSortedOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ISortedOffersQuery, ISortedOffersQueryVariables>) {
        return ApolloReactHooks.useQuery<ISortedOffersQuery, ISortedOffersQueryVariables>(SortedOffersDocument, baseOptions);
      }
export function useSortedOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ISortedOffersQuery, ISortedOffersQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ISortedOffersQuery, ISortedOffersQueryVariables>(SortedOffersDocument, baseOptions);
        }
export type SortedOffersQueryHookResult = ReturnType<typeof useSortedOffersQuery>;
export type SortedOffersLazyQueryHookResult = ReturnType<typeof useSortedOffersLazyQuery>;
export type SortedOffersQueryResult = ApolloReactCommon.QueryResult<ISortedOffersQuery, ISortedOffersQueryVariables>;
export const StaticPagesContentDocument = gql`
    query staticPagesContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    defaultHeroImageLocale {
      locale: en {
        ...ImageFragment
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}`;

/**
 * __useStaticPagesContentQuery__
 *
 * To run a query within a React component, call `useStaticPagesContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticPagesContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticPagesContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useStaticPagesContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IStaticPagesContentQuery, IStaticPagesContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IStaticPagesContentQuery, IStaticPagesContentQueryVariables>(StaticPagesContentDocument, baseOptions);
      }
export function useStaticPagesContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IStaticPagesContentQuery, IStaticPagesContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IStaticPagesContentQuery, IStaticPagesContentQueryVariables>(StaticPagesContentDocument, baseOptions);
        }
export type StaticPagesContentQueryHookResult = ReturnType<typeof useStaticPagesContentQuery>;
export type StaticPagesContentLazyQueryHookResult = ReturnType<typeof useStaticPagesContentLazyQuery>;
export type StaticPagesContentQueryResult = ApolloReactCommon.QueryResult<IStaticPagesContentQuery, IStaticPagesContentQueryVariables>;
export const StoreLocatorContentDocument = gql`
    query storeLocatorContent($appDataId: ID!) {
  AppData(id: $appDataId) {
    _id
    geolocationModalImageUseLocale {
      locale: en {
        ...ImageFragment
      }
    }
    storeLocatorContent {
      searchThisAreaButtonLabel {
        locale: en
      }
      tabsStoreLocatorContent {
        nearbyTab {
          ...TabDetailContentFragment
        }
        favoritesTab {
          ...TabDetailContentFragment
        }
        recentTab {
          ...TabDetailContentFragment
        }
      }
    }
  }
}
    ${ImageFragmentFragmentDoc}
${TabDetailContentFragmentFragmentDoc}`;

/**
 * __useStoreLocatorContentQuery__
 *
 * To run a query within a React component, call `useStoreLocatorContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreLocatorContentQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreLocatorContentQuery({
 *   variables: {
 *      appDataId: // value for 'appDataId'
 *   },
 * });
 */
export function useStoreLocatorContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IStoreLocatorContentQuery, IStoreLocatorContentQueryVariables>) {
        return ApolloReactHooks.useQuery<IStoreLocatorContentQuery, IStoreLocatorContentQueryVariables>(StoreLocatorContentDocument, baseOptions);
      }
export function useStoreLocatorContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IStoreLocatorContentQuery, IStoreLocatorContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IStoreLocatorContentQuery, IStoreLocatorContentQueryVariables>(StoreLocatorContentDocument, baseOptions);
        }
export type StoreLocatorContentQueryHookResult = ReturnType<typeof useStoreLocatorContentQuery>;
export type StoreLocatorContentLazyQueryHookResult = ReturnType<typeof useStoreLocatorContentLazyQuery>;
export type StoreLocatorContentQueryResult = ApolloReactCommon.QueryResult<IStoreLocatorContentQuery, IStoreLocatorContentQueryVariables>;
export const GetSupportDataDocument = gql`
    query GetSupportData($supportDataId: ID!) {
  SupportData(id: $supportDataId) {
    _id
    supportCategoryGroups {
      _id
      name {
        locale: en
      }
      supportSubcategories {
        _id
        name {
          locale: en
        }
        knowledgeForceIssueId
        supportSubcategoryForwardToOrders
        supportSubcategoryFaqs {
          supportFaqTitle {
            locale: en
          }
          supportFaqContent {
            localeRaw: enRaw
          }
          supportFaqMParticleEvent
        }
      }
    }
    deliveryNeverArriveSubcategory {
      _id
      name {
        locale: en
      }
      knowledgeForceIssueId
    }
    deliveryMissingItemsSubcategory {
      _id
      name {
        locale: en
      }
      knowledgeForceIssueId
    }
    orderingIssuesCategoryGroup {
      _id
    }
    supportDataFaqs {
      supportFaqTitle {
        locale: en
      }
      supportFaqContent {
        localeRaw: enRaw
      }
      supportFaqMParticleEvent
    }
  }
}
    `;

/**
 * __useGetSupportDataQuery__
 *
 * To run a query within a React component, call `useGetSupportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportDataQuery({
 *   variables: {
 *      supportDataId: // value for 'supportDataId'
 *   },
 * });
 */
export function useGetSupportDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetSupportDataQuery, IGetSupportDataQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetSupportDataQuery, IGetSupportDataQueryVariables>(GetSupportDataDocument, baseOptions);
      }
export function useGetSupportDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSupportDataQuery, IGetSupportDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetSupportDataQuery, IGetSupportDataQueryVariables>(GetSupportDataDocument, baseOptions);
        }
export type GetSupportDataQueryHookResult = ReturnType<typeof useGetSupportDataQuery>;
export type GetSupportDataLazyQueryHookResult = ReturnType<typeof useGetSupportDataLazyQuery>;
export type GetSupportDataQueryResult = ApolloReactCommon.QueryResult<IGetSupportDataQuery, IGetSupportDataQueryVariables>;
export const GetSupportSubcategoryDocument = gql`
    query GetSupportSubcategory($id: ID!) {
  SupportSubcategory(id: $id) {
    _id
    _type
    _createdAt
    _key
    _rev
    _updatedAt
    name {
      locale: en
    }
    knowledgeForceIssueId
    supportSubcategoryFaqs {
      supportFaqTitle {
        locale: en
      }
      supportFaqContent {
        localeRaw: enRaw
      }
      supportFaqMParticleEvent
    }
    directTicketProcessingPercentage
    supportSubcategoryFaq {
      supportFaqTitle {
        locale: en
      }
      supportFaqContent {
        localeRaw: enRaw
      }
      supportFaqMParticleEvent
    }
    supportSubcategoryForwardToOrders
    supportSubcategorySubmitToSutherland
  }
}
    `;

/**
 * __useGetSupportSubcategoryQuery__
 *
 * To run a query within a React component, call `useGetSupportSubcategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportSubcategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportSubcategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupportSubcategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>(GetSupportSubcategoryDocument, baseOptions);
      }
export function useGetSupportSubcategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>(GetSupportSubcategoryDocument, baseOptions);
        }
export type GetSupportSubcategoryQueryHookResult = ReturnType<typeof useGetSupportSubcategoryQuery>;
export type GetSupportSubcategoryLazyQueryHookResult = ReturnType<typeof useGetSupportSubcategoryLazyQuery>;
export type GetSupportSubcategoryQueryResult = ApolloReactCommon.QueryResult<IGetSupportSubcategoryQuery, IGetSupportSubcategoryQueryVariables>;
export const GetSupportCategoryGroupDocument = gql`
    query GetSupportCategoryGroup($id: ID!) {
  SupportCategoryGroup(id: $id) {
    _id
    name {
      locale: en
    }
    supportSubcategories {
      _id
      name {
        locale: en
      }
      knowledgeForceIssueId
      supportSubcategoryForwardToOrders
      supportSubcategoryFaqs {
        supportFaqTitle {
          locale: en
        }
        supportFaqContent {
          localeRaw: enRaw
        }
        supportFaqMParticleEvent
      }
    }
  }
}
    `;

/**
 * __useGetSupportCategoryGroupQuery__
 *
 * To run a query within a React component, call `useGetSupportCategoryGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportCategoryGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties 
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportCategoryGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupportCategoryGroupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>) {
        return ApolloReactHooks.useQuery<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>(GetSupportCategoryGroupDocument, baseOptions);
      }
export function useGetSupportCategoryGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>(GetSupportCategoryGroupDocument, baseOptions);
        }
export type GetSupportCategoryGroupQueryHookResult = ReturnType<typeof useGetSupportCategoryGroupQuery>;
export type GetSupportCategoryGroupLazyQueryHookResult = ReturnType<typeof useGetSupportCategoryGroupLazyQuery>;
export type GetSupportCategoryGroupQueryResult = ApolloReactCommon.QueryResult<IGetSupportCategoryGroupQuery, IGetSupportCategoryGroupQueryVariables>;
import { disableFragmentWarnings } from 'graphql-tag';
disableFragmentWarnings();
